webpackJsonp([0,2],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__("+prg");
	module.exports = __webpack_require__("lVK7");


/***/ },

/***/ "Y9PB":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Link = __webpack_require__("YgNV");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__("BCqG");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * AppNavigation component, render only
	 */
	// Import Link component
	var AppNavigation = (0, _mobxReact.inject)('MediahubStore', 'ViewStore')((0, _mobxReact.observer)(function (_ref) {
	  var MediahubStore = _ref.MediahubStore,
	      ViewStore = _ref.ViewStore;
	  return _react2.default.createElement(
	    'ul',
	    { className: _style2.default.nav },
	    _.startsWith(ViewStore.currentPath, '/de') && _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'h3',
	        null,
	        _react2.default.createElement(
	          _Link2.default,
	          {
	            to: 'overview',
	            className: ViewStore.isViewActive('overview') ? _style2.default.active : '' },
	          ViewStore.get('home')
	        )
	      )
	    ),
	    _.map(MediahubStore.channelsWithoutFeatured, function (c) {
	      return c.id !== MediahubStore.mostViewedId && _react2.default.createElement(ChannelMenuItem, {
	        key: c.id,
	        channel: c });
	    })
	  );
	}));
	// Import styles
	exports.default = AppNavigation;
	
	
	var ChannelMenuItem = (0, _mobxReact.inject)('MediahubStore', 'ViewStore')((0, _mobxReact.observer)(function (_ref2) {
	  var MediahubStore = _ref2.MediahubStore,
	      ViewStore = _ref2.ViewStore,
	      channel = _ref2.channel;
	  return _react2.default.createElement(
	    'li',
	    null,
	    _react2.default.createElement(
	      'h3',
	      null,
	      _react2.default.createElement(
	        _Link2.default,
	        {
	          to: 'channel',
	          channel: channel.link,
	          className: ViewStore.isViewActive('channel', channel.link) ? _style2.default.active : '' },
	        channel.title
	      )
	    )
	  );
	}));
	module.exports = exports['default'];

/***/ },

/***/ "BCqG":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"nav":"_2lmEf","active":"_1WE-6"};

/***/ },

/***/ "gqZD":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__("kcdz");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * AppTitle component, render only
	 */
	var AppTitle = (0, _mobxReact.inject)('ViewStore')((0, _mobxReact.observer)(function (_ref) {
	  var ViewStore = _ref.ViewStore;
	  return _react2.default.createElement(
	    'h1',
	    { className: _style2.default.title },
	    ViewStore.get('video')
	  );
	}));
	// Import styles
	exports.default = AppTitle;
	module.exports = exports['default'];

/***/ },

/***/ "kcdz":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"title":"NQ1xg"};

/***/ },

/***/ "2HDj":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Navigation = __webpack_require__("Y9PB");
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _style = __webpack_require__("NO8v");
	
	var _style2 = _interopRequireDefault(_style);
	
	var _Title = __webpack_require__("gqZD");
	
	var _Title2 = _interopRequireDefault(_Title);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * AppHeader component, render only
	 */
	
	// Import styles
	var AppHeader = (0, _mobxReact.inject)('ViewStore')((0, _mobxReact.observer)(function (_ref) {
	  var ViewStore = _ref.ViewStore;
	  return _react2.default.createElement(
	    'div',
	    { className: _style2.default.header },
	    _react2.default.createElement(_Navigation2.default, null)
	  );
	}));
	// Import children
	exports.default = AppHeader;
	module.exports = exports['default'];

/***/ },

/***/ "NO8v":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"header":"_2-rkA"};

/***/ },

/***/ "w5UO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("rbbs");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("RIz9");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("IKfj");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2;
	// Import styles
	
	
	var _mobx = __webpack_require__("d6px");
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__("VJcM");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	var FeaturedMediaContainer = (_dec = (0, _mobxReact.inject)('MediahubStore', 'ViewStore'), _dec(_class = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
	  (0, _inherits3.default)(FeaturedMediaContainer, _Component);
	
	  function FeaturedMediaContainer() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FeaturedMediaContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initDefineProp(_this, 'loaded', _descriptor, _this), _initDefineProp(_this, 'faded', _descriptor2, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  FeaturedMediaContainer.prototype.componentDidMount = function componentDidMount() {
	    this._fadeInImage();
	    this._fadeInContainer();
	  };
	
	  FeaturedMediaContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._fadeInImage();
	  };
	
	  FeaturedMediaContainer.prototype._fadeInImage = function _fadeInImage() {
	    var mc = this.props.mc;
	
	
	    if (mc.thumbnail) {
	      var img = new Image();
	      img.onload = this._onImageLoad.bind(this);
	      img.src = mc.thumbnail;
	    }
	  };
	
	  FeaturedMediaContainer.prototype._fadeInContainer = function _fadeInContainer() {
	    var _this2 = this;
	
	    _.delay((0, _mobx.action)(function () {
	      _this2.faded = true;
	    }), 60);
	  };
	
	  FeaturedMediaContainer.prototype._onImageLoad = function _onImageLoad() {
	    var _this3 = this;
	
	    _.delay(function () {
	      _this3._changeLoaded(true);
	    }, 500);
	  };
	
	  FeaturedMediaContainer.prototype._changeLoaded = function _changeLoaded(bool) {
	    this.loaded = bool;
	  };
	
	  FeaturedMediaContainer.prototype.navigateToMc = function navigateToMc(mc) {
	    var ViewStore = this.props.ViewStore;
	
	    var lang = ViewStore.language;
	    var directLink = _.split(mc.directLink, '/');
	    var channel = _.head(directLink);
	    var detail = _.last(directLink);
	
	    ViewStore.router.navigate('detail', {
	      lang: ViewStore.language,
	      channel: channel,
	      detail: detail
	    }, {});
	  };
	
	  FeaturedMediaContainer.prototype.render = function render() {
	    var _this4 = this;
	
	    var MediahubStore = this.props.MediahubStore;
	    var mc = this.props.mc;
	
	
	    if (!mc) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _style2.default.mediaContainer + ' row',
	        style: { opacity: this.opacity },
	        onClick: function onClick() {
	          return _this4.navigateToMc(mc);
	        }
	      },
	      _react2.default.createElement('div', { className: _style2.default.background_color }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: _style2.default.playerContainer + ' col-xs-8',
	          tabIndex: 0,
	          'aria-label': mc.title
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.player },
	          mc.player && _react2.default.createElement('iframe', {
	            src: mc.player,
	            scrolling: 'no',
	            frameBorder: '0',
	            allowFullScreen: true,
	            tabIndex: 0
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.infoContainer + ' col-xs-4' },
	        _react2.default.createElement(
	          'h2',
	          {
	            className: _style2.default.mcTitle },
	          mc.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _style2.default.mcInfo },
	          mc.created + ' | ' + mc.duration + ' '
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _style2.default.mcDescription },
	          _.truncate(mc.description, { length: 380, separator: ' ' })
	        )
	      )
	    );
	  };
	
	  (0, _createClass3.default)(FeaturedMediaContainer, [{
	    key: 'opacity',
	    get: function get() {
	      return this.faded ? 1 : 0;
	    }
	  }]);
	  return FeaturedMediaContainer;
	}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'loaded', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'faded', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _applyDecoratedDescriptor(_class2.prototype, 'opacity', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'opacity'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_changeLoaded', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_changeLoaded'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = FeaturedMediaContainer;
	module.exports = exports['default'];

/***/ },

/***/ "VJcM":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mediaContainer":"_375ce","background_color":"_1MoVp","inline":"_37yb_","infoContainer":"_2WllT","mcTitle":"TS4b6","mcInfo":"_3zXdY","mcDescription":"_15s7G","playerContainer":"_2WPC7","player":"_3FZZJ"};

/***/ },

/***/ "Xjae":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("RIz9");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("IKfj");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _dec2, _class3;
	// Import styles
	
	
	var _mobx = __webpack_require__("d6px");
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPrefixr = __webpack_require__("cAi5");
	
	var _reactPrefixr2 = _interopRequireDefault(_reactPrefixr);
	
	var _Link = __webpack_require__("YgNV");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _style = __webpack_require__("mhIA");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * InfiniteWall component
	 *
	 * It uses it's own store for state sync and various calculations.
	 */
	
	var InfiniteWall = (_dec = (0, _mobxReact.inject)('MediahubStore', 'ViewStore', 'WallStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	  (0, _inherits3.default)(InfiniteWall, _Component);
	
	  function InfiniteWall() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, InfiniteWall);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this._updateScroll = _.debounce(function () {
	      var WallStore = _this.props.WallStore;
	
	      WallStore.updateScroll();
	    }, 10), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  InfiniteWall.prototype.componentWillMount = function componentWillMount() {
	    var WallStore = this.props.WallStore;
	
	    // Track scrolling using requestAnimationFrame
	
	    this.untrackScroll = WallStore.updateScroll();
	
	    // Track window scroll event
	    // window.addEventListener('scroll', this._updateScroll.bind(this));
	    // Track window resize event
	    window.addEventListener('resize', this._updateDimensions.bind(this));
	  };
	
	  InfiniteWall.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        WallStore = _props.WallStore,
	        ViewStore = _props.ViewStore;
	    // Initialize Item Number
	
	    WallStore.updateItemsCount(this.props.itemsCount);
	    // Update Dimensions
	    this._updateDimensions();
	
	    (0, _mobx.autorun)(function () {
	      _this2._updateDimensions(ViewStore.parentTopOffset);
	    });
	  };
	
	  InfiniteWall.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var WallStore = this.props.WallStore;
	    // Update Items Count
	
	    WallStore.updateItemsCount(nextProps.itemsCount);
	  };
	
	  InfiniteWall.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.untrackScroll();
	
	    // Remove Listeners
	    // window.removeEventListener('scroll', this._updateScroll);
	    window.removeEventListener('resize', this._updateDimensions);
	  };
	
	  InfiniteWall.prototype._updateDimensions = function _updateDimensions() {
	    var WallStore = this.props.WallStore;
	
	    var wrapper = this._wrapper;
	    WallStore.updateDimensions(wrapper);
	  };
	
	  InfiniteWall.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        itemsCount = _props2.itemsCount,
	        items = _props2.items,
	        itemsRenderer = _props2.itemsRenderer,
	        WallStore = _props2.WallStore,
	        ViewStore = _props2.ViewStore;
	
	
	    var isEnglish = _.startsWith(ViewStore.currentPath, '/en');
	
	    var linkTo = isEnglish ? 'channel' : 'overview';
	    var channel = isEnglish ? 'english' : '';
	    var linkText = isEnglish ? ViewStore.get('showAll') : ViewStore.get('backToOverview');
	
	    return _react2.default.createElement(
	      'div',
	      { ref: function ref(_ref) {
	          return _this3._wrapper = _ref;
	        } },
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.container,
	          style: { height: WallStore.wrapperH }
	        },
	        !!WallStore.itemsCount && items.map(function (item, index) {
	          var mc = itemsCount > index ? items[index] : {};
	          return _react2.default.createElement(WallItem, {
	            key: 'item_' + index,
	            index: index,
	            mc: mc,
	            itemsRenderer: itemsRenderer });
	        }),
	        !!WallStore.itemsCount && _react2.default.createElement(
	          'div',
	          { className: _style2.default.button_wrapper },
	          _react2.default.createElement(
	            _Link2.default,
	            { to: linkTo, channel: channel },
	            linkText
	          )
	        )
	      )
	    );
	  };
	
	  return InfiniteWall;
	}(_react.Component)) || _class) || _class);
	var WallItem = (_dec2 = (0, _mobxReact.inject)('WallStore'), _dec2(_class3 = (0, _mobxReact.observer)(_class3 = function (_Component2) {
	  (0, _inherits3.default)(WallItem, _Component2);
	
	  function WallItem() {
	    (0, _classCallCheck3.default)(this, WallItem);
	    return (0, _possibleConstructorReturn3.default)(this, _Component2.apply(this, arguments));
	  }
	
	  WallItem.prototype.getItemStyle = function getItemStyle() {
	    var _props3 = this.props,
	        index = _props3.index,
	        WallStore = _props3.WallStore;
	
	    var item = WallStore.getPosition(index);
	
	    return (0, _reactPrefixr2.default)({
	      transform: 'translate3d(' + item.posX + 'px, ' + item.posY + 'px, 0)',
	      height: WallStore.itemH,
	      width: WallStore.itemW
	    });
	  };
	
	  WallItem.prototype.render = function render() {
	    var _props4 = this.props,
	        itemsRenderer = _props4.itemsRenderer,
	        mc = _props4.mc,
	        WallStore = _props4.WallStore;
	    var isMobile = WallStore.isMobile;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _style2.default.item
	        // style={this.getItemStyle()}
	      },
	      _react2.default.createElement(itemsRenderer, { mc: mc, isMobile: isMobile })
	    );
	  };
	
	  return WallItem;
	}(_react.Component)) || _class3) || _class3);
	exports.default = InfiniteWall;
	module.exports = exports['default'];

/***/ },

/***/ "mhIA":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_1A_ke","item":"_23PQb","button_wrapper":"KjoRJ"};

/***/ },

/***/ "YgNV":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Link component, render only
	 */
	var Link = (0, _mobxReact.inject)('ViewStore')((0, _mobxReact.observer)(function (_ref) {
	  var ViewStore = _ref.ViewStore,
	      children = _ref.children,
	      to = _ref.to,
	      page = _ref.page,
	      channel = _ref.channel,
	      detail = _ref.detail,
	      options = _ref.options,
	      className = _ref.className,
	      style = _ref.style;
	  return _react2.default.createElement(
	    'a',
	    {
	      href: '#',
	      className: className,
	      style: style,
	      onClick: function onClick(ev) {
	        // Prevent default behaviour
	        ev.preventDefault();
	
	        // Set fallbacks
	        to = to || 'start';
	
	        var params = {};
	        params.lang = ViewStore.language;
	
	        if (page) {
	          params.page = _.toLower(page);
	        }
	        if (channel) {
	          params.channel = channel;
	        }
	        if (detail) {
	          params.detail = detail;
	        }
	        // Navigate
	        ViewStore.router.navigate(to, params, options);
	      }
	    },
	    children
	  );
	}));
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },

/***/ "qurI":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("rbbs");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__("RIz9");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("IKfj");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _descriptor, _descriptor2;
	// Import styles
	
	
	var _mobx = __webpack_require__("d6px");
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__("ECpV");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	// Import Components
	
	var MediaContainer = (_dec = (0, _mobxReact.inject)('ViewStore'), _dec(_class = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
	  (0, _inherits3.default)(MediaContainer, _Component);
	
	  function MediaContainer() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MediaContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initDefineProp(_this, 'loaded', _descriptor, _this), _initDefineProp(_this, 'faded', _descriptor2, _this), _this.onKeyDown = function (event) {
	      // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
	      if (event.key === 'Enter') {
	        event.preventDefault();
	        event.stopPropagation();
	        _this.navigateToMc(_this.props.mc);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  MediaContainer.prototype.componentDidMount = function componentDidMount() {
	    this._fadeInImage();
	    this._fadeInContainer();
	  };
	
	  MediaContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._fadeInImage();
	  };
	
	  MediaContainer.prototype._fadeInImage = function _fadeInImage() {
	    var mc = this.props.mc;
	
	
	    if (mc.thumbnail) {
	      var img = new Image();
	      img.onload = this._onImageLoad.bind(this);
	      img.src = mc.thumbnail;
	    }
	  };
	
	  MediaContainer.prototype._fadeInContainer = function _fadeInContainer() {
	    var _this2 = this;
	
	    _.delay((0, _mobx.action)(function () {
	      _this2.faded = true;
	    }), 10);
	  };
	
	  MediaContainer.prototype._onImageLoad = function _onImageLoad() {
	    var _this3 = this;
	
	    _.delay(function () {
	      _this3._changeLoaded(true);
	    }, 500);
	  };
	
	  MediaContainer.prototype._changeLoaded = function _changeLoaded(bool) {
	    this.loaded = bool;
	  };
	
	  MediaContainer.prototype.navigateToMc = function navigateToMc(mc) {
	    var ViewStore = this.props.ViewStore;
	
	    var lang = ViewStore.language;
	    var directLink = _.split(mc.directLink, '/');
	    var channel = _.head(directLink);
	    var detail = _.last(directLink);
	
	    ViewStore.router.navigate('detail', {
	      lang: ViewStore.language,
	      channel: channel,
	      detail: detail
	    }, {});
	  };
	
	  MediaContainer.prototype.render = function render() {
	    var _this4 = this;
	
	    var _props = this.props,
	        mc = _props.mc,
	        isMobile = _props.isMobile,
	        inTeaser = _props.inTeaser,
	        ViewStore = _props.ViewStore;
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _style2.default.mediaContainer + (inTeaser ? ' ' + _style2.default.inTeaser : ''),
	        style: { opacity: this.opacity }
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          className: _style2.default.imageContainer,
	          onClick: function onClick() {
	            return _this4.navigateToMc(mc);
	          },
	          onKeyDown: this.onKeyDown,
	          tabIndex: 0,
	          'aria-label': mc.title
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _style2.default.playIconWrap },
	          _react2.default.createElement(
	            'svg',
	            { x: '0px', y: '0px', viewBox: '-197 320.9 200 200' },
	            _react2.default.createElement('circle', { cx: '-92.5', cy: '423.3', r: '75.5' }),
	            _react2.default.createElement('path', {
	              d: 'M-101.9,464.4c-2.4,0-4.8-0.9-6.7-2.7c-3.9-3.7-4-9.9-0.3-13.8l21.8-22.9l-21.7-22.7c-3.7-3.9-3.6-10,0.3-13.8c3.9-3.7,10-3.6,13.8,0.3l28.2,29.4c3.6,3.8,3.6,9.7,0,13.4l-28.2,29.6C-96.7,463.4-99.3,464.4-101.9,464.4L-101.9,464.4zM-101.9,464.4' })
	          )
	        ),
	        _react2.default.createElement('img', {
	          className: this.loaded ? _style2.default.imageLoaded : _style2.default.image,
	          src: mc.thumbnail,
	          alt: mc.title })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.infoContainer },
	        _react2.default.createElement(
	          'h4',
	          {
	            className: _style2.default.mcTitle },
	          mc.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: _style2.default.mcInfo },
	          mc.created + ' | ' + mc.duration + ' '
	        ),
	        _react2.default.createElement(
	          'button',
	          {
	            className: _style2.default.mcLink,
	            onKeyDown: this.onKeyDown,
	            onClick: function onClick() {
	              return _this4.navigateToMc(mc);
	            }
	          },
	          _react2.default.createElement(
	            'svg',
	            { xmlns: 'http://www.w3.org/2000/svg', width: '16', height: '16', fill: 'currentColor', className: 'bi bi-arrow-right', viewBox: '0 0 16 16' },
	            _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _style2.default.mcLinkInner },
	            ViewStore.get('watchVideo')
	          )
	        )
	      )
	    );
	  };
	
	  (0, _createClass3.default)(MediaContainer, [{
	    key: 'opacity',
	    get: function get() {
	      return this.faded ? 1 : 0;
	    }
	  }]);
	  return MediaContainer;
	}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'loaded', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, 'faded', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _applyDecoratedDescriptor(_class2.prototype, 'opacity', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'opacity'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, '_changeLoaded', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_changeLoaded'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = MediaContainer;
	module.exports = exports['default'];

/***/ },

/***/ "ECpV":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mediaContainer":"u6QPN","inTeaser":"_2kMEM","imageContainer":"_1RZas","mcTitle":"_3JZ24","mediaContainerMobile":"_1JkXF u6QPN","mcInfo":"_1bQaE","infoContainer":"_1_seQ","mcLink":"iPKdf","mcLinkInner":"_29nTd","bi-arrow-right":"ZyHR2","imageLoaded":"vKS1L _3_A3j","playIconWrap":"LySHF","image":"_3_A3j"};

/***/ },

/***/ "NlOW":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Link = __webpack_require__("YgNV");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _MediaContainer = __webpack_require__("qurI");
	
	var _MediaContainer2 = _interopRequireDefault(_MediaContainer);
	
	var _config = __webpack_require__("QmSG");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	var _style = __webpack_require__("wDJL");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Teaser = (0, _mobxReact.inject)('MediahubStore', 'ViewStore')((0, _mobxReact.observer)(function (_ref) {
	  var MediahubStore = _ref.MediahubStore,
	      ViewStore = _ref.ViewStore,
	      channelTitle = _ref.channelTitle,
	      channelLink = _ref.channelLink,
	      channelSize = _ref.channelSize,
	      items = _ref.items,
	      index = _ref.index,
	      fromDetail = _ref.fromDetail;
	
	  var isEnglish = _.startsWith(ViewStore.currentPath, '/en');
	  var linkTo = 'channel';
	  if (fromDetail) {
	    linkTo = isEnglish ? 'channel' : '';
	  }
	
	  return _react2.default.createElement(
	    'section',
	    { className: ViewStore.isMobile ? _style2.default.teaserMobile + ' row' : _style2.default.teaser + ' row ' + (index === 1 && _style2.default.highlighted) },
	    index === 1 ? _react2.default.createElement('div', { className: _style2.default.background_color }) : null,
	    _react2.default.createElement(
	      _reactBootstrap.Col,
	      {
	        xs: 12
	      },
	      _react2.default.createElement(
	        'header',
	        { className: _style2.default.header + ' clearfix' },
	        _react2.default.createElement(
	          'h1',
	          {
	            className: 'col-xs-9'
	          },
	          channelTitle
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          'aria-label': channelTitle,
	          'aria-describedby': channelTitle,
	          className: _style2.default.content,
	          role: 'section'
	        },
	        _react2.default.createElement(
	          'ul',
	          {
	            className: 'row'
	          },
	          items.slice(0, 3).map(function (mc) {
	            return _react2.default.createElement(
	              'li',
	              {
	                key: mc.id + '-' + mc.channelId,
	                className: ViewStore.isMobile ? 'col-xs-12' : 'col-xs-6 col-sm-4' },
	              _react2.default.createElement(_MediaContainer2.default, {
	                mc: mc,
	                inTeaser: true,
	                isMobile: ViewStore.isMobile })
	            );
	          })
	        )
	      ),
	      !!channelLink ? _react2.default.createElement(
	        'div',
	        { className: fromDetail ? _style2.default.button_wrapper_left : _style2.default.button_wrapper },
	        _react2.default.createElement(
	          _Link2.default,
	          { to: linkTo,
	            channel: channelLink
	            // className='col-xs-3'
	          },
	          fromDetail ? ViewStore.get('backToOverview') : ViewStore.get('showMore')
	        )
	      ) : null
	    )
	  );
	}));
	// Import styles
	
	// Import config
	// Import Link component
	exports.default = Teaser;
	module.exports = exports['default'];

/***/ },

/***/ "wDJL":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"imageContainer":"_1-2Dz","teaser":"_3zVdl","highlighted":"_3BaRV","background_color":"GufRb","header":"_3ZhO3","button_wrapper":"_2omq3","button_wrapper_left":"_1jQeX","teaserMobile":"_37uDK _3zVdl","content":"_1b0vr"};

/***/ },

/***/ "QmSG":
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var sortOptions = ['publishedDate', 'createdAt'];
	
	var validLanguages = ['de', 'en', 'pl', 'fr'];
	var autoRefreshTime = 86400;
	var featuredChannelIdDev = 781; // ID of the featured channel on DEV
	// const featuredChannelIdDev  = 803; // ID of the featured channel on DEV
	var featuredChannelId = 171; // ID of the featured channel on LIVE
	var mostViewedChannelIdDev = 959; // ID of the featured channel on DEV
	var mostViewedChannelId = 259; // ID of the featured channel on LIVE
	var channelPreviewCount = 4; // Number of mediaContainers for channel preview
	var mobileWidth = 480;
	
	var portholeProxy = '//tc-mh-3796-dev.admiralcloud.com/porthole/proxy.html';
	var includeAuthToken = false; // Set this to true if mediahub should use auth token
	
	/* >>> DEV <<< Toll Collect MediaHub */
	// const mediahubIdDev = 'dbQpUpYerjTd7';
	/* >>> DEV <<< Toll Collect MediaHub */
	//const mediahubIdDev = 'i7YwhFALZSeY0';
	var mediahubIdDev = 'dQSzY8CWrMPUyQUbXhFnNA';
	
	/* >>> CUSTOMER DEV <<< Toll Collect MediaHub */
	// const mediahubId = 'hmqBPsFokirY5';
	var mediahubId = 'dQSzY8CWrMPUyQUbXhFnNA';
	
	exports.default = {
	  sortOptions: sortOptions,
	  autoRefreshTime: autoRefreshTime,
	  featuredChannelIdDev: featuredChannelIdDev,
	  featuredChannelId: featuredChannelId,
	  mostViewedChannelIdDev: mostViewedChannelIdDev,
	  mostViewedChannelId: mostViewedChannelId,
	  channelPreviewCount: channelPreviewCount,
	  mediahubIdDev: mediahubIdDev,
	  mediahubId: mediahubId,
	  mobileWidth: mobileWidth,
	  portholeProxy: portholeProxy,
	  includeAuthToken: includeAuthToken,
	  validLanguages: validLanguages
	};
	module.exports = exports['default'];

/***/ },

/***/ "c/WX":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("RIz9");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("IKfj");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class; // Import layout components
	
	// Import route handlers
	
	
	var _AppHeader = __webpack_require__("2HDj");
	
	var _AppHeader2 = _interopRequireDefault(_AppHeader);
	
	var _Channel = __webpack_require__("bT5C");
	
	var _Channel2 = _interopRequireDefault(_Channel);
	
	var _Detail = __webpack_require__("4Lzn");
	
	var _Detail2 = _interopRequireDefault(_Detail);
	
	var _Overview = __webpack_require__("WYsz");
	
	var _Overview2 = _interopRequireDefault(_Overview);
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * App component
	 */
	var App = (_dec = (0, _mobxReact.inject)('MediahubStore', 'ViewStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	  (0, _inherits3.default)(App, _Component);
	
	  function App() {
	    (0, _classCallCheck3.default)(this, App);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Rendering views based on currentView
	   */
	  App.prototype.renderCurrentView = function renderCurrentView() {
	    switch (this.props.ViewStore.currentViewName) {
	      case 'overview':
	        return _react2.default.createElement(_Overview2.default, null);
	      case 'channel':
	        return _react2.default.createElement(_Channel2.default, null);
	      case 'detail':
	        return _react2.default.createElement(_Detail2.default, null);
	      default:
	        return _react2.default.createElement(
	          'h1',
	          null,
	          '404 - Not found'
	        );
	    }
	  };
	
	  App.prototype.render = function render() {
	    var _this2 = this;
	
	    return _react2.default.createElement(
	      'section',
	      { ref: function ref(_ref) {
	          return _this2._container = _ref;
	        } },
	      _react2.default.createElement(
	        _reactBootstrap.Grid,
	        { fluid: true, className: 'appContainer' },
	        !_.isEqual(this.props.ViewStore.currentViewName, 'detail') ? _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            _react2.default.createElement(_AppHeader2.default, null)
	          )
	        ) : null,
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12 },
	            this.renderCurrentView()
	          )
	        )
	      )
	    );
	  };
	
	  return App;
	}(_react.Component)) || _class) || _class);
	exports.default = App;
	module.exports = exports['default'];

/***/ },

/***/ "Yiez":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IE9 = function IE9() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    '"Your browser is not supported. Please update your browser or use a different one."'
	  );
	};
	
	exports.default = IE9;
	module.exports = exports['default'];

/***/ },

/***/ "FFCO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("RIz9");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("IKfj");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _class;
	// Import styles
	
	// Import App
	
	
	__webpack_require__("qb6w");
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _mobxReactDevtools = __webpack_require__("FHUK");
	
	var _mobxReactDevtools2 = _interopRequireDefault(_mobxReactDevtools);
	
	__webpack_require__("uMhA");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__("GKcl");
	
	var _App = __webpack_require__("c/WX");
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  AppContainer index component for:
	 *  - Importing global CSS styles
	 *  - Injecting Mobx Store Provider
	 *  - Injecting Mobx DevTools
	 *  - Injecting DragDropContext
	 *  - Importing App component
	 *
	 *  NOTE: hot reloading is not working for this component
	 *  App component is the one managing routes
	 *
	 *  DO NOT CHANGE UNLESS NECESSARY!!!
	 */
	var AppContainer = (0, _mobxReact.observer)(_class = function (_Component) {
	  (0, _inherits3.default)(AppContainer, _Component);
	
	  function AppContainer() {
	    (0, _classCallCheck3.default)(this, AppContainer);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  AppContainer.prototype.render = function render() {
	    return _react2.default.createElement(
	      _mobxReact.Provider,
	      this.props.stores,
	      _react2.default.createElement(
	        'div',
	        null,
	        this.props.stores.MediahubStore.isDev ? _react2.default.createElement(_mobxReactDevtools2.default, { position: { bottom: 0, left: 20 } }) : null,
	        _react2.default.createElement(_App2.default, null)
	      )
	    );
	  };
	
	  return AppContainer;
	}(_react.Component)) || _class;
	
	exports.default = AppContainer;
	module.exports = exports['default'];

/***/ },

/***/ "bT5C":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("RIz9");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("IKfj");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class; // Import Components
	
	// Import styles
	
	
	var _InfiniteWall = __webpack_require__("Xjae");
	
	var _InfiniteWall2 = _interopRequireDefault(_InfiniteWall);
	
	var _MediaContainer = __webpack_require__("qurI");
	
	var _MediaContainer2 = _interopRequireDefault(_MediaContainer);
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _style = __webpack_require__("LH19");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Channel component
	 */
	var Channel = (_dec = (0, _mobxReact.inject)('MediahubStore', 'ViewStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	  (0, _inherits3.default)(Channel, _Component);
	
	  function Channel() {
	    (0, _classCallCheck3.default)(this, Channel);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  Channel.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        MediahubStore = _props.MediahubStore,
	        ViewStore = _props.ViewStore;
	
	
	    return _react2.default.createElement(
	      'div',
	      { ref: function ref(_ref) {
	          return _this2._container = _ref;
	        }, className: _style2.default.container },
	      _react2.default.createElement(_InfiniteWall2.default, {
	        items: MediahubStore.mediaContainers,
	        itemsCount: _.size(MediahubStore.mediaContainers),
	        itemsRenderer: _MediaContainer2.default })
	    );
	  };
	
	  return Channel;
	}(_react.Component)) || _class) || _class);
	exports.default = Channel;
	module.exports = exports['default'];

/***/ },

/***/ "LH19":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"wverN"};

/***/ },

/***/ "4Lzn":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("RIz9");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("IKfj");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class, _desc, _value, _class2, _descriptor;
	// Import Components
	
	// Import styles
	
	// var Shariff = require('shariff');
	
	/*
	*
	* Shariff is being used locally (not NPM) in order to work on IE11, files are on /detail/shariff, CSS inside style.css and @fontface inside /styles/_variables.scss
	*
	*/
	
	var _Link = __webpack_require__("YgNV");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Teaser = __webpack_require__("NlOW");
	
	var _Teaser2 = _interopRequireDefault(_Teaser);
	
	var _mobx = __webpack_require__("d6px");
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	var _style = __webpack_require__("L/1q");
	
	var _style2 = _interopRequireDefault(_style);
	
	var _shariff = __webpack_require__("KqFD");
	
	var _shariff2 = _interopRequireDefault(_shariff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	/**
	 * Detail component
	 */
	var Detail = (_dec = (0, _mobxReact.inject)('MediahubStore', 'ViewStore'), _dec(_class = (0, _mobxReact.observer)(_class = (_class2 = function (_Component) {
	  (0, _inherits3.default)(Detail, _Component);
	
	  function Detail() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Detail);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initDefineProp(_this, 'loaded', _descriptor, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  Detail.prototype.componentDidMount = function componentDidMount() {
	    this._fadeInImage();
	  };
	
	  Detail.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    var url = !!document.referrer ? document.referrer : window.location.href;
	
	    var shariff = new _shariff2.default(this._buttons, {
	      services: ['facebook', 'twitter', 'xing', 'linkedin', 'mail', 'whatsapp'],
	      mailUrl: 'mailto:',
	      mailSubject: 'Toll Collect Video',
	      theme: 'round',
	      buttonStyle: 'icon',
	      orientation: 'horizontal',
	      url: url
	    });
	
	    this._fadeInImage();
	  };
	
	  Detail.prototype._fadeInImage = function _fadeInImage() {
	    var MediahubStore = this.props.MediahubStore;
	
	    var mc = MediahubStore.currentContainer;
	
	    if (mc.previewImage) {
	      var img = new Image();
	      img.onload = this._onImageLoad.bind(this);
	      img.src = mc.previewImage;
	    } else {
	      this._changeLoaded(false);
	    }
	  };
	
	  Detail.prototype._onImageLoad = function _onImageLoad() {
	    var _this2 = this;
	
	    _.delay(function () {
	      _this2._changeLoaded(true);
	    }, 500);
	  };
	
	  Detail.prototype._changeLoaded = function _changeLoaded(bool) {
	    this.loaded = bool;
	  };
	
	  Detail.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        MediahubStore = _props.MediahubStore,
	        ViewStore = _props.ViewStore;
	
	    var mc = MediahubStore.currentContainer;
	
	    if (_.isEmpty(mc)) {
	      return null;
	    }
	
	    var isEnglish = _.startsWith(ViewStore.currentPath, '/en');
	
	    var linkTo = isEnglish ? 'channel' : 'overview';
	    var channel = isEnglish ? 'english' : '';
	    var linkText = isEnglish ? ViewStore.get('showAll') : ViewStore.get('backToOverview');
	
	    return _react2.default.createElement(
	      'div',
	      { className: _style2.default.detailContainer },
	      _react2.default.createElement(
	        'div',
	        { className: _style2.default.detail_wrapper },
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, sm: 12 },
	            _react2.default.createElement(
	              'h1',
	              {
	                // tabIndex={0}
	                className: _style2.default.mcTitle },
	              mc.title
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: _style2.default.previewContainer,
	            'aria-label': mc.title,
	            title: mc.title,
	            tabIndex: 0
	          },
	          _.isEqual(mc.type, 'video') && mc.player && _react2.default.createElement('iframe', {
	            className: _style2.default.iframe,
	            src: mc.player,
	            scrolling: 'no',
	            frameBorder: '0',
	            allowFullScreen: true,
	            'aria-label': mc.title,
	            title: mc.title,
	            tabIndex: 0
	          }),
	          _.isEqual(mc.type, 'image') && _react2.default.createElement('img', {
	            className: this.loaded ? _style2.default.imageLoaded : _style2.default.previewImage,
	            src: mc.previewImage,
	            alt: mc.title })
	        ),
	        _react2.default.createElement(
	          _reactBootstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, sm: 12, className: _style2.default.infoContainer },
	            _react2.default.createElement(
	              'p',
	              { className: _style2.default.mcDescription },
	              mc.description
	            )
	          ),
	          _react2.default.createElement(
	            _reactBootstrap.Col,
	            { xs: 12, sm: 12, className: _style2.default.social },
	            _react2.default.createElement(
	              'div',
	              { className: _style2.default.social_text },
	              ViewStore.get('sharePost')
	            ),
	            _react2.default.createElement('div', {
	              ref: function ref(_ref) {
	                return _this3._buttons = _ref;
	              },
	              id: 'socialButtons',
	              className: 'shariff'
	            })
	          )
	        )
	      ),
	      !_.isEqual(mc.channelId, MediahubStore.featuredId) && _react2.default.createElement(DetailChannelTeaser, null),
	      !isEnglish && _react2.default.createElement(MostViewedTeaser, null)
	    );
	  };
	
	  return Detail;
	}(_react.Component), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'loaded', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _applyDecoratedDescriptor(_class2.prototype, '_changeLoaded', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, '_changeLoaded'), _class2.prototype)), _class2)) || _class) || _class);
	exports.default = Detail;
	
	
	var DetailChannelTeaser = (0, _mobxReact.inject)('MediahubStore', 'ViewStore')((0, _mobxReact.observer)(function (_ref2) {
	  var MediahubStore = _ref2.MediahubStore,
	      ViewStore = _ref2.ViewStore;
	
	  var isEnglish = _.startsWith(ViewStore.currentPath, '/en');
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _.map(_.filter(MediahubStore.channels, function (c, index) {
	      return c.id === MediahubStore.currentChannelId;
	    }), function (c, index) {
	      return _react2.default.createElement(_Teaser2.default, {
	        key: 'channel_' + index,
	        channelTitle: _.startsWith(ViewStore.currentPath, '/en') ? ViewStore.get('moreVideos') : ViewStore.get('additionalMediaContainer') + ' ' + c.title,
	        channelLink: c.link
	        // channelLink={isEnglish
	        //   ? 'english'
	        //   : '/'}
	        , channelSize: c.channelSize,
	        items: c.teasers,
	        fromDetail: true
	      });
	    })
	  );
	}));
	
	var MostViewedTeaser = (0, _mobxReact.inject)('MediahubStore')((0, _mobxReact.observer)(function (_ref3) {
	  var MediahubStore = _ref3.MediahubStore;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _.map(_.filter(MediahubStore.specialChannels, function (c) {
	      return c.sortOption === 'countEmbeds';
	    }), function (c, index) {
	      return _react2.default.createElement(_Teaser2.default, {
	        key: 'channel_' + index,
	        channelTitle: c.title,
	        items: c.teasers
	      });
	    })
	  );
	}));
	module.exports = exports['default'];

/***/ },

/***/ "yo7H":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	// https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
	
	var _assign = __webpack_require__("df5H");
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (typeof _assign2.default !== 'function') {
	  // jshint maxdepth:4
	  Object.assign = function (target, varArgs) {
	    // .length of function is 2
	    if (target === null) {
	      // TypeError if undefined or null
	      throw new TypeError('Cannot convert undefined or null to object');
	    }
	
	    var to = Object(target);
	
	    for (var index = 1; index < arguments.length; index++) {
	      var nextSource = arguments[index];
	
	      if (nextSource !== null) {
	        // Skip over if undefined or null
	        for (var nextKey in nextSource) {
	          // Avoid bugs when hasOwnProperty is shadowed
	          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	    }
	    return to;
	  };
	}
	
	/**
	 * Initialization helper. This method is this module's exported entry point.
	 * @param {string|Array|Element} selector - css selector, one element, array of nodes or html fragment
	 * @param {node} [context=document] - context node in which to query
	 * @returns {DOMQuery} A DOMQuery instance containing the selected set of nodes
	 */
	function dq(selector, context) {
	  var nodes = [];
	  context = context || document;
	  if (typeof selector === 'function') {
	    if (context.attachEvent ? context.readyState === 'complete' : context.readyState !== 'loading') {
	      selector();
	    } else {
	      context.addEventListener('DOMContentLoaded', selector);
	    }
	  } else if (selector instanceof Element) {
	    nodes = [selector];
	  } else if (typeof selector === 'string') {
	    if (selector[0] === '<') {
	      nodes = Array.prototype.slice.call(fragment(selector));
	    } else {
	      nodes = Array.prototype.slice.call(context.querySelectorAll(selector));
	    }
	  } else {
	    nodes = selector;
	  }
	  return new DOMQuery(nodes, context);
	}
	
	/**
	 * Contains a set of DOM nodes and provides methods to manipulate the nodes.
	 * @constructor
	 */
	function DOMQuery(elements, context) {
	  this.length = elements.length;
	  this.context = context;
	  var self = this;
	  each(elements, function (i) {
	    self[i] = this;
	  });
	}
	
	/**
	 * Iterates through each node and calls the callback in its context.
	 * @param {eachArrayCallback} callback - A function to be called with a node
	 * @returns {DOMQuery}
	 */
	DOMQuery.prototype.each = function (callback) {
	  for (var i = this.length - 1; i >= 0; i--) {
	    callback.call(this[i], i, this[i]);
	  }
	  return this;
	};
	
	/**
	 * Empties each node.
	 * @returns {DOMQuery}
	 */
	DOMQuery.prototype.empty = function () {
	  return this.each(empty);
	};
	
	/**
	 * Sets the text content of each node. Returns the text content of the first node.
	 * @param {string} [text] - The text content to set
	 * @returns {DOMQuery|string}
	 */
	DOMQuery.prototype.text = function (text) {
	  if (text === undefined) {
	    return this[0].textContent;
	  }
	  return this.each(function () {
	    this.textContent = text;
	  });
	};
	
	/**
	 * Sets an attribute on each node. Returns the attribute's value of the first node.
	 * @param {string} [name] - The attribute's name
	 * @param {string} [value] - The value to set
	 * @returns {DOMQuery|string}
	 */
	DOMQuery.prototype.attr = function (name, value) {
	  if (this.length < 1) {
	    return null;
	  }
	  if (value === undefined) {
	    return this[0].getAttribute(name);
	  }
	  return this.each(function () {
	    this.setAttribute(name, value);
	  });
	};
	
	/**
	 * Sets a data attribute on each node. Returns the data attribute's value of the first node.
	 * Supports deserialization of complex data types as values.
	 * @param {string} [key] - The attribute's name
	 * @param {string} [value] - The value to set
	 * @returns {DOMQuery|string|Object}
	 */
	DOMQuery.prototype.data = function (key, value) {
	  if (value) {
	    return this.attr('data-' + key, value);
	  }
	  if (key) {
	    return this.attr('data-' + key);
	  }
	  var data = (0, _assign2.default)({}, this[0].dataset);
	  each(data, function (k, v) {
	    data[k] = deserializeValue(v);
	  });
	  return data;
	};
	
	/**
	 * Returns a new DOMQuery instance containing all matched nodes in the context
	 * of the set of nodes.
	 * @param {string} selector - The CSS selector
	 * @returns {DOMQuery}
	 */
	DOMQuery.prototype.find = function (selector) {
	  var matches;
	  // querySelectorAll in the context of each element in the set
	  matches = map(this, function (el) {
	    return el.querySelectorAll(selector);
	  });
	  // convert NodeList matches into Array
	  matches = map(matches, function (el) {
	    return Array.prototype.slice.call(el);
	  });
	  // flatten the array
	  matches = Array.prototype.concat.apply([], matches);
	  return new DOMQuery(matches);
	};
	
	/**
	 * Appends nodes to the end of the first node in the set.
	 * @param {string|Array} html - Nodes to append. May be a string containing HTML.
	 * @returns {DOMQuery}
	 */
	DOMQuery.prototype.append = function (html) {
	  if (typeof html === 'string') {
	    html = fragment(html);
	  }
	  append(this[0], html);
	  return this;
	};
	
	/**
	 * Prepends nodes at the top of the first node in the set.
	 * @param {string|Array} html - Nodes to append. May be a string containing HTML.
	 * @returns {DOMQuery}
	 */
	DOMQuery.prototype.prepend = function (html) {
	  if (typeof html === 'string') {
	    html = fragment(html);
	  }
	  prepend(this[0], html);
	  return this;
	};
	
	/**
	 * Adds a CSS class name to the nodes in the set.
	 * @param {string} name - Class name to add
	 * @returns {DOMQuery}
	 */
	DOMQuery.prototype.addClass = function (names) {
	  return this.each(function () {
	    var _this = this;
	
	    // Workaround: IE only supports a single parameter to classList.add()
	    names.split(' ').forEach(function (className) {
	      _this.classList.add(className);
	    });
	  });
	};
	
	/**
	 * Removes a CSS class name from the nodes in the set.
	 * @param {string} name - Class name to remove
	 * @returns {DOMQuery}
	 */
	DOMQuery.prototype.removeClass = function (name) {
	  return this.each(function () {
	    this.classList.remove(name);
	  });
	};
	
	/**
	 * Delegates an event for a node matching a selector to each element in the set.
	 * @param {string} event - The event name
	 * @param {string} selector - The CSS selector
	 * @param {eventHandler} handler - The event handler function
	 * @returns {DOMQuery}
	 */
	DOMQuery.prototype.on = function (event, selector, handler) {
	  return this.each(function () {
	    delegateEvent(selector, event, handler, this);
	  });
	};
	
	/**
	 * Removes each child of a node.
	 * @private
	 */
	var empty = function empty() {
	  while (this.hasChildNodes()) {
	    this.removeChild(this.firstChild);
	  }
	};
	
	/**
	 * Callback function used for map(array, callback).
	 *
	 * @callback mapCallback
	 * @param {Object} object - An element of the array
	 * @return {Array}
	 * @see map
	 */
	
	/**
	 * Runs a callback with each element in an array and returns a new array.
	 * @param {Array} objects - The array to iterate
	 * @param {function} callback - The callback function
	 * @returns {Array}
	 */
	var map = function map(objects, callback) {
	  return Array.prototype.map.call(objects, callback);
	};
	
	/**
	 * Callback function used for each(array, callback).
	 * Called in the context of each element in the array.
	 *
	 * @callback eachArrayCallback
	 * @param {number} index - Index of the current array element
	 * @param {object} value - Element of the array
	 * @return {Array}
	 * @see each
	 */
	
	/**
	 * Callback function used for each(object, callback).
	 * Called in the context of each object property value.
	 *
	 * @callback eachObjectCallback
	 * @param {Object} key - The object's property key
	 * @param {object} value - The object's property value
	 * @return {Array}
	 * @see each
	 */
	
	/**
	 * Runs a callback with each element in an array or key-value pair of an object.
	 * Returns the original object/array.
	 * @param {Object} object - The object to itrate
	 * @param {eachArrayCallback|eachObjectCallback} callback - The callback function
	 * @returns {Array}
	 */
	var each = function each(object, callback) {
	  if (object instanceof Array) {
	    for (var i = 0; i < object.length; i++) {
	      callback.call(object[i], i, object[i]);
	    }
	  } else if (object instanceof Object) {
	    for (var prop in object) {
	      callback.call(object[prop], prop, object[prop], object);
	    }
	  }
	  return object;
	};
	
	/**
	 * Constructs HTML nodes from a string of HTML.
	 * @param {string} html - String of HTML code
	 * @returns {Array}
	 * @private
	 */
	var fragment = function fragment(html) {
	  var div = document.createElement('div');
	  div.innerHTML = html;
	  return div.children;
	};
	
	/**
	 * Appends an array of nodes to the end of an HTML element.
	 * @param {Element} parent - Element to append to
	 * @param {Array} nodes - Collection of nodes to append
	 * @private
	 */
	var append = function append(parent, nodes) {
	  for (var i = 0; i < nodes.length; i++) {
	    parent.appendChild(nodes[i]);
	  }
	};
	
	/**
	 * Prepends an array of nodes to the top of an HTML element.
	 * @param {Element} parent - Element to prepend to
	 * @param {Array} nodes - Collection of nodes to prepend
	 * @private
	 */
	var prepend = function prepend(parent, nodes) {
	  for (var i = nodes.length - 1; i >= 0; i--) {
	    parent.insertBefore(nodes[nodes.length - 1], parent.firstChild);
	  }
	};
	
	/**
	 * Returns the closest parent of a node matching a CSS selector.
	 * @param {HTMLElement} element - Element to append to
	 * @param {string} selector - CSS selector
	 * @param {HTMLElement}
	 * @private
	 * @see {@link https://gist.github.com/Daniel-Hug/abbded91dd55466e590b}
	 */
	var closest = function () {
	  var element = HTMLElement.prototype;
	  var matches = element.matches || element.webkitMatchesSelector || element.mozMatchesSelector || element.msMatchesSelector;
	
	  return function closest(element, selector) {
	    if (element === null) return;
	    return matches.call(element, selector) ? element : closest(element.parentElement, selector);
	  };
	}();
	
	/**
	 * An event handler.
	 *
	 * @callback eventHandler
	 * @param {Event} event - The event this handler was triggered for
	 */
	
	/**
	 * Delegates an event for a node matching a selector.
	 * @param {string} selector - The CSS selector
	 * @param {string} event - The event name
	 * @param {eventHandler} handler - The event handler function
	 * @param {HTMLElement} [scope=document] - Element to add the event listener to
	 * @private
	 */
	var delegateEvent = function delegateEvent(selector, event, handler, scope) {
	  (scope || document).addEventListener(event, function (event) {
	    var listeningTarget = closest(event.target, selector);
	    if (listeningTarget) {
	      handler.call(listeningTarget, event);
	    }
	  });
	};
	
	/**
	 * Extends properties of all arguments into a single object.
	 * @param {...Object} objects - Objects to merge
	 * @param {string} event - The event name
	 * @param {function} handler - The event handler function
	 * @returns {Object}
	 * @see {@link https://gomakethings.com/vanilla-javascript-version-of-jquery-extend/}
	 */
	var extend = function extend(objects) {
	  // Variables
	  var extended = {};
	  var deep = false;
	  var i = 0;
	  var length = arguments.length;
	
	  // Check if a deep merge
	  if (Object.prototype.toString.call(arguments[0]) === '[object Boolean]') {
	    deep = arguments[0];
	    i++;
	  }
	
	  // Merge the object into the extended object
	  var merge = function merge(obj) {
	    for (var prop in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
	        // If deep merge and property is an object, merge properties
	        if (deep && Object.prototype.toString.call(obj[prop]) === '[object Object]') {
	          extended[prop] = extend(true, extended[prop], obj[prop]);
	        } else {
	          extended[prop] = obj[prop];
	        }
	      }
	    }
	  };
	
	  // Loop through each object and conduct a merge
	  for (; i < length; i++) {
	    var obj = arguments[i];
	    merge(obj);
	  }
	
	  return extended;
	};
	
	/**
	 * The callback function for getJSON().
	 *
	 * @callback xhrCallback
	 * @param {boolean} success - True on success. False on error.
	 * @param {Object} data - The parsed data. null if success == false
	 * @param {XMLHttpRequest} xhr - The request object
	 * @see getJSON
	 */
	
	/**
	 * Runs an Ajax request against a url and calls the callback function with
	 * the parsed JSON result.
	 * @param {string} url - The url to request
	 * @param {xhrCallback} callback - The callback function
	 * @returns {XMLHttpRequest}
	 */
	var getJSON = function getJSON(url, callback) {
	  var xhr = new XMLHttpRequest();
	  xhr.open('GET', url, true);
	  xhr.setRequestHeader('Content-Type', 'application/json');
	  xhr.setRequestHeader('Accept', 'application/json');
	
	  xhr.onload = function () {
	    if (xhr.status >= 200 && xhr.status < 400) {
	      var data = JSON.parse(xhr.responseText);
	      callback(data, xhr.status, xhr);
	    } else {
	      callback(null, xhr.status, xhr);
	    }
	  };
	
	  xhr.onerror = function (e) {
	    callback(new Error(e), null, xhr);
	  };
	
	  xhr.send();
	};
	
	/**
	 * Deserializes JSON values from strings. Used with data attributes.
	 * @param {string} value - String to parse
	 * @returns {Object}
	 * @private
	 */
	var deserializeValue = function deserializeValue(value) {
	  /* jshint maxcomplexity:7 */
	  // boolean
	  if (value === 'true') {
	    return true;
	  }
	  if (value === 'false') {
	    return false;
	  }
	  // null
	  if (value === 'null') {
	    return null;
	  }
	  // number
	  if (+value + '' === value) {
	    return +value;
	  }
	  // json
	  if (/^[[{]/.test(value)) {
	    try {
	      return JSON.parse(value);
	    } catch (e) {
	      return value;
	    }
	  }
	  // everything else
	  return value;
	};
	
	dq.extend = extend;
	dq.map = map;
	dq.each = each;
	dq.getJSON = getJSON;
	
	module.exports = dq;

/***/ },

/***/ "KFpU":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'addthis',
	    faPrefix: 'fas',
	    faName: 'fa-plus',
	    title: {
	      'bg': 'Сподели в AddThis',
	      'cs': 'Sdílet na AddThis',
	      'da': 'Del på AddThis',
	      'de': 'Bei AddThis teilen',
	      'en': 'Share on AddThis',
	      'es': 'Compartir en AddThis',
	      'fi': 'Jaa AddThisissä',
	      'fr': 'Partager sur AddThis',
	      'hr': 'Podijelite na AddThis',
	      'hu': 'Megosztás AddThisen',
	      'it': 'Condividi su AddThis',
	      'ja': 'AddThis上で共有',
	      'ko': 'AddThis에서 공유하기',
	      'nl': 'Delen op AddThis',
	      'no': 'Del på AddThis',
	      'pl': 'Udostępnij przez AddThis',
	      'pt': 'Compartilhar no AddThis',
	      'ro': 'Partajează pe AddThis',
	      'ru': 'Поделиться на AddThis',
	      'sk': 'Zdieľať na AddThis',
	      'sl': 'Deli na AddThis',
	      'sr': 'Podeli na AddThis',
	      'sv': 'Dela på AddThis',
	      'tr': 'AddThis\'ta paylaş',
	      'zh': '在AddThis上分享'
	    },
	    shareUrl: 'http://api.addthis.com/oexchange/0.8/offer?url=' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "rN0r":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  var title = encodeURIComponent(shariff.getTitle());
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'buffer',
	    faPrefix: 'fab',
	    faName: 'fa-buffer',
	    title: {
	      'bg': 'Сподели в buffer',
	      'cs': 'Sdílet na buffer',
	      'da': 'Del på buffer',
	      'de': 'Bei buffer teilen',
	      'en': 'Share on buffer',
	      'es': 'Compartir en buffer',
	      'fi': 'Jaa bufferissä',
	      'fr': 'Partager sur buffer',
	      'hr': 'Podijelite na buffer',
	      'hu': 'Megosztás bufferen',
	      'it': 'Condividi su buffer',
	      'ja': 'buffer上で共有',
	      'ko': 'buffer에서 공유하기',
	      'nl': 'Delen op buffer',
	      'no': 'Del på buffer',
	      'pl': 'Udostępnij przez buffer',
	      'pt': 'Compartilhar no buffer',
	      'ro': 'Partajează pe buffer',
	      'ru': 'Поделиться на buffer',
	      'sk': 'Zdieľať na buffer',
	      'sl': 'Deli na buffer',
	      'sr': 'Podeli na buffer',
	      'sv': 'Dela på buffer',
	      'tr': 'buffer\'ta paylaş',
	      'zh': '在buffer上分享'
	    },
	    shareUrl: 'https://buffer.com/add?text=' + title + '&url=' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "Aw3z":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var url = __webpack_require__("UZ5h");
	
	module.exports = function (shariff) {
	  var shareUrl = url.parse('https://share.diasporafoundation.org/', true);
	  shareUrl.query.url = shariff.getURL();
	  shareUrl.query.title = shariff.getTitle();
	  shareUrl.protocol = 'https';
	  delete shareUrl.search;
	
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'diaspora',
	    faPrefix: 'fas',
	    faName: 'fa-asterisk',
	    title: {
	      'bg': 'Сподели в diaspora*',
	      'cs': 'Sdílet na diaspora*',
	      'da': 'Del på diaspora*',
	      'de': 'Bei diaspora* teilen',
	      'en': 'Share on diaspora*',
	      'es': 'Compartir en diaspora*',
	      'fi': 'Jaa Diasporaissä',
	      'fr': 'Partager sur diaspora*',
	      'hr': 'Podijelite na diaspora*',
	      'hu': 'Megosztás diaspora*',
	      'it': 'Condividi su diaspora*',
	      'ja': 'diaspora*上で共有',
	      'ko': 'diaspora*에서 공유하기',
	      'nl': 'Delen op diaspora*',
	      'no': 'Del på diaspora*',
	      'pl': 'Udostępnij przez diaspora*',
	      'pt': 'Compartilhar no diaspora*',
	      'ro': 'Partajează pe diaspora*',
	      'ru': 'Поделиться на diaspora*',
	      'sk': 'Zdieľať na diaspora*',
	      'sl': 'Deli na diaspora*',
	      'sr': 'Podeli na diaspora*-u',
	      'sv': 'Dela på diaspora*',
	      'tr': 'diaspora*\'ta paylaş',
	      'zh': '分享至diaspora*'
	    },
	    shareUrl: url.format(shareUrl) + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "0YOX":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'facebook',
	    faPrefix: 'fab',
	    faName: 'fa-facebook-f',
	    title: {
	      'bg': 'Сподели във Facebook',
	      'cs': 'Sdílet na Facebooku',
	      'da': 'Del på Facebook',
	      'de': 'Bei Facebook teilen',
	      'en': 'Share on Facebook',
	      'es': 'Compartir en Facebook',
	      'fi': 'Jaa Facebookissa',
	      'fr': 'Partager sur Facebook',
	      'hr': 'Podijelite na Facebooku',
	      'hu': 'Megosztás Facebookon',
	      'it': 'Condividi su Facebook',
	      'ja': 'フェイスブック上で共有',
	      'ko': '페이스북에서 공유하기',
	      'nl': 'Delen op Facebook',
	      'no': 'Del på Facebook',
	      'pl': 'Udostępnij na Facebooku',
	      'pt': 'Compartilhar no Facebook',
	      'ro': 'Partajează pe Facebook',
	      'ru': 'Поделиться на Facebook',
	      'sk': 'Zdieľať na Facebooku',
	      'sl': 'Deli na Facebooku',
	      'sr': 'Podeli na Facebook-u',
	      'sv': 'Dela på Facebook',
	      'tr': 'Facebook\'ta paylaş',
	      'zh': '在Facebook上分享'
	    },
	    shareUrl: 'https://www.facebook.com/sharer/sharer.php?u=' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "WN47":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  var title = shariff.getTitle();
	  var description = shariff.getMeta('description');
	
	  return {
	    popup: true,
	    shareText: 'Flattr',
	    name: 'flattr',
	    faPrefix: 'far',
	    faName: 'fa-money-bill-alt',
	    title: {
	      'de': 'Artikel flattrn',
	      'en': 'Flattr this'
	    },
	    shareUrl: 'https://flattr.com/submit/auto?title=' + encodeURIComponent(title) + '&description=' + encodeURIComponent(description) + '&category=' + encodeURIComponent(shariff.options.flattrCategory || 'text') + '&user_id=' + encodeURIComponent(shariff.options.flattrUser) + '&url=' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "frM/":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  var title = encodeURIComponent(shariff.getTitle());
	  return {
	    popup: true,
	    shareText: 'flip it',
	    name: 'flipboard',
	    faPrefix: 'fab',
	    faName: 'fa-flipboard',
	    title: {
	      'bg': 'Сподели в Flipboard',
	      'cs': 'Sdílet na Flipboardu',
	      'da': 'Del på Flipboard',
	      'de': 'Bei Flipboard teilen',
	      'en': 'Share on Flipboard',
	      'es': 'Compartir en Flipboard',
	      'fi': 'Jaa Flipboardissä',
	      'fr': 'Partager sur Flipboard',
	      'hr': 'Podijelite na Flipboardu',
	      'hu': 'Megosztás Flipboardon',
	      'it': 'Condividi su Flipboard',
	      'ja': 'Flipboard上で共有',
	      'ko': 'Flipboard에서 공유하기',
	      'nl': 'Delen op Flipboard',
	      'no': 'Del på Flipboard',
	      'pl': 'Udostępnij na Flipboardu',
	      'pt': 'Compartilhar no Flipboard',
	      'ro': 'Partajează pe Flipboard',
	      'ru': 'Поделиться на Flipboard',
	      'sk': 'Zdieľať na Flipboardu',
	      'sl': 'Deli na Flipboardu',
	      'sr': 'Podeli na Flipboard-u',
	      'sv': 'Dela på Flipboard',
	      'tr': 'Flipboard\'ta paylaş',
	      'zh': '在Flipboard上分享'
	    },
	    shareUrl: 'https://share.flipboard.com/bookmarklet/popout?v=2&title=' + title + '&url=' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "n8It":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = {
	  addthis: __webpack_require__("KFpU"),
	  buffer: __webpack_require__("rN0r"),
	  diaspora: __webpack_require__("Aw3z"),
	  facebook: __webpack_require__("0YOX"),
	  flattr: __webpack_require__("WN47"),
	  flipboard: __webpack_require__("frM/"),
	  info: __webpack_require__("W8Zq"),
	  linkedin: __webpack_require__("fSdU"),
	  mail: __webpack_require__("PvOx"),
	  pinterest: __webpack_require__("1d4V"),
	  pocket: __webpack_require__("tzB9"),
	  print: __webpack_require__("WV5X"),
	  qzone: __webpack_require__("IBda"),
	  reddit: __webpack_require__("5YaW"),
	  stumbleupon: __webpack_require__("2JNZ"),
	  telegram: __webpack_require__("AjoF"),
	  tencent: __webpack_require__("C094"),
	  threema: __webpack_require__("zizA"),
	  tumblr: __webpack_require__("SfGA"),
	  twitter: __webpack_require__("FeEC"),
	  vk: __webpack_require__("giFI"),
	  weibo: __webpack_require__("mh5i"),
	  whatsapp: __webpack_require__("aD6o"),
	  xing: __webpack_require__("dTlm")
	};

/***/ },

/***/ "W8Zq":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  return {
	    blank: shariff.getInfoDisplayBlank(),
	    popup: shariff.getInfoDisplayPopup(),
	    shareText: 'Info',
	    name: 'info',
	    faPrefix: 'fas',
	    faName: 'fa-info',
	    title: {
	      'bg': 'Повече информация',
	      'cs': 'Více informací',
	      'da': 'Flere oplysninger',
	      'de': 'Weitere Informationen',
	      'en': 'More information',
	      'es': 'Más informaciones',
	      'fi': 'Lisätietoja',
	      'fr': 'Plus d\'informations',
	      'hr': 'Više informacija',
	      'hu': 'Több információ',
	      'it': 'Maggiori informazioni',
	      'ja': '詳しい情報',
	      'ko': '추가 정보',
	      'nl': 'Verdere informatie',
	      'no': 'Mer informasjon',
	      'pl': 'Więcej informacji',
	      'pt': 'Mais informações',
	      'ro': 'Mai multe informatii',
	      'ru': 'Больше информации',
	      'sk': 'Viac informácií',
	      'sl': 'Več informacij',
	      'sr': 'Više informacija',
	      'sv': 'Mer information',
	      'tr': 'Daha fazla bilgi',
	      'zh': '更多信息'
	    },
	    shareUrl: shariff.getInfoUrl()
	  };
	};

/***/ },

/***/ "fSdU":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  var title = encodeURIComponent(shariff.getTitle());
	  var descr = encodeURIComponent(shariff.getMeta('description'));
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'mitteilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': 'シェア',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'distribuiți',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'linkedin',
	    faPrefix: 'fab',
	    faName: 'fa-linkedin-in',
	    title: {
	      'bg': 'Сподели в LinkedIn',
	      'cs': 'Sdílet na LinkedIn',
	      'da': 'Del på LinkedIn',
	      'de': 'Bei LinkedIn teilen',
	      'en': 'Share on LinkedIn',
	      'es': 'Compartir en LinkedIn',
	      'fi': 'Jaa LinkedInissä',
	      'fr': 'Partager sur LinkedIn',
	      'hr': 'Podijelite na LinkedIn',
	      'hu': 'Megosztás LinkedInen',
	      'it': 'Condividi su LinkedIn',
	      'ja': 'LinkedIn上で共有',
	      'ko': 'LinkedIn에서 공유하기',
	      'nl': 'Delen op LinkedIn',
	      'no': 'Del på LinkedIn',
	      'pl': 'Udostępnij przez LinkedIn',
	      'pt': 'Compartilhar no LinkedIn',
	      'ro': 'Partajează pe LinkedIn',
	      'ru': 'Поделиться на LinkedIn',
	      'sk': 'Zdieľať na LinkedIn',
	      'sl': 'Deli na LinkedIn',
	      'sr': 'Podeli na LinkedIn-u',
	      'sv': 'Dela på LinkedIn',
	      'tr': 'LinkedIn\'ta paylaş',
	      'zh': '在LinkedIn上分享'
	    },
	    shareUrl: 'https://www.linkedin.com/shareArticle?mini=true&summary=' + descr + '&title=' + title + '&url=' + url
	  };
	};

/***/ },

/***/ "PvOx":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = shariff.getOption('mailUrl');
	
	  // mailto: link? Add body and subject.
	  if (url.indexOf('mailto:') === 0) {
	    url += '?subject=' + encodeURIComponent(shariff.getOption('mailSubject') || shariff.getTitle());
	    url += '&body=' + encodeURIComponent(shariff.getOption('mailBody').replace(/\{url\}/i, shariff.getURL()));
	  }
	
	  return {
	    blank: url.indexOf('http') === 0,
	    popup: false,
	    shareText: {
	      'en': 'mail',
	      'zh': '分享'
	    },
	    name: 'mail',
	    faPrefix: 'fas',
	    faName: 'fa-envelope',
	    title: {
	      'bg': 'Изпрати по имейл',
	      'cs': 'Poslat mailem',
	      'da': 'Sende via e-mail',
	      'de': 'Per E-Mail versenden',
	      'en': 'Send by email',
	      'es': 'Enviar por email',
	      'fi': 'Lähetä sähköpostitse',
	      'fr': 'Envoyer par courriel',
	      'hr': 'Pošaljite emailom',
	      'hu': 'Elküldés e-mailben',
	      'it': 'Inviare via email',
	      'ja': '電子メールで送信',
	      'ko': '이메일로 보내기',
	      'nl': 'Sturen via e-mail',
	      'no': 'Send via epost',
	      'pl': 'Wyślij e-mailem',
	      'pt': 'Enviar por e-mail',
	      'ro': 'Trimite prin e-mail',
	      'ru': 'Отправить по эл. почте',
	      'sk': 'Poslať e-mailom',
	      'sl': 'Pošlji po elektronski pošti',
	      'sr': 'Pošalji putem email-a',
	      'sv': 'Skicka via e-post',
	      'tr': 'E-posta ile gönder',
	      'zh': '通过电子邮件传送'
	    },
	    shareUrl: url
	  };
	};

/***/ },

/***/ "1d4V":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var url = __webpack_require__("UZ5h");
	
	module.exports = function (shariff) {
	  var title = shariff.getTitle();
	  var creator = shariff.getMeta('DC.creator');
	  if (creator.length > 0) {
	    title += ' - ' + creator;
	  }
	  var img = shariff.getOption('mediaUrl');
	  if (!img || img.length <= 0) {
	    img = shariff.getMeta('og:image');
	  }
	
	  var shareUrl = url.parse('https://www.pinterest.com/pin/create/link/', true);
	  shareUrl.query.url = shariff.getURL();
	  shareUrl.query.media = img;
	  shareUrl.query.description = title;
	  delete shareUrl.search;
	
	  return {
	    popup: true,
	    shareText: 'pin it',
	    name: 'pinterest',
	    faPrefix: 'fab',
	    faName: 'fa-pinterest-p',
	    title: {
	      'bg': 'Сподели в Pinterest',
	      'cs': 'Přidat na Pinterest',
	      'da': 'Del på Pinterest',
	      'de': 'Bei Pinterest pinnen',
	      'en': 'Pin it on Pinterest',
	      'es': 'Compartir en Pinterest',
	      'fi': 'Jaa Pinterestissä',
	      'fr': 'Partager sur Pinterest',
	      'hr': 'Podijelite na Pinterest',
	      'hu': 'Megosztás Pinteresten',
	      'it': 'Condividi su Pinterest',
	      'ja': 'Pinterest上で共有',
	      'ko': 'Pinterest에서 공유하기',
	      'nl': 'Delen op Pinterest',
	      'no': 'Del på Pinterest',
	      'pl': 'Udostępnij przez Pinterest',
	      'pt': 'Compartilhar no Pinterest',
	      'ro': 'Partajează pe Pinterest',
	      'ru': 'Поделиться на Pinterest',
	      'sk': 'Zdieľať na Pinterest',
	      'sl': 'Deli na Pinterest',
	      'sr': 'Podeli na Pinterest-u',
	      'sv': 'Dela på Pinterest',
	      'tr': 'Pinterest\'ta paylaş',
	      'zh': '分享至Pinterest'
	    },
	    shareUrl: url.format(shareUrl) + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "tzB9":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  var title = encodeURIComponent(shariff.getTitle());
	  return {
	    popup: true,
	    shareText: 'Pocket',
	    name: 'pocket',
	    faPrefix: 'fab',
	    faName: 'fa-get-pocket',
	    title: {
	      'bg': 'Запазване в Pocket',
	      'cs': 'Uložit do Pocket',
	      'da': 'Gem i Pocket',
	      'de': 'In Pocket speichern',
	      'en': 'Save to Pocket',
	      'es': 'Guardar en Pocket',
	      'fi': 'Tallenna kohtaan Pocket',
	      'fr': 'Enregistrer dans Pocket',
	      'hr': 'Spremi u Pocket',
	      'hu': 'Mentés "Pocket"-be',
	      'it': 'Salva in Pocket',
	      'ja': '「ポケット」に保存',
	      'ko': 'Pocket에 저장',
	      'nl': 'Opslaan in Pocket',
	      'no': 'Lagre i Pocket',
	      'pl': 'Zapisz w Pocket',
	      'pt': 'Salvar em Pocket',
	      'ro': 'Salvați în Pocket',
	      'ru': 'Сохранить в Pocket',
	      'sk': 'Uložiť do priečinka Pocket',
	      'sl': 'Shrani v Pocket',
	      'sr': 'Sačuvaj u Pocket',
	      'sv': 'Spara till Pocket',
	      'tr': 'Pocket e kaydet',
	      'zh': '保存到Pocket'
	    },
	    shareUrl: 'https://getpocket.com/save?title=' + title + '&url=' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "WV5X":
/***/ function(module, exports) {

	/* jshint scripturl:true */
	'use strict';
	
	module.exports = function (shariff) {
	  var url = 'javascript:window.print();';
	
	  return {
	    name: 'print',
	    faPrefix: 'fas',
	    faName: 'fa-print',
	    popup: false,
	    shareText: {
	      'bg': '',
	      'cs': 'tlačit',
	      'da': '',
	      'de': 'drucken',
	      'en': 'print',
	      'es': '',
	      'fi': '',
	      'fr': '',
	      'hr': '',
	      'hu': '',
	      'it': '',
	      'ja': '',
	      'ko': '',
	      'nl': '',
	      'no': '',
	      'pl': '',
	      'pt': '',
	      'ro': '',
	      'ru': '',
	      'sk': '',
	      'sl': '',
	      'sr': '',
	      'sv': '',
	      'tr': '',
	      'zh': ''
	    },
	    title: {
	      'bg': '',
	      'cs': 'tlačit',
	      'da': '',
	      'de': 'drucken',
	      'en': 'print',
	      'es': '',
	      'fi': '',
	      'fr': '',
	      'hr': '',
	      'hu': '',
	      'it': '',
	      'ja': '',
	      'ko': '',
	      'nl': '',
	      'no': '',
	      'pl': '',
	      'pt': '',
	      'ro': '',
	      'ru': '',
	      'sk': '',
	      'sl': '',
	      'sr': '',
	      'sv': '',
	      'tr': '',
	      'zh': ''
	    },
	    shareUrl: url
	  };
	};

/***/ },

/***/ "IBda":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	
	  var title = shariff.getTitle();
	
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'qzone',
	    faPrefix: 'fab',
	    faName: 'fa-qq',
	    title: {
	      'bg': 'Сподели в Qzone',
	      'cs': 'Sdílet na Qzone',
	      'da': 'Del på Qzone',
	      'de': 'Bei Qzone teilen',
	      'en': 'Share on Qzone',
	      'es': 'Compartir en Qzone',
	      'fi': 'Jaa Qzoneissä',
	      'fr': 'Partager sur Qzone',
	      'hr': 'Podijelite na Qzone',
	      'hu': 'Megosztás Qzone',
	      'it': 'Condividi su Qzone',
	      'ja': 'Qzone上で共有',
	      'ko': 'Qzone에서 공유하기',
	      'nl': 'Delen op Qzone',
	      'no': 'Del på Qzone',
	      'pl': 'Udostępnij przez Qzone',
	      'pt': 'Compartilhar no Qzone',
	      'ro': 'Partajează pe Qzone',
	      'ru': 'Поделиться на Qzone',
	      'sk': 'Zdieľať na Qzone',
	      'sl': 'Deli na Qzone',
	      'sr': 'Podeli na Qzone-u',
	      'sv': 'Dela på Qzone',
	      'tr': 'Qzone\'ta paylaş',
	      'zh': '分享至QQ空间'
	    },
	    shareUrl: 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=' + url + '&title=' + title + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "5YaW":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  var title = encodeURIComponent(shariff.getTitle());
	
	  if (title !== '') {
	    title = '&title=' + title;
	  }
	
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'reddit',
	    faPrefix: 'fab',
	    faName: 'fa-reddit-alien',
	    title: {
	      'bg': 'Сподели в Reddit',
	      'cs': 'Sdílet na Redditu',
	      'da': 'Del på Reddit',
	      'de': 'Bei Reddit teilen',
	      'en': 'Share on Reddit',
	      'es': 'Compartir en Reddit',
	      'fi': 'Jaa Redditissä',
	      'fr': 'Partager sur Reddit',
	      'hr': 'Podijelite na Reddit',
	      'hu': 'Megosztás Redditen',
	      'it': 'Condividi su Reddit',
	      'ja': 'Reddit上で共有',
	      'ko': 'Reddit에서 공유하기',
	      'nl': 'Delen op Reddit',
	      'no': 'Del på Reddit',
	      'pl': 'Udostępnij przez Reddit',
	      'pt': 'Compartilhar no Reddit',
	      'ro': 'Partajează pe Reddit',
	      'ru': 'Поделиться на Reddit',
	      'sk': 'Zdieľať na Reddit',
	      'sl': 'Deli na Reddit',
	      'sr': 'Podeli na Reddit-u',
	      'sv': 'Dela på Reddit',
	      'tr': 'Reddit\'ta paylaş',
	      'zh': '分享至Reddit'
	    },
	    shareUrl: 'https://reddit.com/submit?url=' + url + title + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "2JNZ":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  var title = encodeURIComponent(shariff.getTitle());
	
	  if (title !== '') {
	    title = '&title=' + title;
	  }
	
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'stumbleupon',
	    faPrefix: 'fab',
	    faName: 'fa-stumbleupon',
	    title: {
	      'bg': 'Сподели в Stumbleupon',
	      'cs': 'Sdílet na Stumbleuponu',
	      'da': 'Del på Stumbleupon',
	      'de': 'Bei Stumbleupon teilen',
	      'en': 'Share on Stumbleupon',
	      'es': 'Compartir en Stumbleupon',
	      'fi': 'Jaa Stumbleuponissä',
	      'fr': 'Partager sur Stumbleupon',
	      'hr': 'Podijelite na Stumbleupon',
	      'hu': 'Megosztás Stumbleupon',
	      'it': 'Condividi su Stumbleupon',
	      'ja': 'Stumbleupon上で共有',
	      'ko': 'Stumbleupon에서 공유하기',
	      'nl': 'Delen op Stumbleupon',
	      'no': 'Del på Stumbleupon',
	      'pl': 'Udostępnij przez Stumbleupon',
	      'pt': 'Compartilhar no Stumbleupon',
	      'ro': 'Partajează pe Stumbleupon',
	      'ru': 'Поделиться на Stumbleupon',
	      'sk': 'Zdieľať na Stumbleupon',
	      'sl': 'Deli na Stumbleupon',
	      'sr': 'Podeli na Stumbleupon-u',
	      'sv': 'Dela på Stumbleupon',
	      'tr': 'Stumbleupon\'ta paylaş',
	      'zh': '分享至Stumbleupon'
	    },
	    shareUrl: 'https://www.stumbleupon.com/submit?url=' + url + title + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "AjoF":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'telegram',
	    faPrefix: 'fab',
	    faName: 'fa-telegram',
	    title: {
	      'bg': 'Сподели в Telegram',
	      'cs': 'Sdílet na Telegramu',
	      'da': 'Del på Telegram',
	      'de': 'Bei Telegram teilen',
	      'en': 'Share on Telegram',
	      'es': 'Compartir en Telegram',
	      'fi': 'Jaa Telegramissä',
	      'fr': 'Partager sur Telegram',
	      'hr': 'Podijelite na Telegram',
	      'hu': 'Megosztás Telegramen',
	      'it': 'Condividi su Telegram',
	      'ja': 'Telegram上で共有',
	      'ko': 'Telegram에서 공유하기',
	      'nl': 'Delen op Telegram',
	      'no': 'Del på Telegram',
	      'pl': 'Udostępnij przez Telegram',
	      'pt': 'Compartilhar no Telegram',
	      'ro': 'Partajează pe Telegram',
	      'ru': 'Поделиться на Telegram',
	      'sk': 'Zdieľať na Telegram',
	      'sl': 'Deli na Telegram',
	      'sr': 'Podeli na Telegram-u',
	      'sv': 'Dela på Telegram',
	      'tr': 'Telegram\'ta paylaş',
	      'zh': '在Telegram上分享'
	    },
	    shareUrl: 'https://t.me/share/url?url=' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "C094":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	
	  var title = shariff.getTitle();
	
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'tencent-weibo',
	    faPrefix: 'fab',
	    faName: 'fa-tencent-weibo',
	    title: {
	      'bg': 'Сподели в tencent weibo',
	      'cs': 'Sdílet na tencent weibo',
	      'da': 'Del på tencent weibo',
	      'de': 'Bei tencent weibo teilen',
	      'en': 'Share on tencent weibo',
	      'es': 'Compartir en tencent weibo',
	      'fi': 'Jaa tencent weiboissä',
	      'fr': 'Partager sur tencent weibo',
	      'hr': 'Podijelite na tencent weibo',
	      'hu': 'Megosztás tencent weiboen',
	      'it': 'Condividi su tencent weibo',
	      'ja': 'Tencent weibo上で共有',
	      'ko': 'Tencent weibo에서 공유하기',
	      'nl': 'Delen op tencent weibo',
	      'no': 'Del på tencent weibo',
	      'pl': 'Udostępnij przez tencent weibo',
	      'pt': 'Compartilhar no tencent weibo',
	      'ro': 'Partajează pe tencent weibo',
	      'ru': 'Поделиться на tencent weibo',
	      'sk': 'Zdieľať na tencent weibo',
	      'sl': 'Deli na tencent weibo',
	      'sr': 'Podeli na tencent weibo-u',
	      'sv': 'Dela på tencent weibo',
	      'tr': 'Tencent weibo\'ta paylaş',
	      'zh': '分享至腾讯微博'
	    },
	    shareUrl: 'http://v.t.qq.com/share/share.php?url=' + url + '&title=' + title + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "zizA":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	
	  var title = shariff.getTitle();
	
	  return {
	    popup: false,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'threema',
	    faPrefix: 'fas',
	    faName: 'fa-lock',
	    title: {
	      'bg': 'Сподели в Threema',
	      'cs': 'Sdílet na Threema',
	      'da': 'Del på Threema',
	      'de': 'Bei Threema teilen',
	      'en': 'Share on Threema',
	      'es': 'Compartir en Threema',
	      'fi': 'Jaa Threemaissä',
	      'fr': 'Partager sur Threema',
	      'hr': 'Podijelite na Threema',
	      'hu': 'Megosztás Threemaen',
	      'it': 'Condividi su Threema',
	      'ja': 'Threema上で共有',
	      'ko': 'Threema에서 공유하기',
	      'nl': 'Delen op Threema',
	      'no': 'Del på Threema',
	      'pl': 'Udostępnij przez Threema',
	      'pt': 'Compartilhar no Threema',
	      'ro': 'Partajează pe Threema',
	      'ru': 'Поделиться на Threema',
	      'sk': 'Zdieľať na Threema',
	      'sl': 'Deli na Threema',
	      'sr': 'Podeli na Threema-u',
	      'sv': 'Dela på Threema',
	      'tr': 'Threema\'ta paylaş',
	      'zh': '在Threema上分享'
	    },
	    shareUrl: 'threema://compose?text=' + encodeURIComponent(title) + '%20' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "SfGA":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'tumblr',
	    faPrefix: 'fab',
	    faName: 'fa-tumblr',
	    title: {
	      'bg': 'Сподели в tumblr',
	      'cs': 'Sdílet na tumblru',
	      'da': 'Del på tumblr',
	      'de': 'Bei tumblr teilen',
	      'en': 'Share on tumblr',
	      'es': 'Compartir en tumblr',
	      'fi': 'Jaa tumblrissä',
	      'fr': 'Partager sur tumblr',
	      'hr': 'Podijelite na tumblr',
	      'hu': 'Megosztás tumblren',
	      'it': 'Condividi su tumblr',
	      'ja': 'tumblr上で共有',
	      'ko': 'tumblr에서 공유하기',
	      'nl': 'Delen op tumblr',
	      'no': 'Del på tumblr',
	      'pl': 'Udostępnij przez tumblr',
	      'pt': 'Compartilhar no tumblr',
	      'ro': 'Partajează pe tumblr',
	      'ru': 'Поделиться на tumblr',
	      'sk': 'Zdieľať na tumblr',
	      'sl': 'Deli na tumblr',
	      'sr': 'Podeli na tumblr-u',
	      'sv': 'Dela på tumblr',
	      'tr': 'tumblr\'ta paylaş',
	      'zh': '在tumblr上分享'
	    },
	    shareUrl: 'http://tumblr.com/widgets/share/tool?canonicalUrl=' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "FeEC":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var url = __webpack_require__("UZ5h");
	
	// abbreviate at last blank before length and add "\u2026" (horizontal ellipsis)
	var abbreviateText = function abbreviateText(text, length) {
	  var div = document.createElement('div');
	  var node = document.createTextNode(text);
	  div.appendChild(node);
	  var abbreviated = div.textContent;
	  if (abbreviated.length <= length) {
	    return text;
	  }
	
	  var lastWhitespaceIndex = abbreviated.substring(0, length - 1).lastIndexOf(' ');
	  abbreviated = abbreviated.substring(0, lastWhitespaceIndex) + '\u2026';
	
	  return abbreviated;
	};
	
	module.exports = function (shariff) {
	  var shareUrl = url.parse('https://twitter.com/intent/tweet', true);
	
	  var title = shariff.getTitle();
	
	  // 120 is the max character count left after twitters automatic url shortening with t.co
	  shareUrl.query.text = abbreviateText(title, 120);
	  shareUrl.query.url = shariff.getURL();
	  if (shariff.options.twitterVia !== null) {
	    shareUrl.query.via = shariff.options.twitterVia;
	  }
	  delete shareUrl.search;
	
	  return {
	    popup: true,
	    shareText: {
	      'en': 'tweet',
	      'ja': 'のつぶやき',
	      'ko': '짹짹',
	      'ru': 'твит',
	      'sr': 'твеет',
	      'zh': '鸣叫'
	    },
	    name: 'twitter',
	    faPrefix: 'fab',
	    faName: 'fa-twitter',
	    title: {
	      'bg': 'Сподели в Twitter',
	      'cs': 'Sdílet na Twiiteru',
	      'da': 'Del på Twitter',
	      'de': 'Bei Twitter teilen',
	      'en': 'Share on Twitter',
	      'es': 'Compartir en Twitter',
	      'fi': 'Jaa Twitterissä',
	      'fr': 'Partager sur Twitter',
	      'hr': 'Podijelite na Twitteru',
	      'hu': 'Megosztás Twitteren',
	      'it': 'Condividi su Twitter',
	      'ja': 'ツイッター上で共有',
	      'ko': '트위터에서 공유하기',
	      'nl': 'Delen op Twitter',
	      'no': 'Del på Twitter',
	      'pl': 'Udostępnij na Twitterze',
	      'pt': 'Compartilhar no Twitter',
	      'ro': 'Partajează pe Twitter',
	      'ru': 'Поделиться на Twitter',
	      'sk': 'Zdieľať na Twitteri',
	      'sl': 'Deli na Twitterju',
	      'sr': 'Podeli na Twitter-u',
	      'sv': 'Dela på Twitter',
	      'tr': 'Twitter\'da paylaş',
	      'zh': '在Twitter上分享'
	    },
	    // shareUrl: 'https://twitter.com/intent/tweet?text='+ shariff.getShareText() + '&url=' + url
	    shareUrl: url.format(shareUrl) + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "giFI":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'vk',
	    faPrefix: 'fab',
	    faName: 'fa-vk',
	    title: {
	      'bg': 'Сподели във VK',
	      'cs': 'Sdílet na VKu',
	      'da': 'Del på VK',
	      'de': 'Bei VK teilen',
	      'en': 'Share on VK',
	      'es': 'Compartir en VK',
	      'fi': 'Jaa VKissa',
	      'fr': 'Partager sur VK',
	      'hr': 'Podijelite na VKu',
	      'hu': 'Megosztás VKon',
	      'it': 'Condividi su VK',
	      'ja': 'フェイスブック上で共有',
	      'ko': '페이스북에서 공유하기',
	      'nl': 'Delen op VK',
	      'no': 'Del på VK',
	      'pl': 'Udostępnij na VKu',
	      'pt': 'Compartilhar no VK',
	      'ro': 'Partajează pe VK',
	      'ru': 'Поделиться на ВКонтакте',
	      'sk': 'Zdieľať na VKu',
	      'sl': 'Deli na VKu',
	      'sr': 'Podeli na VK-u',
	      'sv': 'Dela på VK',
	      'tr': 'VK\'ta paylaş',
	      'zh': '在VK上分享'
	    },
	    shareUrl: 'https://vk.com/share.php?url=' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "mh5i":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	
	  var title = shariff.getTitle();
	
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'weibo',
	    faPrefix: 'fab',
	    faName: 'fa-weibo',
	    title: {
	      'bg': 'Сподели в weibo',
	      'cs': 'Sdílet na weibo',
	      'da': 'Del på weibo',
	      'de': 'Bei weibo teilen',
	      'en': 'Share on weibo',
	      'es': 'Compartir en weibo',
	      'fi': 'Jaa weiboissä',
	      'fr': 'Partager sur weibo',
	      'hr': 'Podijelite na weibo',
	      'hu': 'Megosztás weiboen',
	      'it': 'Condividi su weibo',
	      'ja': 'Weibo上で共有',
	      'ko': 'Weibo에서 공유하기',
	      'nl': 'Delen op weibo',
	      'no': 'Del på weibo',
	      'pl': 'Udostępnij przez weibo',
	      'pt': 'Compartilhar no weibo',
	      'ro': 'Partajează pe weibo',
	      'ru': 'Поделиться на weibo',
	      'sk': 'Zdieľať na weibo',
	      'sl': 'Deli na weibo',
	      'sr': 'Podeli na weibo-u',
	      'sv': 'Dela på weibo',
	      'tr': 'Weibo\'ta paylaş',
	      'zh': '分享至新浪微博'
	    },
	    shareUrl: 'http://service.weibo.com/share/share.php?url=' + url + '&title=' + title + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "aD6o":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	
	  var title = shariff.getTitle();
	
	  return {
	    popup: false,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'whatsapp',
	    faPrefix: 'fab',
	    faName: 'fa-whatsapp',
	    title: {
	      'bg': 'Сподели в Whatsapp',
	      'cs': 'Sdílet na Whatsappu',
	      'da': 'Del på Whatsapp',
	      'de': 'Bei Whatsapp teilen',
	      'en': 'Share on Whatsapp',
	      'es': 'Compartir en Whatsapp',
	      'fi': 'Jaa WhatsAppissä',
	      'fr': 'Partager sur Whatsapp',
	      'hr': 'Podijelite na Whatsapp',
	      'hu': 'Megosztás WhatsAppen',
	      'it': 'Condividi su Whatsapp',
	      'ja': 'Whatsapp上で共有',
	      'ko': 'Whatsapp에서 공유하기',
	      'nl': 'Delen op Whatsapp',
	      'no': 'Del på Whatsapp',
	      'pl': 'Udostępnij przez WhatsApp',
	      'pt': 'Compartilhar no Whatsapp',
	      'ro': 'Partajează pe Whatsapp',
	      'ru': 'Поделиться на Whatsapp',
	      'sk': 'Zdieľať na Whatsapp',
	      'sl': 'Deli na Whatsapp',
	      'sr': 'Podeli na WhatsApp-u',
	      'sv': 'Dela på Whatsapp',
	      'tr': 'Whatsapp\'ta paylaş',
	      'zh': '在Whatsapp上分享'
	    },
	    shareUrl: 'whatsapp://send?text=' + encodeURIComponent(title) + '%20' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "dTlm":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function (shariff) {
	  var url = encodeURIComponent(shariff.getURL());
	  return {
	    popup: true,
	    shareText: {
	      'bg': 'cподеляне',
	      'cs': 'sdílet',
	      'da': 'del',
	      'de': 'teilen',
	      'en': 'share',
	      'es': 'compartir',
	      'fi': 'Jaa',
	      'fr': 'partager',
	      'hr': 'podijelite',
	      'hu': 'megosztás',
	      'it': 'condividi',
	      'ja': '共有',
	      'ko': '공유하기',
	      'nl': 'delen',
	      'no': 'del',
	      'pl': 'udostępnij',
	      'pt': 'compartilhar',
	      'ro': 'partajează',
	      'ru': 'поделиться',
	      'sk': 'zdieľať',
	      'sl': 'deli',
	      'sr': 'podeli',
	      'sv': 'dela',
	      'tr': 'paylaş',
	      'zh': '分享'
	    },
	    name: 'xing',
	    faPrefix: 'fab',
	    faName: 'fa-xing',
	    title: {
	      'bg': 'Сподели в XING',
	      'cs': 'Sdílet na XINGu',
	      'da': 'Del på XING',
	      'de': 'Bei XING teilen',
	      'en': 'Share on XING',
	      'es': 'Compartir en XING',
	      'fi': 'Jaa XINGissä',
	      'fr': 'Partager sur XING',
	      'hr': 'Podijelite na XING',
	      'hu': 'Megosztás XINGen',
	      'it': 'Condividi su XING',
	      'ja': 'XING上で共有',
	      'ko': 'XING에서 공유하기',
	      'nl': 'Delen op XING',
	      'no': 'Del på XING',
	      'pl': 'Udostępnij przez XING',
	      'pt': 'Compartilhar no XING',
	      'ro': 'Partajează pe XING',
	      'ru': 'Поделиться на XING',
	      'sk': 'Zdieľať na XING',
	      'sl': 'Deli na XING',
	      'sr': 'Podeli na XING-u',
	      'sv': 'Dela på XING',
	      'tr': 'XING\'ta paylaş',
	      'zh': '分享至XING'
	    },
	    shareUrl: 'https://www.xing.com/spi/shares/new?url=' + url + shariff.getReferrerTrack()
	  };
	};

/***/ },

/***/ "KqFD":
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	// require('babel-polyfill')
	
	var _typeof2 = __webpack_require__("tyBi");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__("mleP");
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__("yo7H");
	var services = __webpack_require__("n8It");
	var url = __webpack_require__("UZ5h");
	
	// Defaults may be overridden either by passing "options" to Shariff constructor
	// or by setting data attributes.
	var Defaults = {
	  theme: 'color',
	
	  // URL to backend that requests social counts. null means "disabled"
	  backendUrl: null,
	
	  // Link to the "about" page
	  infoUrl: 'http://ct.de/-2467514',
	
	  // Type of display for the "about" page: "blank", "popup" or "self", default = "blank"
	  infoDisplay: 'blank',
	
	  // localisation: "de" or "en"
	  lang: 'de',
	
	  // fallback language for not fully localized services
	  langFallback: 'en',
	
	  mailUrl: function mailUrl() {
	    var shareUrl = url.parse(this.getURL(), true);
	    shareUrl.query.view = 'mail';
	    delete shareUrl.search;
	    return url.format(shareUrl);
	  },
	
	  mailBody: function mailBody() {
	    return this.getURL();
	  },
	
	  // Media (e.g. image) URL to be shared
	  mediaUrl: null,
	
	  // horizontal/vertical
	  orientation: 'horizontal',
	
	  // icon/icon-count/standard
	  buttonStyle: 'standard',
	
	  // a string to suffix current URL
	  referrerTrack: null,
	
	  // services to be enabled in the following order
	  services: ['twitter', 'facebook', 'info'],
	
	  title: global.document.title,
	
	  twitterVia: null,
	
	  flattrUser: null,
	
	  flattrCategory: null,
	
	  // build URI from rel="canonical" or document.location
	  url: function url() {
	    var url = global.document.location.href;
	    var canonical = $('link[rel=canonical]').attr('href') || this.getMeta('og:url') || '';
	
	    if (canonical.length > 0) {
	      if (canonical.indexOf('http') < 0) {
	        if (canonical.indexOf('//') !== 0) {
	          canonical = global.document.location.protocol + '//' + global.document.location.host + canonical;
	        } else {
	          canonical = global.document.location.protocol + canonical;
	        }
	      }
	      url = canonical;
	    }
	
	    return url;
	  }
	};
	
	var Shariff = function () {
	  function Shariff(element, options) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, Shariff);
	
	    // the DOM element that will contain the buttons
	    this.element = element;
	
	    // Ensure elemnt is empty
	    $(element).empty();
	
	    this.options = $.extend({}, Defaults, options, $(element).data());
	
	    // filter available services to those that are enabled and initialize them
	    this.services = (0, _keys2.default)(services).filter(function (service) {
	      return _this.isEnabledService(service);
	    }).sort(function (a, b) {
	      var services = _this.options.services;
	      return services.indexOf(a) - services.indexOf(b);
	    }).map(function (serviceName) {
	      return services[serviceName](_this);
	    });
	
	    this._addButtonList();
	
	    if (this.options.backendUrl !== null && this.options.buttonStyle !== 'icon') {
	      this.getShares(this._updateCounts.bind(this));
	    }
	  }
	
	  Shariff.prototype.isEnabledService = function isEnabledService(serviceName) {
	    return this.options.services.indexOf(serviceName) > -1;
	  };
	
	  Shariff.prototype.$socialshareElement = function $socialshareElement() {
	    return $(this.element);
	  };
	
	  Shariff.prototype.getLocalized = function getLocalized(data, key) {
	    if ((0, _typeof3.default)(data[key]) === 'object') {
	      if (typeof data[key][this.options.lang] === 'undefined') {
	        return data[key][this.options.langFallback];
	      } else {
	        return data[key][this.options.lang];
	      }
	    } else if (typeof data[key] === 'string') {
	      return data[key];
	    }
	    return undefined;
	  };
	
	  // returns content of <meta name="" content=""> tags or '' if empty/non existant
	
	
	  Shariff.prototype.getMeta = function getMeta(name) {
	    var metaContent = $('meta[name="' + name + '"],[property="' + name + '"]').attr('content');
	    return metaContent || '';
	  };
	
	  Shariff.prototype.getInfoUrl = function getInfoUrl() {
	    return this.options.infoUrl;
	  };
	
	  Shariff.prototype.getInfoDisplayPopup = function getInfoDisplayPopup() {
	    return this.options.infoDisplay === 'popup';
	  };
	
	  Shariff.prototype.getInfoDisplayBlank = function getInfoDisplayBlank() {
	    return this.options.infoDisplay !== 'popup' && this.options.infoDisplay !== 'self';
	  };
	
	  Shariff.prototype.getURL = function getURL() {
	    return this.getOption('url');
	  };
	
	  Shariff.prototype.getOption = function getOption(name) {
	    var option = this.options[name];
	    return typeof option === 'function' ? option.call(this) : option;
	  };
	
	  Shariff.prototype.getTitle = function getTitle() {
	    var title = this.getOption('title');
	    if ($(this.element).data()['title']) return title;
	    title = title || this.getMeta('DC.title');
	    var creator = this.getMeta('DC.creator');
	    return title && creator ? title + ' - ' + creator : title;
	  };
	
	  Shariff.prototype.getReferrerTrack = function getReferrerTrack() {
	    return this.options.referrerTrack || '';
	  };
	
	  // returns shareCounts of document
	
	
	  Shariff.prototype.getShares = function getShares(callback) {
	    var baseUrl = url.parse(this.options.backendUrl, true);
	    baseUrl.query.url = this.getURL();
	    delete baseUrl.search;
	    return $.getJSON(url.format(baseUrl), callback);
	  };
	
	  // add value of shares for each service
	
	
	  Shariff.prototype._updateCounts = function _updateCounts(data, status, xhr) {
	    var _this2 = this;
	
	    if (!data) return;
	    $.each(data, function (serviceName, value) {
	      if (!_this2.isEnabledService(serviceName)) {
	        return;
	      }
	      if (value >= 1000) {
	        value = Math.round(value / 1000) + 'k';
	      }
	      $(_this2.element).find('.' + serviceName + ' a').append($('<span/>').addClass('share_count').text(value));
	    });
	  };
	
	  // add html for button-container
	
	
	  Shariff.prototype._addButtonList = function _addButtonList() {
	    var _this3 = this;
	
	    var $buttonList = $('<ul/>').addClass(['theme-' + this.options.theme, 'orientation-' + this.options.orientation, 'button-style-' + this.options.buttonStyle, 'shariff-col-' + this.options.services.length].join(' '));
	
	    // add html for service-links
	    this.services.forEach(function (service) {
	      var $li = $('<li/>').addClass('shariff-button ' + service.name);
	      var $shareLink = $('<a/>').attr('href', service.shareUrl);
	
	      if (_this3.options.buttonStyle === 'standard') {
	        var $shareText = $('<span/>').addClass('share_text').text(_this3.getLocalized(service, 'shareText'));
	        $shareLink.append($shareText);
	      }
	
	      if (typeof service.faPrefix !== 'undefined' && typeof service.faName !== 'undefined') {
	        $shareLink.prepend($('<span/>').addClass(service.faPrefix + ' ' + service.faName));
	      }
	
	      if (service.popup) {
	        $shareLink.attr('data-rel', 'popup');
	        if (service.name !== 'info') {
	          $shareLink.attr('rel', 'nofollow');
	        }
	      } else if (service.blank) {
	        $shareLink.attr('target', '_blank');
	        if (service.name === 'info') {
	          $shareLink.attr('rel', 'noopener noreferrer');
	        } else {
	          $shareLink.attr('rel', 'nofollow noopener noreferrer');
	        }
	      } else if (service.name !== 'info') {
	        $shareLink.attr('rel', 'nofollow');
	      }
	      $shareLink.attr('title', _this3.getLocalized(service, 'title'));
	
	      // add attributes for screen readers
	      $shareLink.attr('role', 'button');
	      $shareLink.attr('aria-label', _this3.getLocalized(service, 'title'));
	
	      $li.append($shareLink);
	
	      $buttonList.append($li);
	    });
	
	    // event delegation
	    $buttonList.on('click', '[data-rel="popup"]', function (e) {
	      e.preventDefault();
	
	      var url = $(this).attr('href');
	
	      // if a twitter widget is embedded on current site twitter's widget.js
	      // will open a popup so we should not open a second one.
	      if (url.match(/twitter\.com\/intent\/(\w+)/)) {
	        var w = global.window;
	        if (w.__twttr && w.__twttr.widgets && w.__twttr.widgets.loaded) {
	          return;
	        }
	      }
	
	      global.window.open(url, '_blank', 'width=600,height=460');
	    });
	
	    this.$socialshareElement().append($buttonList);
	  };
	
	  return Shariff;
	}();
	
	module.exports = Shariff;
	
	// export Shariff class to global (for non-Node users)
	global.Shariff = Shariff;
	
	$(function () {
	  // initialize .shariff elements
	  $('.shariff').each(function () {
	    if (!this.hasOwnProperty('shariff')) {
	      this.shariff = new Shariff(this);
	    }
	  });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ "L/1q":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"detailContainer":"_2GNj5","detail_wrapper":"_3_9pr","xing":"_3osL-","mcTitle":"_1xyte","previewContainer":"tKBV8","iframe":"_3C_sC","previewImage":"_23q3n","emptyImage":"_3gjSE","imageLoaded":"_1fA8c _23q3n","mcInfo":"_3GJXx","mcDescription":"_1AFdO","backToOverviewWrap":"CiEnh","gridIconWrap":"_2lsek","social":"_2M58C","theme-round":"_36zZX","fa-spin":"_30SlO"};

/***/ },

/***/ "WYsz":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__("RIz9");
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__("IKfj");
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _dec, _class;
	// Import Components
	
	// Import styles
	
	
	var _Featured = __webpack_require__("w5UO");
	
	var _Featured2 = _interopRequireDefault(_Featured);
	
	var _Teaser = __webpack_require__("NlOW");
	
	var _Teaser2 = _interopRequireDefault(_Teaser);
	
	var _mobxReact = __webpack_require__("OSg3");
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactBootstrap = __webpack_require__("3kvR");
	
	var _style = __webpack_require__("3tVx");
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Overview component
	 */
	var Overview = (_dec = (0, _mobxReact.inject)('MediahubStore', 'ViewStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	  (0, _inherits3.default)(Overview, _Component);
	
	  function Overview() {
	    (0, _classCallCheck3.default)(this, Overview);
	    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
	  }
	
	  Overview.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        MediahubStore = _props.MediahubStore,
	        ViewStore = _props.ViewStore;
	
	    var lang = ViewStore.language;
	
	    return _react2.default.createElement(
	      'div',
	      { ref: function ref(_ref) {
	          return _this2._container = _ref;
	        }, className: _style2.default.container + ' row' },
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        !!MediahubStore.featuredMediaContainer && _react2.default.createElement(_Featured2.default, {
	          mc: MediahubStore.featuredMediaContainer }),
	        _.map(MediahubStore.channelsWithoutFeatured, function (c, index) {
	          return _react2.default.createElement(_Teaser2.default, {
	            key: 'channel_' + index,
	            index: index,
	            channelTitle: c.title,
	            channelLink: c.link,
	            channelSize: c.channelSize,
	            items: c.teasers });
	        })
	      )
	    );
	  };
	
	  return Overview;
	}(_react.Component)) || _class) || _class);
	exports.default = Overview;
	module.exports = exports['default'];

/***/ },

/***/ "3tVx":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"_2EUGC"};

/***/ },

/***/ "lVK7":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__("j1ja");
	
	var _bowser = __webpack_require__("O/+C");
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	var _AppContainer = __webpack_require__("FFCO");
	
	var _AppContainer2 = _interopRequireDefault(_AppContainer);
	
	var _IE = __webpack_require__("Yiez");
	
	var _IE2 = _interopRequireDefault(_IE);
	
	var _react = __webpack_require__("U7vG");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__("O27J");
	
	__webpack_require__("xzMi");
	
	var _stores = __webpack_require__("kWNH");
	
	var _stores2 = _interopRequireDefault(_stores);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Global scope
	
	// RequestAnimationFrame
	
	// Import dependencies
	
	// Import AppContainer container
	// BABEL polyfill for ie10
	window._ = __webpack_require__("M4fF");
	// Import stores
	
	window.moment = __webpack_require__("PJh5");
	
	// Initialize Stores
	var stores = (0, _stores2.default)();
	
	/**
	 * Render Mediahub function
	 */
	(function renderMediahub() {
	
	  // Find our mount node
	  var mountNode = document.querySelector('#root');
	
	  // Declare our appComponent
	  var isOldIE = _bowser2.default.msie && _bowser2.default.version <= 9;
	  var appComponent = isOldIE ? _react2.default.createElement(_IE2.default, null) : _react2.default.createElement(_AppContainer2.default, { stores: stores });
	
	  // Render our App component
	  (0, _reactDom.render)(appComponent, mountNode);
	})();

/***/ },

/***/ "kWNH":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.initializeStores = undefined;
	
	var _mobx = __webpack_require__("d6px");
	
	var _MediahubStore = __webpack_require__("8DSZ");
	
	var _MediahubStore2 = _interopRequireDefault(_MediahubStore);
	
	var _ViewStore = __webpack_require__("7QeO");
	
	var _ViewStore2 = _interopRequireDefault(_ViewStore);
	
	var _WallStore = __webpack_require__("iBKY");
	
	var _WallStore2 = _interopRequireDefault(_WallStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Set strick mode for stores, so you can only change state through actions
	/**
	 * State handler
	 * Mobx stores importer
	 */
	
	(0, _mobx.useStrict)(true);
	
	// Export store variable
	
	// Import stores
	var initializeStores = exports.initializeStores = function initializeStores() {
	  return {
	    MediahubStore: _MediahubStore2.default,
	    WallStore: _WallStore2.default,
	    ViewStore: _ViewStore2.default
	  };
	};
	
	exports.default = initializeStores;

/***/ },

/***/ "8DSZ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _values = __webpack_require__("0HRX");
	
	var _values2 = _interopRequireDefault(_values);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("rbbs");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
	// Import viewStore
	
	// Import API
	
	// Import Models
	
	
	var _config = __webpack_require__("QmSG");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mobx = __webpack_require__("d6px");
	
	var _ViewStore = __webpack_require__("7QeO");
	
	var _ViewStore2 = _interopRequireDefault(_ViewStore);
	
	var _api = __webpack_require__("VsUZ");
	
	var _api2 = _interopRequireDefault(_api);
	
	var _Channel = __webpack_require__("t7be");
	
	var _Channel2 = _interopRequireDefault(_Channel);
	
	var _MediaContainer = __webpack_require__("waSm");
	
	var _MediaContainer2 = _interopRequireDefault(_MediaContainer);
	
	var _Mediahub = __webpack_require__("B2J4");
	
	var _Mediahub2 = _interopRequireDefault(_Mediahub);
	
	var _SpecialChannel = __webpack_require__("krgz");
	
	var _SpecialChannel2 = _interopRequireDefault(_SpecialChannel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	/**
	 * MediahubStore Class
	 */
	var MediahubStore = (_class = function () {
	
	  /**
	   * CONSTRUCTOR
	   */
	
	
	  // Searching
	
	
	  // Sorting
	
	
	  // Search results array
	  function MediahubStore() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, MediahubStore);
	
	    _initDefineProp(this, 'mediahub', _descriptor, this);
	
	    _initDefineProp(this, 'channels', _descriptor2, this);
	
	    _initDefineProp(this, 'specialChannels', _descriptor3, this);
	
	    _initDefineProp(this, 'mediaContainers', _descriptor4, this);
	
	    _initDefineProp(this, 'currentChannelId', _descriptor5, this);
	
	    _initDefineProp(this, 'currentContainerId', _descriptor6, this);
	
	    _initDefineProp(this, 'currentContainer', _descriptor7, this);
	
	    _initDefineProp(this, 'ascending', _descriptor8, this);
	
	    _initDefineProp(this, 'sortOption', _descriptor9, this);
	
	    _initDefineProp(this, 'selectedFilters', _descriptor10, this);
	
	    _initDefineProp(this, 'searchText', _descriptor11, this);
	
	    _initDefineProp(this, 'numberOfHits', _descriptor12, this);
	
	    _initDefineProp(this, 'loadedInitialData', _descriptor13, this);
	
	    _initDefineProp(this, 'pendingRequestCount', _descriptor14, this);
	
	    _initDefineProp(this, 'nextBatchFrom', _descriptor15, this);
	
	    // LOAD MEDIAHUB !!!!
	    if (!_config2.default.includeAuthToken) {
	      this.loadMediahub();
	    } else {
	      // If there has to be a token load mediahub
	      // only after the API token is present
	      (0, _mobx.reaction)(function () {
	        return _api2.default.token;
	      }, function () {
	        _this.loadMediahub();
	      });
	    }
	
	    // SET CURRENT CHANNEL ID
	    // Via pathname change
	    (0, _mobx.autorun)(function () {
	      if (!_ViewStore2.default.currentView) return;
	      var _ViewStore$currentVie = _ViewStore2.default.currentView,
	          name = _ViewStore$currentVie.name,
	          channel = _ViewStore$currentVie.channel,
	          lang = _ViewStore$currentVie.lang;
	
	      // Find channelId based on current view
	
	      var channelId = _lodash2.default.result(_lodash2.default.find(_this.channels, function (c) {
	        return _lodash2.default.isEqual(channel, c.link) || _lodash2.default.isEqual(channel, c['link_' + lang]);
	      }), 'id', false);
	
	      if (channelId) {
	        // Set current channel ID => triggers search
	        _this.setCurrentChannelId(channelId);
	      }
	    });
	
	    // DELIVER DIRECTLINK
	    // Only when conditions are met
	    (0, _mobx.autorun)(function () {
	      if (!_ViewStore2.default.currentView) return;
	      var _ViewStore$currentVie2 = _ViewStore2.default.currentView,
	          channel = _ViewStore$currentVie2.channel,
	          detail = _ViewStore$currentVie2.detail;
	
	
	      if (detail && channel && (!_config2.default.includeAuthToken || !!_api2.default.token)) {
	        // Search for directLink
	        _this.deliverDirectLink(channel + '/' + detail);
	      }
	    });
	
	    // TRIGGER SEARCH
	    // When search conditions change
	    // Do it maximum once every 300ms
	    (0, _mobx.autorunAsync)(function () {
	      // It's needed here for when to run
	      // const filters     = this.selectedFilters.values();
	      // const sortOption  = this.sortOption;
	      // const ascending   = this.ascending;
	      var searchText = _this.searchText;
	      var channelId = _this.currentChannelId;
	
	      if (searchText || channelId) {
	        _this.queryBuilder();
	      }
	    }, 300);
	
	    // LOAD NEXT BATCH OF RESULTS
	    // For infinite wall component
	    (0, _mobx.reaction)(function () {
	      return _this.nextBatchFrom;
	    }, function () {
	      if (!!_this.nextBatchFrom && _this.nextBatchFrom < _this.numberOfHits) {
	        // console.warn("load next batch", this.nextBatchFrom);
	        _this.queryBuilder(_this.nextBatchFrom);
	      }
	    });
	
	    // DEBUGING
	    // autorun(() => {
	    //   console.info("numberOfHits", this.numberOfHits);
	    // });
	  }
	
	  // Is searching for something
	
	
	  // Loading
	
	
	  // Channel handling
	
	
	  MediahubStore.prototype.loadError = function loadError(request, error) {
	    this.pendingRequestCount--;
	    console.warn('loadError ' + request, error);
	  };
	
	  /**
	   * LOAD MEDIAHUB ACTIONS
	   */
	
	
	  MediahubStore.prototype.loadMediahub = function loadMediahub() {
	    var _this2 = this;
	
	    this.pendingRequestCount++;
	
	    _api2.default.get('init').then(function (result) {
	      return _this2.loadMediahubSuccess(result);
	    }).fail(function (err) {
	      return _this2.loadError('loadMediahub', err);
	    });
	  };
	
	  MediahubStore.prototype.loadMediahubSuccess = function loadMediahubSuccess(mediahub) {
	    this.pendingRequestCount--;
	
	    this.mediahub = new _Mediahub2.default(mediahub);
	    this.loadChannels();
	  };
	
	  /**
	   * LOAD CHANNELS ACTIONS
	   */
	
	
	  MediahubStore.prototype.loadChannels = function loadChannels() {
	    var _this3 = this;
	
	    this.pendingRequestCount++;
	
	    _api2.default.get('mediahub').then(function (result) {
	      return _this3.loadChannelsSuccess(result);
	    }).fail(function (err) {
	      return _this3.loadError('loadChannels', err);
	    });
	  };
	
	  MediahubStore.prototype.loadChannelsSuccess = function loadChannelsSuccess(channels) {
	    var _this4 = this;
	
	    this.pendingRequestCount--;
	    this.hasLoadedInitialData = true;
	
	    //sort channels according to their position
	    channels = _lodash2.default.orderBy(channels, 'sorting.pos', 'asc');
	
	    // Add special channels
	    var specials = ['publishedDate'];
	    _lodash2.default.forEach(specials, function (c) {
	      var channel = new _SpecialChannel2.default(c, false);
	      _this4.specialChannels.push(channel);
	    });
	
	    _lodash2.default.forEach(channels, function (c) {
	      var mostViewed = c.channelId === _this4.mostViewedId;
	      var channel = new _Channel2.default(c, mostViewed);
	      // Most viewed is requested to be on the top of the list
	      mostViewed ? _this4.channels.unshift(channel) : _this4.channels.push(channel);
	    });
	  };
	
	  /**
	   * DIRECT LINK ACTIONS
	   */
	
	
	  MediahubStore.prototype.deliverDirectLink = function deliverDirectLink(directLink) {
	    var _this5 = this;
	
	    this.pendingRequestCount++;
	
	    var data = {};
	
	    data['directLink'] = directLink;
	    if (_config2.default.includeAuthToken) {
	      data['token'] = _api2.default.token;
	    }
	
	    _api2.default.get('directLink', data).then(function (result) {
	      return _this5.deliverDirectLinkSuccess(result);
	    }).fail(function (err) {
	      return _this5.loadMediahubError(err);
	    });
	  };
	
	  MediahubStore.prototype.deliverDirectLinkSuccess = function deliverDirectLinkSuccess(result) {
	    var mc = _lodash2.default.head(result.hits);
	
	    if (!mc) {
	      _ViewStore2.default.language === 'en' ? _ViewStore2.default.router.navigate('channel', { lang: 'en', channel: 'english' }) : _ViewStore2.default.router.navigate('start');
	      return;
	    }
	
	    this.setCurrentChannelId(mc.channelId);
	    this.currentContainer = new _MediaContainer2.default(mc);
	  };
	
	  /**
	   * CURRENT CHANNEL AND MEDIACONTAINER ACTIONS
	   */
	
	
	  MediahubStore.prototype.setCurrentChannelId = function setCurrentChannelId(channelId) {
	    this.currentChannelId = channelId;
	    this.clearSearch();
	  };
	
	  /**
	   * SORTING ACTIONS
	   */
	
	
	  MediahubStore.prototype.sorting = function sorting(option, ascending) {
	    this.sortOption = option || this.sortOption;
	    this.ascending = ascending;
	  };
	
	  MediahubStore.prototype.initSorting = function initSorting() {
	    this.sortOption = _lodash2.default.head(_config2.default.sortOptions);
	    this.ascending = false;
	  };
	
	  /**
	   * LOAD NEXT BATCH ACTIONS
	   */
	
	
	  MediahubStore.prototype.loadNextBatch = function loadNextBatch() {
	    this.nextBatchFrom = this.mediaContainers.length;
	  };
	
	  /**
	   * SEARCH ACTIONS
	   */
	
	
	  MediahubStore.prototype.setSearchText = function setSearchText(searchText) {
	    this.searchText = searchText;
	  };
	
	  MediahubStore.prototype.setSearchFilter = function setSearchFilter(filter, type) {
	    var valueArray = _lodash2.default.join(filter, ',');
	
	    if (!valueArray) {
	      this.selectedFilters.delete(type);
	    } else {
	      this.selectedFilters.set(type, valueArray);
	    }
	  };
	
	  MediahubStore.prototype.clearSearch = function clearSearch() {
	    // Clear search inputs
	    this.searchText = '';
	    this.selectedFilters.clear();
	
	    // Return to initial sorting
	    this.ascending = false;
	    this.sortOption = _lodash2.default.head(_config2.default.sortOptions);
	  };
	
	  /**
	   * SEARCH RESULTS ACTIONS
	   */
	
	
	  MediahubStore.prototype.queryBuilder = function queryBuilder(nextBatchFrom) {
	    // Prepare params object
	    var params = {};
	
	    // Prepare filters array
	    var filter = [];
	
	    var must = [];
	
	    var nestedQuery = {
	      "nested": {
	        "path": "links",
	        "query": {
	          "bool": {
	            "filter": [{
	              "terms": {
	                "links.language": [_ViewStore2.default.language]
	              }
	            }]
	          }
	        }
	      }
	    };
	
	    must.push(nestedQuery);
	
	    // Add selected filters to filters array
	    this.selectedFilters.forEach(function (value, key) {
	      var terms = {};
	      terms[key] = _lodash2.default.compact(_lodash2.default.split(value, ','));
	
	      if (key === 'orientation') {
	        var orientationArr = [];
	
	        _lodash2.default.forEach(terms[key], function (mode) {
	          if (_lodash2.default.isEqual(mode, 'landscape')) {
	            orientationArr.push(1, 2, 3, 4);
	          }
	          if (_lodash2.default.isEqual(mode, 'portrait')) {
	            orientationArr.push(5, 6, 7, 8);
	          }
	        });
	
	        terms[key] = orientationArr;
	      }
	
	      if (_lodash2.default.size(terms[key])) {
	        filter.push({ terms: terms });
	      }
	    });
	
	    // Add search term if search text isn't empty
	    if (!this.searchTextEmpty) {
	      params['searchTerm'] = this.searchText;
	    }
	
	    // If there is no search term add sorting options
	    if (this.searchTextEmpty) {
	      var sortOrder = {};
	      sortOrder[this.sortOption] = {
	        order: this.ascending ? 'asc' : 'desc'
	      };
	      params['sort'] = [sortOrder];
	    }
	
	    // If there are no filters yet or search text add channelId
	    if (!_lodash2.default.size(filter) && !this.searchText && this.currentChannelId) {
	      filter.push({ term: { channelId: this.currentChannelId } }
	      // { term: { language: ViewStore.language } },
	      );
	    }
	
	    // Add filters and nested query to the query
	    if (_lodash2.default.size(filter)) {
	      params['query'] = {
	        bool: { filter: filter, must: must }
	      };
	    }
	
	    // Add from param in case of loading next batch
	    if (nextBatchFrom) {
	      params['from'] = nextBatchFrom;
	    } else {
	      // Empty out array
	      this.mediaContainers = [];
	    }
	
	    // Add auth token
	    if (_config2.default.includeAuthToken) {
	      params['token'] = _api2.default.token;
	    }
	
	    // Perform the search
	    this.search(params);
	  };
	
	  MediahubStore.prototype.search = function search(data) {
	    var _this6 = this;
	
	    this.pendingRequestCount++;
	
	    _api2.default.post('search', { data: data }).then(function (result) {
	      return _this6.searchSuccess(result);
	    }).fail(function (err) {
	      return _this6.loadError('search 1', err);
	    });
	  };
	
	  // TODO -> abstract this whole block cause it's in 3 places
	  // from searchSuccess till deliverThumbsSuccess
	
	
	  MediahubStore.prototype.searchSuccess = function searchSuccess(result) {
	    var _this7 = this;
	
	    this.pendingRequestCount--;
	    var channelMediaContainerIds = [];
	
	    this.numberOfHits = result.numberOfHits;
	
	    if (_lodash2.default.isEqual(result.from, 0)) {
	      this.mediaContainers = [];
	    }
	
	    if (this.mediaContainers.length <= this.numberOfHits) {
	      // Add MediaContainers
	      _lodash2.default.forEach(result.hits, function (mc) {
	        var mediaContainer = new _MediaContainer2.default(mc);
	        _this7.mediaContainers.push(mediaContainer);
	        channelMediaContainerIds.push({
	          mediaContainerId: mc.mediaContainerId,
	          channelId: mc.channelId
	        });
	      });
	    }
	
	    // Deliver thumbnails for search results
	    this.deliverThumbs({ channelMediaContainerIds: channelMediaContainerIds });
	  };
	
	  MediahubStore.prototype.deliverThumbs = function deliverThumbs(data) {
	    var _this8 = this;
	
	    this.pendingRequestCount++;
	
	    data.previewImages = true;
	    data.width = 480;
	
	    _api2.default.post('deliverThumbs', { data: data }).then(function (result) {
	      return _this8.deliverThumbsSuccess(result);
	    }).fail(function (err) {
	      return _this8.loadError('deliverThumbs', err);
	    });
	  };
	
	  MediahubStore.prototype.deliverThumbsSuccess = function deliverThumbsSuccess(thumbs) {
	    var _this9 = this;
	
	    this.pendingRequestCount--;
	    var thumbsByMc = _lodash2.default.groupBy(thumbs, 'mediaContainerId');
	
	    _lodash2.default.forEach(thumbsByMc, function (value, key) {
	      var mcs = _lodash2.default.filter(_this9.mediaContainers, { id: _lodash2.default.toInteger(key) });
	      _lodash2.default.forEach(mcs, function (mc) {
	        mc.setThumbnails(value);
	      });
	    });
	  };
	
	  (0, _createClass3.default)(MediahubStore, [{
	    key: 'isSearching',
	    get: function get() {
	      return !this.searchTextEmpty || !!this.selectedFilters.size;
	    }
	  }, {
	    key: 'searchTextEmpty',
	    get: function get() {
	      return _lodash2.default.isEmpty(this.searchText);
	    }
	  }, {
	    key: 'isLoading',
	    get: function get() {
	      return this.pendingRequestCount > 0;
	    }
	  }, {
	    key: 'currentChannel',
	    get: function get() {
	      var _this10 = this;
	
	      return this.channels.find(function (c) {
	        return c.id === _this10.currentChannelId;
	      }) || false;
	    }
	  }, {
	    key: 'featuredId',
	    get: function get() {
	      return this.isDev ? _config2.default.featuredChannelIdDev : _config2.default.featuredChannelId;
	    }
	  }, {
	    key: 'mostViewedId',
	    get: function get() {
	      return this.isDev ? _config2.default.mostViewedChannelIdDev : _config2.default.mostViewedChannelId;
	    }
	  }, {
	    key: 'channelsWithoutFeatured',
	    get: function get() {
	      var _this11 = this;
	
	      var channels = this.channels.slice();
	      var LANGUAGE_CHANNELS = {
	        en: 'english',
	        pl: 'polski',
	        fr: 'francais'
	      };
	      var LANGUAGE_CHANNEL_LIST = (0, _values2.default)(LANGUAGE_CHANNELS);
	
	      if (_lodash2.default.startsWith(_ViewStore2.default.currentPath, '/de')) {
	        return channels.filter(function (c) {
	          return c.id !== _this11.featuredId && !_lodash2.default.includes(LANGUAGE_CHANNEL_LIST, c.link);
	        });
	      }
	
	      if (_lodash2.default.startsWith(_ViewStore2.default.currentPath, '/pl')) {
	        return channels.filter(function (c) {
	          return c.link == LANGUAGE_CHANNELS.pl;
	        });
	      }
	
	      if (_lodash2.default.startsWith(_ViewStore2.default.currentPath, '/fr')) {
	        return channels.filter(function (c) {
	          return c.link == LANGUAGE_CHANNELS.fr;
	        });
	      }
	
	      return channels.filter(function (c) {
	        return c.link == LANGUAGE_CHANNELS.en;
	      });
	    }
	  }, {
	    key: 'featuredChannel',
	    get: function get() {
	      var _this12 = this;
	
	      return this.channels.find(function (c) {
	        return c.id === _this12.featuredId;
	      }) || {};
	    }
	  }, {
	    key: 'featuredMediaContainer',
	    get: function get() {
	      var mediaContainers = _lodash2.default.sortBy(_lodash2.default.result(this.featuredChannel, 'teasers', []), 'sortCriteria');
	      return _lodash2.default.head(mediaContainers);
	    }
	  }, {
	    key: 'isDev',
	    get: function get() {
	      return _api2.default.host().indexOf('apidev') > -1;
	    }
	
	    /**
	     * GENERAL LOAD ERROR ACTION
	     * Use in all failed responses
	     */
	
	  }]);
	  return MediahubStore;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'mediahub', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return {};
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'channels', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return [];
	  }
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'specialChannels', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return [];
	  }
	}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'mediaContainers', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return [];
	  }
	}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'currentChannelId', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'currentContainerId', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'currentContainer', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return {};
	  }
	}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'ascending', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, 'sortOption', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return _lodash2.default.head(_config2.default.sortOptions);
	  }
	}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, 'selectedFilters', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return _mobx.observable.map({});
	  }
	}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, 'searchText', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return '';
	  }
	}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, 'numberOfHits', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, 'loadedInitialData', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, 'pendingRequestCount', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, 'nextBatchFrom', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _applyDecoratedDescriptor(_class.prototype, 'isSearching', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isSearching'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'searchTextEmpty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'searchTextEmpty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isLoading', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isLoading'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'currentChannel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'currentChannel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'channelsWithoutFeatured', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'channelsWithoutFeatured'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'featuredChannel', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'featuredChannel'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'featuredMediaContainer', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'featuredMediaContainer'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadError', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadMediahub', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadMediahub'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadMediahubSuccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadMediahubSuccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadChannels', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadChannels'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadChannelsSuccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadChannelsSuccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deliverDirectLink', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deliverDirectLink'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deliverDirectLinkSuccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deliverDirectLinkSuccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setCurrentChannelId', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setCurrentChannelId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'sorting', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'sorting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'initSorting', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'initSorting'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadNextBatch', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadNextBatch'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSearchText', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setSearchText'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setSearchFilter', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setSearchFilter'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'clearSearch', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'clearSearch'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'queryBuilder', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'queryBuilder'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'search', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'search'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'searchSuccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'searchSuccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deliverThumbs', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deliverThumbs'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deliverThumbsSuccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deliverThumbsSuccess'), _class.prototype)), _class);
	
	
	var mediahubStore = new MediahubStore();
	exports.default = mediahubStore;
	module.exports = exports['default'];

/***/ },

/***/ "7QeO":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("rbbs");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8; // import various utils
	
	// Import router5
	
	// Import MediahubStore
	
	
	// Verge for dimensions
	
	
	var _config = __webpack_require__("QmSG");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mobx = __webpack_require__("d6px");
	
	var _router = __webpack_require__("N70D");
	
	var _router2 = _interopRequireDefault(_router);
	
	var _browser = __webpack_require__("vF5d");
	
	var _browser2 = _interopRequireDefault(_browser);
	
	var _listeners = __webpack_require__("U9Hq");
	
	var _listeners2 = _interopRequireDefault(_listeners);
	
	var _api = __webpack_require__("VsUZ");
	
	var _api2 = _interopRequireDefault(_api);
	
	var _porthole = __webpack_require__("9vrF");
	
	var _porthole2 = _interopRequireDefault(_porthole);
	
	var _MediahubStore = __webpack_require__("8DSZ");
	
	var _MediahubStore2 = _interopRequireDefault(_MediahubStore);
	
	var _verge = __webpack_require__("mPS7");
	
	var _verge2 = _interopRequireDefault(_verge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	var MOBILE_WIDTH = _config2.default.mobileWidth;
	var VALID_LANGUAGES = _config2.default.validLanguages;
	
	// Import translations
	var translations = {
	  de: __webpack_require__("vErg"),
	  en: __webpack_require__("cXVW"),
	  pl: __webpack_require__("uvIH"),
	  fr: __webpack_require__("OBa7")
	};
	
	/**
	 * ViewStore Class
	 *
	 * It designed for handling:
	 *  - routing and navigation
	 *  - window and elements dimensions
	 *  - various UI toggles
	 *  - language and translations
	 */
	var ViewStore = (_class = function () {
	
	  // Current view with name and all route params
	  function ViewStore() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, ViewStore);
	
	    _initDefineProp(this, 'currentView', _descriptor, this);
	
	    _initDefineProp(this, 'isMobileNavOpen', _descriptor2, this);
	
	    _initDefineProp(this, 'isAdvancedOpen', _descriptor3, this);
	
	    _initDefineProp(this, 'containerHeight', _descriptor4, this);
	
	    _initDefineProp(this, 'containerWidth', _descriptor5, this);
	
	    _initDefineProp(this, 'parentWinHeight', _descriptor6, this);
	
	    _initDefineProp(this, 'parentScrollTop', _descriptor7, this);
	
	    this.updateScroll = _lodash2.default.debounce((0, _mobx.action)(function (scroll) {
	      _this.parentScrollTop = scroll;
	    }), 10);
	
	    _initDefineProp(this, 'parentTopOffset', _descriptor8, this);
	
	    this.updateTopOffset = _lodash2.default.debounce((0, _mobx.action)(function (parentTopOffset) {
	      _this.parentTopOffset = parentTopOffset;
	    }), 10);
	
	    // Setup Porthole
	    window.windowProxy = new _porthole2.default.WindowProxy(_config2.default.portholeProxy);
	    // Add event listener
	    window.windowProxy.addEventListener(function (msg) {
	      return _this.portholeMessage(msg);
	    });
	
	    // Initialize router
	    this.router = (0, _router2.default)([{ name: 'start', path: '/' }, { name: 'overview', path: '/:lang' }, { name: 'channel', path: '/:lang/:channel' }, { name: 'detail', path: '/:lang/:channel/:detail' }])
	
	    // Register plugins
	    .usePlugin((0, _browser2.default)()).usePlugin((0, _listeners2.default)())
	
	    // Register listeners
	    .addListener(function (toState, fromState) {
	      return _this.setCurrentView(toState.name, toState.params, toState.path);
	    });
	
	    // Start the router
	    this.router.start();
	
	    // Check dimensions on each 1s interval
	    window.setInterval(function () {
	      return _this.updateDimensions();
	    }, 1000);
	
	    // Update parent only when containerHeight changes
	    (0, _mobx.autorun)(function () {
	      return window.windowProxy.post({ height: _this.containerHeight });
	    });
	
	    // Update parent with path
	    (0, _mobx.reaction)(function () {
	      return _this.currentView;
	    }, function () {
	      // Scroll window to top
	      window.scrollTo(0, 0);
	      window.windowProxy.post({ scroll: 0 });
	      // Send current path to parent
	      _this.sendPath();
	    });
	  }
	
	  // For responsiveness
	
	
	  // Dimensions
	
	
	  // Toggles
	
	
	  /**
	   * Porthole event listener
	   */
	  ViewStore.prototype.portholeMessage = function portholeMessage(message) {
	    var token = _lodash2.default.result(message, 'data.tkn');
	    var language = _lodash2.default.result(message, 'data.language');
	    var directLink = _lodash2.default.result(message, 'data.directLink');
	    var scroll = _lodash2.default.result(message, 'data.scroll');
	    var iframeOffset = _lodash2.default.result(message, 'data.iframeOffset');
	    var winHeight = _lodash2.default.result(message, 'data.winHeight');
	
	    // Set API token
	    if (token) {
	      _api2.default.setToken(token);
	    }
	
	    // Set language from parent
	    if (!directLink && language) {
	      this.router.navigate('overview', { lang: language });
	    }
	
	    // Set directLink from parent
	    if (directLink) {
	      var linkParts = _lodash2.default.compact(_lodash2.default.split(directLink, '/'));
	      var lang = _lodash2.default.nth(linkParts, 0);
	      var channel = _lodash2.default.nth(linkParts, 1);
	      var detail = _lodash2.default.nth(linkParts, 2);
	      var params = _lodash2.default.omitBy({ lang: lang, channel: channel, detail: detail }, _lodash2.default.isUndefined);
	
	      var name = void 0;
	
	      if (params.detail) {
	        name = 'detail';
	      } else {
	        if (params.channel) {
	          name = 'channel';
	        } else {
	          name = 'overview';
	        }
	      }
	
	      if (!_lodash2.default.isEqual(directLink, window.location.pathname)) {
	        this.router.navigate(name, params);
	      }
	    }
	
	    // Set parent scroll position
	    if (scroll) {
	      this.updateScroll(scroll);
	    }
	    // Set iframe top offset
	    if (iframeOffset) {
	      this.updateTopOffset(iframeOffset);
	    }
	    // Set parent window height
	    if (winHeight) {
	      this.updateParentWinHeight(winHeight);
	    }
	  };
	
	  /**
	   * PORTHOLE update URL of parent with current path
	   */
	
	
	  ViewStore.prototype.sendPath = function sendPath() {
	    var directLink = window.location.pathname;
	    window.windowProxy.post({ directLink: directLink });
	  };
	
	  /**
	   * ROUTING ACTIONS
	   */
	
	
	  ViewStore.prototype.setCurrentView = function setCurrentView(name, params, path) {
	    var lang = this.getLanguage(_lodash2.default.result(params, 'lang', ''));
	
	    if (lang === 'de') {
	      if (name == 'start') {
	        this.router.navigate('overview', { lang: 'de' });
	        return;
	      }
	
	      var _currentView = params;
	      _currentView.name = name;
	      _currentView.lang = lang;
	      _currentView.path = path;
	
	      this.currentView = _currentView;
	      return;
	    }
	
	    var LANGUAGE_CHANNELS = {
	      en: 'english',
	      pl: 'polski',
	      fr: 'francais'
	    };
	
	    if (name === 'channel' && params.channel !== LANGUAGE_CHANNELS.en && params.lang === 'en') {
	      this.router.navigate('overview', { lang: 'en' });
	      return;
	    }
	    if (name === 'channel' && params.channel === LANGUAGE_CHANNELS.en && params.lang !== 'en') {
	      this.router.navigate('overview', { lang: params.lang });
	      return;
	    }
	
	    if (name === 'channel' && params.channel !== LANGUAGE_CHANNELS.pl && params.lang === 'pl') {
	      this.router.navigate('overview', { lang: 'pl' });
	      return;
	    }
	    if (name === 'channel' && params.channel === LANGUAGE_CHANNELS.pl && params.lang !== 'pl') {
	      this.router.navigate('overview', { lang: params.lang });
	      return;
	    }
	
	    if (name === 'channel' && params.channel !== LANGUAGE_CHANNELS.fr && params.lang === 'fr') {
	      this.router.navigate('overview', { lang: 'fr' });
	      return;
	    }
	    if (name === 'channel' && params.channel === LANGUAGE_CHANNELS.fr && params.lang !== 'fr') {
	      this.router.navigate('overview', { lang: params.lang });
	      return;
	    }
	
	    // /en -> /en/english
	    if (name == 'start') {
	      this.router.navigate('channel', { lang: lang, channel: LANGUAGE_CHANNELS[lang] });
	      return;
	    }
	    if (name === 'overview' && !this.currentView) {
	      this.router.navigate('channel', { lang: lang, channel: LANGUAGE_CHANNELS[lang] });
	      return;
	    }
	
	    var currentView = params;
	    currentView.name = name;
	    currentView.lang = lang;
	    currentView.path = path;
	
	    this.currentView = currentView;
	  };
	
	  /**
	   * NAVIGATION HELPERS
	   */
	
	
	  ViewStore.prototype.isViewActive = function isViewActive(to, linkChannel, linkPage) {
	    if (!this.currentView) return false;
	    var _currentView2 = this.currentView,
	        name = _currentView2.name,
	        channel = _currentView2.channel,
	        detail = _currentView2.detail,
	        page = _currentView2.page;
	
	
	    if (detail) {
	      return _lodash2.default.isEqual(channel, linkChannel);
	    }
	
	    if (page) {
	      return _lodash2.default.isEqual(page, linkPage);
	    }
	
	    return _lodash2.default.isEqual(name, to) && _lodash2.default.isEqual(channel, linkChannel);
	  };
	
	  /**
	   * DIMENSIONS ACTIONS
	   */
	
	
	  ViewStore.prototype.updateDimensions = function updateDimensions() {
	    var elem = document.getElementById('root');
	    var rect = _verge2.default.rectangle(elem);
	    var width = rect.width;
	    var height = rect.height;
	
	    if (this.containerHeight !== height) {
	      this.containerHeight = height;
	    }
	
	    if (this.containerWidth !== width) {
	      this.containerWidth = width;
	    }
	  };
	
	  ViewStore.prototype.updateParentWinHeight = function updateParentWinHeight(winHeight) {
	    this.parentWinHeight = winHeight;
	  };
	
	  /**
	   * TOGGLES ACTIONS
	   */
	
	
	  ViewStore.prototype.toggleMobileNav = function toggleMobileNav(bool) {
	    this.isMobileNavOpen = bool || !this.isMobileNavOpen;
	  };
	
	  ViewStore.prototype.toggleAdvancedSearch = function toggleAdvancedSearch(bool) {
	    this.isAdvancedOpen = bool || !this.isAdvancedOpen;
	  };
	
	  /**
	   * LANGUAGE HELPERS
	   */
	
	
	  ViewStore.prototype.getLanguage = function getLanguage(language) {
	    language = language || this.getNavigatorLanguage();
	    return _lodash2.default.indexOf(VALID_LANGUAGES, language) > -1 ? language : _lodash2.default.head(VALID_LANGUAGES); // de is the default
	  };
	
	  ViewStore.prototype.getNavigatorLanguage = function getNavigatorLanguage() {
	    var navigatorLanguage = _lodash2.default.head(_lodash2.default.compact(_lodash2.default.split(_lodash2.default.result(window, 'navigator.userLanguage'), '-', 1))) || _lodash2.default.head(_lodash2.default.compact(_lodash2.default.split(_lodash2.default.result(window, 'navigator.language'), '-', 1)));
	
	    var deReferrer = document.referrer.indexOf('/de/') > -1;
	
	    // NOTE Just in case we need language from parent not through prothole
	    // return deReferrer
	    //         ? _.head(VALID_LANGUAGES) // de is the default
	    //         // : navigatorLanguage;
	    //         : _.last(VALID_LANGUAGES); // en as fallback
	
	    return _lodash2.default.head(VALID_LANGUAGES); // de is the default
	  };
	
	  ViewStore.prototype.get = function get(word) {
	    return translations[this.language || 'de'][word] || '**' + word + '**';
	  };
	
	  ViewStore.prototype.getValidLanguages = function getValidLanguages() {
	    return VALID_LANGUAGES;
	  };
	
	  (0, _createClass3.default)(ViewStore, [{
	    key: 'isMobile',
	    get: function get() {
	      return this.containerWidth < MOBILE_WIDTH;
	    }
	
	    // For convinience
	
	  }, {
	    key: 'language',
	    get: function get() {
	      return this.currentView ? this.currentView.lang : "";
	    }
	  }, {
	    key: 'currentViewName',
	    get: function get() {
	      return this.currentView ? this.currentView.name : "";
	    }
	  }, {
	    key: 'currentPath',
	    get: function get() {
	      return this.currentView ? this.currentView.path : "";
	    }
	  }]);
	  return ViewStore;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'currentView', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return null;
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'isMobileNavOpen', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'isAdvancedOpen', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'containerHeight', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return window.innerHeight;
	  }
	}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'containerWidth', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return window.innerWidth;
	  }
	}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'parentWinHeight', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'parentScrollTop', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, 'parentTopOffset', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _applyDecoratedDescriptor(_class.prototype, 'isMobile', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isMobile'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'language', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'language'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'currentViewName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'currentViewName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'currentPath', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'currentPath'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setCurrentView', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setCurrentView'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateDimensions', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateDimensions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateParentWinHeight', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateParentWinHeight'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleMobileNav', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleMobileNav'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'toggleAdvancedSearch', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'toggleAdvancedSearch'), _class.prototype)), _class);
	
	
	var viewStore = new ViewStore();
	exports.default = viewStore;
	module.exports = exports['default'];

/***/ },

/***/ "iBKY":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("rbbs");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
	// Import Stores
	
	
	var _config = __webpack_require__("QmSG");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _mobx = __webpack_require__("d6px");
	
	var _MediahubStore = __webpack_require__("8DSZ");
	
	var _MediahubStore2 = _interopRequireDefault(_MediahubStore);
	
	var _ViewStore = __webpack_require__("7QeO");
	
	var _ViewStore2 = _interopRequireDefault(_ViewStore);
	
	var _verge = __webpack_require__("mPS7");
	
	var _verge2 = _interopRequireDefault(_verge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	// Some defaults
	var MAX_ITEMS_PER_ROW = 2;
	var ITEM_RATIO = 0.5625;
	var BUFFER = 2;
	var GUTTER = 20;
	var MOBILE_HEIGHT = 80;
	var MOBILE_WIDTH = _config2.default.mobileWidth;
	var MIN_ITEM_WIDTH = (MOBILE_WIDTH + 1) / 2;
	
	/**
	 * InfiniteWallStore Class
	 */
	var InfiniteWallStore = (_class = function () {
	  function InfiniteWallStore() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, InfiniteWallStore);
	
	    _initDefineProp(this, 'scrollY', _descriptor, this);
	
	    _initDefineProp(this, 'scrollD', _descriptor2, this);
	
	    _initDefineProp(this, 'wrapperW', _descriptor3, this);
	
	    _initDefineProp(this, 'itemsCount', _descriptor4, this);
	
	    // autorun(() => {
	    //   this.updateScroll(ViewStore.parentScrollTop);
	    // });
	
	    (0, _mobx.reaction)(function () {
	      return _this.shouldLoadNextBatch;
	    }, function () {
	      if (_this.shouldLoadNextBatch) {
	        _MediahubStore2.default.loadNextBatch();
	      }
	    });
	  }
	
	  InfiniteWallStore.prototype.getPosition = function getPosition(index) {
	    var gutter = !_.isEqual(this.itemsPerRow, 1) ? this.itemsPerRow * GUTTER / (this.itemsPerRow - 1) : 0;
	
	    var rowIndex = Math.floor(index / this.itemsPerRow);
	    var posX = (index - rowIndex * this.itemsPerRow) * (this.itemW + gutter);
	    var posY = rowIndex * this.itemH;
	
	    return { posX: posX, posY: posY };
	  };
	
	  InfiniteWallStore.prototype.updateItemsCount = function updateItemsCount(itemsCount) {
	    this.itemsCount = itemsCount;
	  };
	
	  InfiniteWallStore.prototype.updateDimensions = function updateDimensions(elem) {
	    var scrollY = _verge2.default.scrollY() || _ViewStore2.default.parentScrollTop;
	    var rect = _verge2.default.rectangle(elem);
	
	    this.wrapperW = rect.width;
	    this.scrollD = _verge2.default.scrollY() + rect.top + _ViewStore2.default.parentTopOffset;
	    this.scrollY = scrollY;
	  };
	
	  InfiniteWallStore.prototype.updateScroll = function updateScroll() {
	    // We don't have to worry about unnecessary updates
	    var scrollY = _verge2.default.scrollY() || _ViewStore2.default.parentScrollTop;
	    this.scrollY = scrollY;
	
	    // Put's scroll updates in requestAnimationFrame
	    this.rAF = window.requestAnimationFrame(this.updateScroll.bind(this));
	
	    // It returns a function because it's possible then
	    // to callcancelAnimationFrame in the wall component
	    return function () {
	      window.cancelAnimationFrame(this.rAF);
	    }.bind(this);
	  };
	
	  (0, _createClass3.default)(InfiniteWallStore, [{
	    key: 'isMobile',
	    get: function get() {
	      return this.wrapperW <= MOBILE_WIDTH;
	    }
	  }, {
	    key: 'itemsPerRow',
	    get: function get() {
	      var itemsPerRow = Math.floor(this.wrapperW / MIN_ITEM_WIDTH);
	      return Math.min(itemsPerRow, MAX_ITEMS_PER_ROW);
	    }
	  }, {
	    key: 'rowCount',
	    get: function get() {
	      return Math.ceil(this.itemsCount / this.itemsPerRow) || 0;
	    }
	  }, {
	    key: 'wrapperH',
	    get: function get() {
	      return Math.ceil(this.rowCount * this.itemH);
	    }
	  }, {
	    key: 'itemW',
	    get: function get() {
	      var width = this.wrapperW / this.itemsPerRow || 0;
	      return _.isEqual(this.itemsPerRow, 1) ? width : width - GUTTER;
	    }
	  }, {
	    key: 'itemH',
	    get: function get() {
	      return this.isMobile ? ITEM_RATIO * this.itemW / 2 + GUTTER : ITEM_RATIO * this.itemW + MOBILE_HEIGHT;
	    }
	  }, {
	    key: 'scrollTop',
	    get: function get() {
	      return Math.max(0, this.scrollY - this.scrollD) || 0;
	    }
	  }, {
	    key: 'rowsAbove',
	    get: function get() {
	      return Math.max(0, Math.floor(this.scrollTop / this.itemH)) || 0;
	    }
	  }, {
	    key: 'visibleRows',
	    get: function get() {
	      var winH = _ViewStore2.default.parentWinHeight || _verge2.default.viewportH();
	      return Math.ceil((this.rowsAbove * this.itemH + Math.min(winH, this.wrapperH)) / this.itemH) || 0;
	    }
	  }, {
	    key: 'indexStart',
	    get: function get() {
	      return Math.max(0, Math.min(this.itemsCount - 1, (this.rowsAbove - BUFFER) * this.itemsPerRow)) || 0;
	    }
	  }, {
	    key: 'indexEnd',
	    get: function get() {
	      return Math.min(this.itemsCount, (this.visibleRows + BUFFER) * this.itemsPerRow) || this.itemsCount;
	    }
	  }, {
	    key: 'shouldLoadNextBatch',
	    get: function get() {
	      return this.indexEnd >= this.itemsCount;
	    }
	  }, {
	    key: 'indexes',
	    get: function get() {
	      // Computes an array of indexes for layouting purposes
	      var indexes = [];
	      var i = this.indexStart;
	      for (i; i < this.indexEnd; i++) {
	        indexes.push(i);
	      }
	      return indexes;
	    }
	  }]);
	  return InfiniteWallStore;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'scrollY', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'scrollD', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'wrapperW', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'itemsCount', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _applyDecoratedDescriptor(_class.prototype, 'isMobile', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isMobile'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'itemsPerRow', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'itemsPerRow'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'rowCount', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'rowCount'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'wrapperH', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'wrapperH'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'itemW', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'itemW'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'itemH', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'itemH'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'scrollTop', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'scrollTop'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'rowsAbove', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'rowsAbove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'visibleRows', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'visibleRows'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'indexStart', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'indexStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'indexEnd', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'indexEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'shouldLoadNextBatch', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'shouldLoadNextBatch'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'indexes', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'indexes'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateItemsCount', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateItemsCount'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateDimensions', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateDimensions'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'updateScroll', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'updateScroll'), _class.prototype)), _class);
	
	
	var wallStore = new InfiniteWallStore();
	exports.default = wallStore;
	module.exports = exports['default'];

/***/ },

/***/ "vErg":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  home: 'Übersicht',
	  channels: 'Channels',
	  lastChannelUpdates: 'Letzte Aktualisierungen',
	  topics: 'Themen',
	  noTitle: 'Kein Titel',
	  noDescription: 'Keine Beschreibung',
	  imageMap: 'Bildermappe',
	  de: 'deutsch',
	  en: 'english',
	  contact: 'Kontakt',
	  imprint: 'Impressum',
	  legal: 'Legal',
	  downloads: 'Download',
	  downloadTitle: 'Video herunterladen:',
	  // downloadDescription:          '',
	  directLinks: 'Link',
	  directLinkTitle: 'Video Link',
	  // directLinkDescription:        '',
	  shortlink: 'Shortlink',
	  //
	  browseCategories: 'Kategorie wählen',
	  //
	  prepareDownload: 'Download wird vorbereitet...',
	  //
	  contactPerson: 'Ansprechpartner',
	  contactCompany: 'Unternehmen',
	  contactOccupation: 'Position',
	  contactPhone: 'Telefon',
	  contactEmail: 'E-mail',
	  mediahubTechError: 'Bei Aufruf dieser Seite ist ein technisches Problem aufgetreten. Bitte nehmen Sie Kontakt mit der Versender des Links auf.',
	  mediahubNotYetAvailable: 'Diese Seite ist noch nicht verfügbar. Bitte besuchen Sie uns wieder ab dem ',
	  mediahubNoLongerAvailable: 'Diese Seite ist nicht mehr verfügbar seit dem ',
	  mediahubMaxDownloads: 'Die maximale Anzahl von Aufrufen für diese Seite ist überschritten.',
	  // zoomTurnedOff:                '',
	  // zoomTurnedOn:                 '',
	  //additional information
	  additionalMedia: 'Weitere Downloads',
	  additionalMediaContainer: 'Weitere Videos zu',
	  moreVideos: 'Weitere Videos',
	  start: 'Veröffentlichung von:',
	  end: 'bis:',
	  //authentication
	  authenticationRequired: 'Authentifizierung ist erforderlich.',
	  authUsername: 'Username',
	  authPassword: 'Passwort',
	  authLogin: 'Login',
	  authWrong: 'Username oder Passwort sind nicht korrekt. Bitte versuchen Sie es erneut.',
	  //videorelated
	  videoSize: 'Auflösung',
	  fileSize: 'Dateigröße',
	  formatDownloads: 'Downloadformate',
	  download: 'Download',
	  mediaNotAvailable: 'Video ist für Download nicht verfügbar.',
	  // QualityOfVideo
	  hd: 'HD',
	  timeout: 'Die Gültigkeit der Seite ist abgelaufen.',
	  timeoutDescription: 'Aus Sicherheitsgründen sind alle Seiten nur für eine begrenzte Zeit gültig. Bitte nutzen Sie die RELOAD-Funktion Ihres Browsers um diese Seite erneut zu laden.',
	  noDataForMediaHub: 'Keine Medien gefunden',
	  noDataForMediaHubDescription: 'Mit diesem MediaHub sind keine Medien verknüpft.',
	  mediahub: 'MediaHub',
	  loading: '...loading',
	  //media
	  title: 'Titel',
	  description: 'Beschreibung',
	  videoDescription: 'Videobeschreibung',
	  mediaDescription: 'Beschreibung',
	  // search
	  search: 'Suche',
	  searchResults: 'Ergebnisse',
	  // Player Overlay
	  playerOverlayViews: 'Aufrufe:',
	  playerOverlayDate: 'Datum:',
	  playerOverlayTags: 'Tags:',
	  // Breadcrumb
	  breadcrumbYouAreHere: 'Sie sind hier:',
	  breadCrumbHomepage: 'Startseite',
	  breadCrumbSlider: 'Im Slider',
	  // Errors
	  unauthorized: 'Fehler 401 - Nicht Authorisiert',
	  forbidden: 'Fehler 403 - Zugang verboten',
	  notFound: 'Fehler 404 - Seite nicht gefunden',
	  serverError: 'Fehler 500 - Interner Server Fehler',
	  error404p1: 'Die von Ihnen angeforderte Seite wurde nicht gefunden.',
	  error404p2: 'Bitte prüfen Sie die eingegebene Adresse.',
	  error404p3: 'Für weitere Informationen kontaktieren Sie uns ',
	  error404contact: 'hier',
	  //empty
	  emptyString: ' ',
	  backToOverview: 'Zurück zur Übersicht',
	  showAll: 'Alle anzeigen',
	  showMore: 'Mehr Videos zeigen',
	  all: 'Alle',
	  filter_countEmbeds: 'Meistgesehene Videos',
	  filter_createdAt: 'Neueste Videos',
	  filter_meta_productionDate: 'Neueste Videos',
	  filter_publishedDate: 'Neueste Videos',
	  noCreationDate: 'Kein Erstellungsdatum',
	  video: 'Videos',
	  watchVideo: 'Video ansehen',
	  sharePost: 'Teilen Sie diesen Beitrag'
	};

/***/ },

/***/ "cXVW":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  home: 'Übersicht',
	  channels: 'Channels',
	  lastChannelUpdates: 'Last Channel Updates',
	  topics: 'Topics',
	  noTitle: 'No title',
	  noDescription: 'No description found',
	  imageMap: 'Image map',
	  de: 'deutsch',
	  en: 'english',
	  contact: 'Contact',
	  imprint: 'Imprint',
	  legal: 'Legal',
	  downloads: 'Download',
	  downloadTitle: 'Download video:',
	  downloadDescription: '',
	  directLinks: 'Link',
	  directLinkTitle: 'Video link',
	  directLinkDescription: '',
	  shortlink: 'Shortlink',
	  //
	  browseCategories: 'Select category',
	  //
	  prepareDownload: 'Preparing download...',
	  //
	  contactPerson: 'Contact person',
	  contactCompany: 'Company',
	  contactOccupation: 'Occupation',
	  contactPhone: 'Phone',
	  contactEmail: 'E-mail',
	  mediahubTechError: 'An error occurred while we tried to display this page. Please contact the person who have sent you this link.',
	  mediahubNotYetAvailable: 'This page is not yet available. Please visit this page again on ',
	  mediahubNoLongerAvailable: 'This page is not available since ',
	  mediahubMaxDownloads: 'The maximum number of requests for this page is reached.',
	  zoomTurnedOff: 'Enable image zoom',
	  zoomTurnedOn: 'Disable image zoom',
	  //additional information
	  additionalMedia: 'Additional downloads',
	  additionalMediaContainer: 'More Videos about',
	  moreVideos: 'More videos',
	  start: 'Available from:',
	  end: 'to:',
	  //authentication
	  authenticationRequired: 'Authentication required to access this page.',
	  authUsername: 'Username',
	  authPassword: 'Password',
	  authLogin: 'Login',
	  authWrong: 'Wrong authentication. Please try again.',
	  //videorelated
	  videoSize: 'Size',
	  fileSize: 'File size',
	  formatDownloads: 'Download formats',
	  download: 'Download',
	  mediaNotAvailable: 'Video is not available for download.',
	  // QualityOfVideo
	  hd: 'HD',
	  timeout: 'The page has timed out.',
	  timeoutDescription: 'For security reasons this page was only valid for a certain amount of time. Please use your browser\'s refresh button to go back to the page.',
	  noDataForMediaHub: 'No media files present',
	  noDataForMediaHubDescription: 'There are no media files connected with this mediahub.',
	  mediahub: 'MediaHub',
	  loading: '...loading',
	  //media
	  title: 'Title',
	  description: 'Description',
	  videoDescription: 'Description',
	  mediaDescription: 'Description',
	  // search
	  search: 'Search',
	  searchResults: 'Results',
	  // Player Overlay
	  playerOverlayViews: 'Views:',
	  playerOverlayDate: 'Date:',
	  playerOverlayTags: 'Tags:',
	  // Breadcrumb
	  breadcrumbYouAreHere: 'You are here:',
	  breadCrumbHomepage: 'Homepage',
	  breadCrumbSlider: 'In slider',
	  // Errors
	  unauthorized: '401 - Unauthorized',
	  forbidden: '403 - Forbidden',
	  notFound: '404 - Publicarea could not be found.',
	  serverError: '500 - Internal server error',
	  error404p1: 'The page you are looking for could not be found.',
	  error404p2: 'Please check the address.',
	  error404p3: 'For more information please contact us ',
	  error404contact: 'here',
	  //empty
	  emptyString: ' ',
	  backToOverview: 'Back to Overview',
	  showAll: 'Show all',
	  showMore: 'Show more videos',
	  all: 'All',
	  filter_countEmbeds: 'Most viewed videos',
	  filter_createdAt: 'Latest videos',
	  filter_publishedDate: 'Latest videos',
	  noCreationDate: 'No creation date',
	  video: 'Videos',
	  watchVideo: 'Watch video',
	  sharePost: 'Share this video'
	
	};

/***/ },

/***/ "OBa7":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    home: 'Accueil',
	    channels: 'Chaînes',
	    lastChannelUpdates: 'Dernières mises à jour de la chaîne',
	    topics: 'Sujets',
	    noTitle: 'Pas de titre',
	    noDescription: 'Aucune description trouvée',
	    imageMap: 'Carte d\'image',
	    de: 'allemand',
	    en: 'anglais',
	    contact: 'Contact',
	    imprint: 'Mentions légales',
	    legal: 'Juridique',
	    downloads: 'Téléchargements',
	    downloadTitle: 'Télécharger la vidéo :',
	    downloadDescription: '',
	    directLinks: 'Lien',
	    directLinkTitle: 'Lien vidéo',
	    directLinkDescription: '',
	    shortlink: 'Lien court',
	    //
	    browseCategories: 'Sélectionner une catégorie',
	    //
	    prepareDownload: 'Préparation du téléchargement...',
	    //
	    contactPerson: 'Personne de contact',
	    contactCompany: 'Société',
	    contactOccupation: 'Profession',
	    contactPhone: 'Téléphone',
	    contactEmail: 'E-mail',
	    mediahubTechError: 'Une erreur s\'est produite lorsque nous avons essayé d\'afficher cette page. Veuillez contacter la personne qui vous a envoyé ce lien.',
	    mediahubNotYetAvailable: 'Cette page n\'est pas encore disponible. Veuillez la revisiter le ',
	    mediahubNoLongerAvailable: 'Cette page n\'est plus disponible depuis le ',
	    mediahubMaxDownloads: 'Le nombre maximal de demandes pour cette page a été atteint.',
	    zoomTurnedOff: 'Activer le zoom d\'image',
	    zoomTurnedOn: 'Désactiver le zoom d\'image',
	    // Informations supplémentaires
	    additionalMedia: 'Téléchargements supplémentaires',
	    additionalMediaContainer: 'Plus de vidéos sur',
	    moreVideos: 'Plus de vidéos',
	    start: 'Disponible à partir de :',
	    end: 'jusqu\'à :',
	    // Authentification
	    authenticationRequired: 'Authentification requise pour accéder à cette page.',
	    authUsername: 'Nom d\'utilisateur',
	    authPassword: 'Mot de passe',
	    authLogin: 'Connexion',
	    authWrong: 'Authentification incorrecte. Veuillez réessayer.',
	    // Lié à la vidéo
	    videoSize: 'Taille',
	    fileSize: 'Taille du fichier',
	    formatDownloads: 'Formats de téléchargement',
	    download: 'Télécharger',
	    mediaNotAvailable: 'La vidéo n\'est pas disponible en téléchargement.',
	    // Qualité de la vidéo
	    hd: 'HD',
	    timeout: 'La page a expiré.',
	    timeoutDescription: 'Pour des raisons de sécurité, cette page n\'était valide que pendant une certaine période. Veuillez utiliser le bouton de rafraîchissement de votre navigateur pour revenir à la page.',
	    noDataForMediaHub: 'Aucun fichier multimédia présent',
	    noDataForMediaHubDescription: 'Aucun fichier multimédia n\'est connecté à ce mediahub.',
	    mediahub: 'MediaHub',
	    loading: '...chargement',
	    // Média
	    title: 'Titre',
	    description: 'Description',
	    videoDescription: 'Description',
	    mediaDescription: 'Description',
	    // Recherche
	    search: 'Recherche',
	    searchResults: 'Résultats',
	    // Superposition du lecteur
	    playerOverlayViews: 'Vues :',
	    playerOverlayDate: 'Date :',
	    playerOverlayTags: 'Tags :',
	    // Fil d'Ariane
	    breadcrumbYouAreHere: 'Vous êtes ici :',
	    breadCrumbHomepage: 'Page d\'accueil',
	    breadCrumbSlider: 'Dans le curseur',
	    // Erreurs
	    unauthorized: '401 - Non autorisé',
	    forbidden: '403 - Interdit',
	    notFound: '404 - L\'espace publicitaire n\'a pas pu être trouvé.',
	    serverError: '500 - Erreur interne du serveur',
	    error404p1: 'La page que vous recherchez est introuvable.',
	    error404p2: 'Veuillez vérifier l\'adresse.',
	    error404p3: 'Pour plus d\'informations, veuillez nous contacter ',
	    error404contact: 'ici',
	    // Vide
	    emptyString: ' ',
	    backToOverview: 'Retour à l\'aperçu',
	    showAll: 'Afficher tout',
	    showMore: 'Afficher plus de vidéos',
	    all: 'Tout',
	    filter_countEmbeds: 'Vidéos les plus vues',
	    filter_createdAt: 'Dernières vidéos',
	    filter_publishedDate: 'Dernières vidéos',
	    noCreationDate: 'Pas de date de création',
	    video: 'Vidéos',
	    watchVideo: 'Regarder la vidéo',
	    sharePost: 'Partager cette vidéo'
	};

/***/ },

/***/ "uvIH":
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    home: 'Strona główna',
	    channels: 'Kanały',
	    lastChannelUpdates: 'Ostatnie aktualizacje kanałów',
	    topics: 'Tematy',
	    noTitle: 'Brak tytułu',
	    noDescription: 'Nie znaleziono opisu',
	    imageMap: 'Mapa obrazu',
	    de: 'niemiecki',
	    en: 'angielski',
	    contact: 'Kontakt',
	    imprint: 'Odbitka',
	    legal: 'Prawny',
	    downloads: 'Pobieranie',
	    downloadTitle: 'Pobierz wideo:',
	    downloadDescription: '',
	    directLinks: 'Link',
	    directLinkTitle: 'Link do wideo',
	    directLinkDescription: '',
	    shortlink: 'Skrócony link',
	    //
	    browseCategories: 'Wybierz kategorię',
	    //
	    prepareDownload: 'Przygotowywanie do pobrania...',
	    //
	    contactPerson: 'Osoba kontaktowa',
	    contactCompany: 'Firma',
	    contactOccupation: 'Zawód',
	    contactPhone: 'Telefon',
	    contactEmail: 'E-mail',
	    mediahubTechError: 'Wystąpił błąd podczas próby wyświetlenia tej strony. Skontaktuj się z osobą, która wysłała Ci ten link.',
	    mediahubNotYetAvailable: 'Ta strona nie jest jeszcze dostępna. Proszę odwiedzić ją ponownie ',
	    mediahubNoLongerAvailable: 'Ta strona nie jest dostępna od ',
	    mediahubMaxDownloads: 'Osiągnięto maksymalną liczbę żądań dla tej strony.',
	    zoomTurnedOff: 'Włącz zoom obrazu',
	    zoomTurnedOn: 'Wyłącz zoom obrazu',
	    //dodatkowe informacje
	    additionalMedia: 'Dodatkowe pliki do pobrania',
	    additionalMediaContainer: 'Więcej filmów na temat',
	    moreVideos: 'Więcej filmów',
	    start: 'Dostępne od:',
	    end: 'do:',
	    //uwierzytelnianie
	    authenticationRequired: 'Wymagane uwierzytelnianie, aby uzyskać dostęp do tej strony.',
	    authUsername: 'Nazwa użytkownika',
	    authPassword: 'Hasło',
	    authLogin: 'Zaloguj się',
	    authWrong: 'Błędne uwierzytelnianie. Spróbuj ponownie.',
	    //związane z wideo
	    videoSize: 'Rozmiar',
	    fileSize: 'Rozmiar pliku',
	    formatDownloads: 'Formaty pobierania',
	    download: 'Pobierz',
	    mediaNotAvailable: 'Wideo nie jest dostępne do pobrania.',
	    // Jakość wideo
	    hd: 'HD',
	    timeout: 'Strona przekroczyła czas oczekiwania.',
	    timeoutDescription: 'Z powodów bezpieczeństwa ta strona była ważna przez określony czas. Użyj przycisku odświeżania w przeglądarce, aby powrócić do strony.',
	    noDataForMediaHub: 'Brak plików multimedialnych',
	    noDataForMediaHubDescription: 'Nie ma plików multimedialnych związanych z tym mediahubem.',
	    mediahub: 'MediaHub',
	    loading: '...ładowanie',
	    //media
	    title: 'Tytuł',
	    description: 'Opis',
	    videoDescription: 'Opis',
	    mediaDescription: 'Opis',
	    //wyszukiwanie
	    search: 'Szukaj',
	    searchResults: 'Wyniki',
	    // Nakładka odtwarzacza
	    playerOverlayViews: 'Odsłony:',
	    playerOverlayDate: 'Data:',
	    playerOverlayTags: 'Tagi:',
	    // Chlebki
	    breadcrumbYouAreHere: 'Jesteś tutaj:',
	    breadCrumbHomepage: 'Strona główna',
	    breadCrumbSlider: 'W suwaku',
	    // Błędy
	    unauthorized: '401 - Nieautoryzowany',
	    forbidden: '403 - Zakazany',
	    notFound: '404 - Nie można znaleźć publicznej przestrzeni.',
	    serverError: '500 - Wewnętrzny błąd serwera',
	    error404p1: 'Strona, której szukasz, nie została odnaleziona.',
	    error404p2: 'Sprawdź adres.',
	    error404p3: 'W celu uzyskania dodatkowych informacji skontaktuj się z nami ',
	    error404contact: 'tutaj',
	    //puste
	    emptyString: ' ',
	    backToOverview: 'Powrót do przeglądu',
	    showAll: 'Pokaż wszystko',
	    showMore: 'Pokaż więcej filmów',
	    all: 'Wszystko',
	    filter_countEmbeds: 'Najczęściej oglądane filmy',
	    filter_createdAt: 'Najnowsze filmy',
	    filter_publishedDate: 'Najnowsze filmy',
	    noCreationDate: 'Brak daty utworzenia',
	    video: 'Filmy',
	    watchVideo: 'Obejrzyj film',
	    sharePost: 'Udostępnij ten film'
	};

/***/ },

/***/ "t7be":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("rbbs");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
	// Import other stores
	
	// Import API
	
	// Import the MediaContainer Class
	
	
	var _config = __webpack_require__("QmSG");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _mobx = __webpack_require__("d6px");
	
	var _MediahubStore = __webpack_require__("8DSZ");
	
	var _MediahubStore2 = _interopRequireDefault(_MediahubStore);
	
	var _ViewStore = __webpack_require__("7QeO");
	
	var _ViewStore2 = _interopRequireDefault(_ViewStore);
	
	var _api = __webpack_require__("VsUZ");
	
	var _api2 = _interopRequireDefault(_api);
	
	var _helpers = __webpack_require__("c/9r");
	
	var _MediaContainer = __webpack_require__("waSm");
	
	var _MediaContainer2 = _interopRequireDefault(_MediaContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	/**
	 * Channel Class
	 */
	var Channel = (_class = function () {
	
	  /**
	   * CONSTRUCTOR
	   */
	
	
	  // Channel Data
	  function Channel(channel, mostViewed) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, Channel);
	
	    _initDefineProp(this, 'pendingRequestCount', _descriptor, this);
	
	    _initDefineProp(this, 'id', _descriptor2, this);
	
	    _initDefineProp(this, 'metadata', _descriptor3, this);
	
	    _initDefineProp(this, 'previewImages', _descriptor4, this);
	
	    _initDefineProp(this, 'mostViewed', _descriptor5, this);
	
	    _initDefineProp(this, 'teasers', _descriptor6, this);
	
	    _initDefineProp(this, 'channelSize', _descriptor7, this);
	
	    this.id = _.result(channel, 'channelId', null);
	    this.metadata = _.result(channel, 'metadata', []);
	    this.previewImages = _.result(channel, 'previewImages', []);
	    this.mostViewed = mostViewed;
	
	    (0, _mobx.autorun)(function () {
	      var currentChannel = _MediahubStore2.default.currentChannel;
	      var currentViewName = _ViewStore2.default.currentViewName;
	
	      if (!_this.hasLoadedInitialData && (_.isEqual(_this.id, currentChannel.id) || _.isEqual(currentViewName, 'overview'))) {
	        _this.loadTeasers();
	      }
	    });
	  }
	
	  /**
	   * COMPUTED VALUES
	   */
	
	  Channel.prototype.loadTeasers = function loadTeasers() {
	    var _this2 = this;
	
	    this.pendingRequestCount++;
	
	    var data = {};
	
	    var sortOrder = {};
	    var sortOption = _.head(_config2.default.sortOptions);
	
	    sortOrder[sortOption] = {
	      order: 'desc'
	    };
	
	    var filter = [];
	    var must = [];
	
	    var nestedQuery = {
	      "nested": {
	        "path": "links",
	        "query": {
	          "bool": {
	            "filter": [{
	              "terms": {
	                "links.language": [_ViewStore2.default.language]
	              }
	            }]
	          }
	        }
	      }
	    };
	
	    filter.push({ terms: { channelId: [this.id] } });
	
	    must.push(nestedQuery);
	
	    data['query'] = { bool: { filter: filter, must: must } };
	    data['sort'] = [sortOrder];
	    data['size'] = _config2.default.channelPreviewCount;
	
	    if (_config2.default.includeAuthToken) {
	      data['token'] = _api2.default.token;
	    }
	
	    _api2.default.post('search', { data: data }).then(function (result) {
	      return _this2.loadTeasersSuccess(result);
	    }).fail(function (err) {
	      return _this2.loadError('search 3', err);
	    });
	  };
	
	  Channel.prototype.loadError = function loadError(request, error) {
	    this.pendingRequestCount--;
	    console.warn('loadError ' + request, error);
	  };
	
	  // TODO -> abstract this whole block cause it's in 3 places
	  // from loadTeasersSuccess till deliverThumbsSuccess
	
	
	  Channel.prototype.loadTeasersSuccess = function loadTeasersSuccess(result) {
	    var _this3 = this;
	
	    this.pendingRequestCount--;
	    var channelMediaContainerIds = [];
	
	    this.channelSize = result.numberOfHits;
	    if (this.mostViewed) {
	      result.hits = _.sortBy(result.hits, 'sortCriteria');
	    }
	    var ids = _.map(result.hits, 'mediaContainerId');
	
	    _.forEach(result.hits, function (mc) {
	      var mediaContainer = new _MediaContainer2.default(mc);
	      _this3.teasers.push(mediaContainer);
	      channelMediaContainerIds.push({
	        mediaContainerId: mc.mediaContainerId,
	        channelId: mc.channelId
	      });
	    });
	
	    if (_.size(ids)) {
	      this.deliverThumbs({ channelMediaContainerIds: channelMediaContainerIds });
	    }
	  };
	
	  Channel.prototype.deliverThumbs = function deliverThumbs(data) {
	    var _this4 = this;
	
	    this.pendingRequestCount++;
	
	    data['previewImages'] = true;
	    data['width'] = 480;
	
	    if (_config2.default.includeAuthToken) {
	      data['token'] = _api2.default.token;
	    }
	
	    _api2.default.post('deliverThumbs', { data: data }) // TODO add auth ???
	    .then(function (result) {
	      return _this4.deliverThumbsSuccess(result);
	    }).fail(function (err) {
	      return _this4.loadError('deliverThumbs', err);
	    });
	  };
	
	  Channel.prototype.deliverThumbsSuccess = function deliverThumbsSuccess(thumbs) {
	    var _this5 = this;
	
	    this.pendingRequestCount--;
	    var thumbsByMc = _.groupBy(thumbs, 'mediaContainerId');
	
	    _.forEach(thumbsByMc, function (value, key) {
	      var mcs = _.filter(_this5.teasers, { id: _.toInteger(key) });
	      _.forEach(mcs, function (mc) {
	        mc.setThumbnails(value);
	      });
	    });
	  };
	
	  (0, _createClass3.default)(Channel, [{
	    key: 'title',
	    get: function get() {
	      return (0, _helpers.getMetadata)(this.metadata, 'channel_name', _ViewStore2.default.language);
	    }
	  }, {
	    key: 'link',
	    get: function get() {
	      return (0, _helpers.getLinkFromChannelTitle)(this.title);
	    }
	  }, {
	    key: 'link_en',
	    get: function get() {
	      return (0, _helpers.getLinkFromChannelTitle)((0, _helpers.getMetadata)(this.metadata, 'channel_name', 'en'));
	    }
	  }, {
	    key: 'link_de',
	    get: function get() {
	      return (0, _helpers.getLinkFromChannelTitle)((0, _helpers.getMetadata)(this.metadata, 'channel_name', 'de'));
	    }
	  }, {
	    key: 'description',
	    get: function get() {
	      return (0, _helpers.getMetadata)(this.metadata, 'channel_description', _ViewStore2.default.language);
	    }
	  }, {
	    key: 'thumbnail',
	    get: function get() {
	      return (0, _helpers.getPreviewImage)(this.previewImages, 260);
	    }
	  }, {
	    key: 'hasLoadedInitialData',
	    get: function get() {
	      return this.teasers.length;
	    }
	
	    /**
	     * ACTIONS
	     */
	
	  }]);
	  return Channel;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'pendingRequestCount', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.observable], {
	  enumerable: true,
	  initializer: null
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'metadata', [_mobx.observable], {
	  enumerable: true,
	  initializer: null
	}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'previewImages', [_mobx.observable], {
	  enumerable: true,
	  initializer: null
	}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'mostViewed', [_mobx.observable], {
	  enumerable: true,
	  initializer: null
	}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, 'teasers', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return [];
	  }
	}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, 'channelSize', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _applyDecoratedDescriptor(_class.prototype, 'title', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'title'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'link', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'link'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'link_en', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'link_en'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'link_de', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'link_de'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'description', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'description'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'thumbnail', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'thumbnail'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasLoadedInitialData', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hasLoadedInitialData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadTeasers', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadTeasers'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadError', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadTeasersSuccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadTeasersSuccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deliverThumbs', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deliverThumbs'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deliverThumbsSuccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deliverThumbsSuccess'), _class.prototype)), _class);
	exports.default = Channel;
	module.exports = exports['default'];

/***/ },

/***/ "waSm":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("rbbs");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _desc, _value, _class, _descriptor, _descriptor2;
	// Import stores
	
	// Import API
	
	
	var _config = __webpack_require__("QmSG");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _mobx = __webpack_require__("d6px");
	
	var _MediahubStore = __webpack_require__("8DSZ");
	
	var _MediahubStore2 = _interopRequireDefault(_MediahubStore);
	
	var _ViewStore = __webpack_require__("7QeO");
	
	var _ViewStore2 = _interopRequireDefault(_ViewStore);
	
	var _api = __webpack_require__("VsUZ");
	
	var _api2 = _interopRequireDefault(_api);
	
	var _helpers = __webpack_require__("c/9r");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	/**
	 * MediaContainer Class
	 */
	var MediaContainer = (_class = function () {
	  function MediaContainer(mediaContainer) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, MediaContainer);
	
	    _initDefineProp(this, 'content', _descriptor, this);
	
	    _initDefineProp(this, 'thumbs', _descriptor2, this);
	
	    this.content = mediaContainer;
	
	    // Load high resultion images for currentContainer type image
	    (0, _mobx.autorun)(function () {
	      if (_.isEqual(_MediahubStore2.default.currentContainer, _this) && _.isEqual(_this.type, 'image') && !_this.previewImage) {
	        // Deliver download links
	        _this.deliverDownloadLink();
	      }
	    });
	  }
	
	  MediaContainer.prototype.setThumbnails = function setThumbnails(thumbs) {
	    var _this2 = this;
	
	    _.forEach(thumbs, function (t) {
	      _this2.thumbs.push(t);
	    });
	  };
	
	  /**
	   * Get images for current mediaContainer
	   */
	
	
	  MediaContainer.prototype.deliverDownloadLink = function deliverDownloadLink() {
	    var _this3 = this;
	
	    var data = {
	      'ids': [this.id],
	      'channelId': this.channelId,
	      'download': true
	    };
	
	    if (data.download) {
	      data.previewImages = true;
	    }
	
	    _.forEach(['original', 240], function (downloadLink) {
	      if (_.isInteger(downloadLink)) {
	        data['width'] = downloadLink;
	      }
	
	      if (_config2.default.includeAuthToken) {
	        data['token'] = _api2.default.token;
	      }
	
	      _api2.default.post('deliverThumbs', { data: data }).then(function (result) {
	        return _this3.setThumbnails(result);
	      });
	    });
	  };
	
	  (0, _createClass3.default)(MediaContainer, [{
	    key: 'id',
	    get: function get() {
	      return this.content.mediaContainerId;
	    }
	  }, {
	    key: 'channelId',
	    get: function get() {
	      return this.content.channelId;
	    }
	  }, {
	    key: 'title',
	    get: function get() {
	      return (0, _helpers.getMetaForMC)(this.content, 'container_name', _ViewStore2.default.language);
	    }
	  }, {
	    key: 'description',
	    get: function get() {
	      return (0, _helpers.getMetaForMC)(this.content, 'container_description', _ViewStore2.default.language);
	    }
	  }, {
	    key: 'fileName',
	    get: function get() {
	      var _content = this.content,
	          fileName = _content.fileName,
	          fileExtension = _content.fileExtension;
	
	      var name = _.truncate(fileName, {
	        'length': 20,
	        'separator': ' '
	      });
	      return name + '.' + fileExtension;
	    }
	  }, {
	    key: 'meta_copyright',
	    get: function get() {
	      return (0, _helpers.getMetaForMC)(this.content, 'meta_copyright', _ViewStore2.default.language);
	    }
	  }, {
	    key: 'thumbnail',
	    get: function get() {
	      // return _.result(_.head(this.thumbs), 'signedUrl', '');
	      return (0, _helpers.getPreviewImage)(this.thumbs, 240);
	    }
	  }, {
	    key: 'previewImage',
	    get: function get() {
	      return (0, _helpers.getPreviewImage)(this.thumbs, 1280);
	    }
	  }, {
	    key: 'directLink',
	    get: function get() {
	      // If directLinks returns empty array then use the channel id instead
	      var directLink = (0, _helpers.getDirectLink)(this.content.directLinks, _ViewStore2.default.language) || this.channelId + '/' + this.id;
	      return directLink;
	    }
	  }, {
	    key: 'sortCriteria',
	    get: function get() {
	      return this.content.sortCriteria;
	    }
	  }, {
	    key: 'tags',
	    get: function get() {
	      return this.content.tags_full;
	    }
	  }, {
	    key: 'type',
	    get: function get() {
	      return this.content.type;
	    }
	  }, {
	    key: 'player',
	    get: function get() {
	      var link = _.result(this.content, 'player', '');
	
	      if (!link) {
	        return link;
	      }
	
	      var apiLink = _api2.default.getEnv() === "DEV" ? 'https://playerdev.admiralcloud.com/#' + link : 'https://playerdev2.admiralcloud.com/#' + link;
	
	      var hash = apiLink.split('#')[1];
	
	      if (hash) {
	        hash = hash.replace('?', '~~~').replace(/\?/g, '&').replace('~~~', '?');
	
	        var baseUrl = apiLink.split('#')[0];
	        var mediaContainerId = hash.split('?')[0];
	        var optionalQuery = hash.split('?')[1];
	
	        apiLink = baseUrl + '?v=' + mediaContainerId;
	        if (optionalQuery) {
	          apiLink += '&' + optionalQuery;
	        }
	      }
	
	      return apiLink;
	    }
	  }, {
	    key: 'created',
	    get: function get() {
	      var created = this.content.publishedDate;
	
	      return !!created ? moment(created).format('DD.MM.YYYY') : _ViewStore2.default.get('noCreationDate');
	    }
	  }, {
	    key: 'duration',
	    get: function get() {
	      var duration = moment(this.content.duration || 0).format('m:ss');
	      return duration + ' Min';
	    }
	
	    /**
	     * Set thumbs action
	     */
	
	  }]);
	  return MediaContainer;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'content', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return {};
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'thumbs', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return [];
	  }
	}), _applyDecoratedDescriptor(_class.prototype, 'id', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'id'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'channelId', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'channelId'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'title', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'title'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'description', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'description'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'fileName', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'fileName'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'meta_copyright', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'meta_copyright'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'thumbnail', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'thumbnail'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'previewImage', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'previewImage'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'directLink', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'directLink'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'sortCriteria', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'sortCriteria'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'tags', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'tags'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'type'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'player', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'player'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'created', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'created'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'duration', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'duration'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'setThumbnails', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setThumbnails'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deliverDownloadLink', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deliverDownloadLink'), _class.prototype)), _class);
	exports.default = MediaContainer;
	module.exports = exports['default'];

/***/ },

/***/ "B2J4":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("rbbs");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3;
	// Import viewStore
	
	
	var _mobx = __webpack_require__("d6px");
	
	var _ViewStore = __webpack_require__("7QeO");
	
	var _ViewStore2 = _interopRequireDefault(_ViewStore);
	
	var _helpers = __webpack_require__("c/9r");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	/**
	 * Mediahub Class
	 */
	var Mediahub = (_class = function () {
	  function Mediahub(mediahub) {
	    (0, _classCallCheck3.default)(this, Mediahub);
	
	    _initDefineProp(this, 'link', _descriptor, this);
	
	    _initDefineProp(this, 'metadata', _descriptor2, this);
	
	    _initDefineProp(this, 'type', _descriptor3, this);
	
	    this.link = _.result(mediahub, 'link', '');
	    this.type = _.result(mediahub, 'type', 'mediahub');
	    this.metadata = _.result(mediahub, 'metadata', []);
	  }
	
	  (0, _createClass3.default)(Mediahub, [{
	    key: 'title',
	    get: function get() {
	      return (0, _helpers.getMetadata)(this.metadata, 'container_name', _ViewStore2.default.language);
	    }
	  }, {
	    key: 'description',
	    get: function get() {
	      return (0, _helpers.getMetadata)(this.metadata, 'container_description', _ViewStore2.default.language);
	    }
	  }]);
	  return Mediahub;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'link', [_mobx.observable], {
	  enumerable: true,
	  initializer: null
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'metadata', [_mobx.observable], {
	  enumerable: true,
	  initializer: null
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'type', [_mobx.observable], {
	  enumerable: true,
	  initializer: null
	}), _applyDecoratedDescriptor(_class.prototype, 'title', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'title'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'description', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'description'), _class.prototype)), _class);
	exports.default = Mediahub;
	module.exports = exports['default'];

/***/ },

/***/ "krgz":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__("rbbs");
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
	// Import viewStore
	
	// Import API
	
	// Import the MediaContainer Class
	
	
	var _config = __webpack_require__("QmSG");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _mobx = __webpack_require__("d6px");
	
	var _ViewStore = __webpack_require__("7QeO");
	
	var _ViewStore2 = _interopRequireDefault(_ViewStore);
	
	var _api = __webpack_require__("VsUZ");
	
	var _api2 = _interopRequireDefault(_api);
	
	var _helpers = __webpack_require__("c/9r");
	
	var _MediaContainer = __webpack_require__("waSm");
	
	var _MediaContainer2 = _interopRequireDefault(_MediaContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	/**
	 * SpecialChannel Class
	 */
	var SpecialChannel = (_class = function () {
	
	  /**
	   * CONSTRUCTOR
	   */
	  function SpecialChannel(sortOption, sortOrderAsc) {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, SpecialChannel);
	
	    _initDefineProp(this, 'pendingRequestCount', _descriptor, this);
	
	    _initDefineProp(this, 'teasers', _descriptor2, this);
	
	    _initDefineProp(this, 'sortOption', _descriptor3, this);
	
	    _initDefineProp(this, 'sortOrderAsc', _descriptor4, this);
	
	    this.sortOption = sortOption;
	    this.sortOrderAsc = sortOrderAsc;
	
	    (0, _mobx.autorun)(function () {
	      var currentViewName = _ViewStore2.default.currentViewName;
	
	      if (!_this.hasLoadedInitialData && (_.isEqual(currentViewName, 'detail') || _.isEqual(currentViewName, 'overview'))) {
	        _this.loadTeasers();
	      }
	    });
	  }
	
	  SpecialChannel.prototype.loadTeasers = function loadTeasers() {
	    var _this2 = this;
	
	    var sortOption = this.sortOption;
	    var sortOrderAsc = this.sortOrderAsc;
	
	    this.pendingRequestCount++;
	
	    var data = {};
	    var sort = {};
	
	    sort[sortOption] = {
	      order: sortOrderAsc ? 'asc' : 'desc'
	    };
	
	    var filter = [];
	    var must = [];
	
	    var nestedQuery = {
	      "nested": {
	        "path": "links",
	        "query": {
	          "bool": {
	            "filter": [{
	              "terms": {
	                "links.language": [_ViewStore2.default.language]
	              }
	            }]
	          }
	        }
	      }
	
	      // filter.push(
	      //   { terms: { channelId: [this.id] } }
	      // );
	
	    };must.push(nestedQuery);
	
	    data['query'] = { bool: { filter: filter, must: must } };
	
	    // filter.push(
	    //   { terms: { language: [ViewStore.language] } },
	    // );
	
	    data['sort'] = [sort];
	    data['query'] = { bool: { filter: filter, must: must } };
	    data['size'] = _config2.default.channelPreviewCount + 4;
	
	    if (_config2.default.includeAuthToken) {
	      data['token'] = _api2.default.token;
	    }
	
	    _api2.default.post('search', { data: data }).then(function (result) {
	      return _this2.loadTeasersSuccess(result);
	    }).fail(function (err) {
	      return _this2.loadError('search 2', err);
	    });
	  };
	
	  SpecialChannel.prototype.loadError = function loadError(request, error) {
	    this.pendingRequestCount--;
	    console.warn('loadError ' + request, error);
	  };
	
	  SpecialChannel.prototype.loadTeasersSuccess = function loadTeasersSuccess(result) {
	    var _this3 = this;
	
	    var channelMediaContainerIds = [];
	
	    result.hits = _.slice(_.uniqBy(result.hits, 'mediaContainerId'), 0, _config2.default.channelPreviewCount);
	    this.pendingRequestCount--;
	
	    _.forEach(result.hits, function (mc) {
	      var mediaContainer = new _MediaContainer2.default(mc);
	      _this3.teasers.push(mediaContainer);
	      channelMediaContainerIds.push({
	        mediaContainerId: mc.mediaContainerId,
	        channelId: mc.channelId
	      });
	    });
	
	    this.deliverThumbs({ channelMediaContainerIds: channelMediaContainerIds });
	  };
	
	  SpecialChannel.prototype.deliverThumbs = function deliverThumbs(data) {
	    var _this4 = this;
	
	    this.pendingRequestCount++;
	
	    data['previewImages'] = true;
	    data['width'] = 480;
	
	    if (_config2.default.includeAuthToken) {
	      data['token'] = _api2.default.token;
	    }
	
	    _api2.default.post('deliverThumbs', { data: data }) // TODO add auth ???
	    .then(function (result) {
	      return _this4.deliverThumbsSuccess(result);
	    }).fail(function (err) {
	      return _this4.loadError('deliverThumbs', err);
	    });
	  };
	
	  SpecialChannel.prototype.deliverThumbsSuccess = function deliverThumbsSuccess(thumbs) {
	    var _this5 = this;
	
	    this.pendingRequestCount--;
	    var thumbsByMc = _.groupBy(thumbs, 'mediaContainerId');
	
	    _.forEach(thumbsByMc, function (value, key) {
	      var mcs = _.filter(_this5.teasers, { id: _.toInteger(key) });
	      _.forEach(mcs, function (mc) {
	        mc.setThumbnails(value);
	      });
	    });
	  };
	
	  (0, _createClass3.default)(SpecialChannel, [{
	    key: 'title',
	    get: function get() {
	      var title = this.sortOption || 'noTitle';
	      return _ViewStore2.default.get('filter_' + title);
	    }
	  }, {
	    key: 'hasLoadedInitialData',
	    get: function get() {
	      return this.teasers.length;
	    }
	
	    /**
	     * ACTIONS
	     */
	
	  }]);
	  return SpecialChannel;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'pendingRequestCount', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return 0;
	  }
	}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'teasers', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return [];
	  }
	}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'sortOption', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return '';
	  }
	}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'sortOrderAsc', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return false;
	  }
	}), _applyDecoratedDescriptor(_class.prototype, 'title', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'title'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'hasLoadedInitialData', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'hasLoadedInitialData'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadTeasers', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadTeasers'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadError', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadError'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'loadTeasersSuccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'loadTeasersSuccess'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deliverThumbs', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deliverThumbs'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deliverThumbsSuccess', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deliverThumbsSuccess'), _class.prototype)), _class);
	exports.default = SpecialChannel;
	module.exports = exports['default'];

/***/ },

/***/ "GKcl":
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"subline":"_3sEKs"};

/***/ },

/***/ "xzMi":
/***/ function(module, exports) {

	'use strict';
	
	(function () {
	
	  var lastTime = 0;
	  var vendors = ['ms', 'moz', 'webkit', 'o'];
	  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	  }
	
	  if (!window.requestAnimationFrame) {
	    window.requestAnimationFrame = function (callback, element) {
	      var currTime = new Date().getTime();
	      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	      var id = window.setTimeout(function () {
	        callback(currTime + timeToCall);
	      }, timeToCall);
	      lastTime = currTime + timeToCall;
	      return id;
	    };
	  }
	
	  if (!window.cancelAnimationFrame) {
	    window.cancelAnimationFrame = function (id) {
	      clearTimeout(id);
	    };
	  }
	})();

/***/ },

/***/ "VsUZ":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__("XhVP");
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	var _getOwnPropertyDescriptor = __webpack_require__("QkrG");
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	var _stringify = __webpack_require__("UvFP");
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _keys = __webpack_require__("mleP");
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__("rLg+");
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _desc, _value, _class, _descriptor;
	
	var _config = __webpack_require__("QmSG");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _mobx = __webpack_require__("d6px");
	
	var _reqwest = __webpack_require__("SHHR");
	
	var _reqwest2 = _interopRequireDefault(_reqwest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _initDefineProp(target, property, descriptor, context) {
	  if (!descriptor) return;
	  (0, _defineProperty2.default)(target, property, {
	    enumerable: descriptor.enumerable,
	    configurable: descriptor.configurable,
	    writable: descriptor.writable,
	    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
	  });
	}
	
	function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	  var desc = {};
	  Object['ke' + 'ys'](descriptor).forEach(function (key) {
	    desc[key] = descriptor[key];
	  });
	  desc.enumerable = !!desc.enumerable;
	  desc.configurable = !!desc.configurable;
	
	  if ('value' in desc || desc.initializer) {
	    desc.writable = true;
	  }
	
	  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
	    return decorator(target, property, desc) || desc;
	  }, desc);
	
	  if (context && desc.initializer !== void 0) {
	    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
	    desc.initializer = undefined;
	  }
	
	  if (desc.initializer === void 0) {
	    Object['define' + 'Property'](target, property, desc);
	    desc = null;
	  }
	
	  return desc;
	}
	
	function _initializerWarningHelper(descriptor, context) {
	  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	}
	
	var environments = {
	  LOCAL: 'LOCAL',
	  DEV: 'DEV',
	  STA: 'STA',
	  LIVE: 'LIVE',
	  DEVLIVE: 'DEVLIVE',
	  BETA: 'BETA'
	};
	
	/**
	 * API class - handels all api related stuff
	 */
	var API = (_class = function () {
	  function API() {
	    (0, _classCallCheck3.default)(this, API);
	
	    _initDefineProp(this, 'token', _descriptor, this);
	
	    this.mediahubId = '';
	
	    var env = this.getEnv();
	    this.mediahubId = _lodash2.default.isEqual(env, 'DEV') ? _config2.default.mediahubIdDev : _config2.default.mediahubId;
	  }
	
	  /**
	   * Set the token
	   */
	
	
	  API.prototype.setToken = function setToken() {
	    var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    this.token = 'token=' + token;
	  };
	
	  /**
	   * apiPath - establish correct api path
	   * @resource (String) - string indicating the resource
	   * @params (Object) - object containng other params
	   */
	
	
	  API.prototype.apiPath = function apiPath(resource, params) {
	    // Vars from params
	    var channelId = _lodash2.default.result(params, 'channelId', '');
	    var auth = _lodash2.default.result(params, 'auth');
	    var skip = _lodash2.default.result(params, 'skip');
	    var limit = _lodash2.default.result(params, 'limit', '100');
	    var directLink = _lodash2.default.result(params, 'directLink', '');
	    var language = 'en,de,silent';
	
	    switch (resource) {
	      case 'init':
	        return this.host() + '/v5/mediahub/' + this.mediahubId + '/config';
	      case 'config':
	        return this.host() + '/v5/mediahub/' + this.mediahubId + '/config';
	      case 'mediahub':
	        return this.host() + '/v5/mediahub/' + this.mediahubId + '/channels';
	      case 'channel':
	        return this.host() + '/v5/mediahub/' + this.mediahubId + '/' + channelId;
	      case 'search':
	        return this.host() + '/v5/mediahub/' + this.mediahubId + '/search';
	      case 'deliverItems':
	        return this.host() + '/v5/mediahub/' + this.mediahubId + '/deliverItems';
	      case 'deliverThumbs':
	        return this.host() + '/v5/mediahub/' + this.mediahubId + '/signedMediaUrls';
	      case 'directLink':
	        return this.host() + '/v5/mediahub/' + this.mediahubId + '/directLink?directLink=' + directLink;
	      // case 'feature':
	      //   return this.host() + '/v2/mediahub/' + this.mediahubId + '/' + channelId + '?audioLanguage=' + language;
	      // case 'player':
	      //   return this.host() + '/v2/mediacontainer/de/' + this.mediahubId;
	      // case 'downloadTracker':
	      //   return this.host('stats') + '/v2/downloads/tracker';
	      // case 'rating':
	      //   return this.host() + '/v2/rating';
	      default:
	        throw new Error('no valid resource!');
	    }
	  };
	
	  /**
	   * Method for getting variables form URL
	   */
	
	
	  API.prototype.getUrlVars = function getUrlVars() {
	    var vars = {};
	    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
	      vars[key] = value;
	    });
	    return vars;
	  };
	
	  API.prototype.getEnvFromHostname = function getEnvFromHostname(host) {
	    // turn this line on for developing, BUT don't forget to disable again after pushing:
	    // return environments.LIVE;
	
	    if (host.indexOf('dev-mediahub') > -1) {
	      return environments.DEV;
	    }
	    if (host.indexOf('tc-mh-3796-dev') > -1) {
	      return environments.LIVE;
	    }
	    if (host.indexOf('localhost') > -1) {
	      return environments.DEV;
	    }
	    return environments.LIVE;
	  };
	
	  /**
	   * Method for establishing environment
	   */
	
	
	  API.prototype.getEnv = function getEnv() {
	    return environments.LIVE;
	    var envFromUrl = this.getUrlVars().env && this.getUrlVars().env.toUpperCase();
	    var envFromHost = this.getEnvFromHostname(window.location.hostname);
	
	    var env = envFromUrl || envFromHost;
	    var envs = (0, _keys2.default)(environments);
	
	    if (envs.indexOf(env) < 0) {
	      alert(env + ' is not a valid environment! ' + env + ' has to be in ' + envs.toString());
	    }
	
	    return env;
	  };
	
	  /**
	   * Method for establishing host
	   * @name (String) - name of host, either 'api' (default) or 'stats'
	   */
	
	
	  API.prototype.host = function host(name) {
	    name = name || 'api';
	
	    var env = this.getEnv();
	    var hosts = {
	      api: {
	        LOCAL: '//apiobs.admiralcloud.com',
	        DEV: '//apidev.admiralcloud.com',
	        STA: '//apifra.admiralcloud.com',
	        LIVE: '//api.admiralcloud.com',
	        DEVLIVE: '//apiobs.admiralcloud.com',
	        BETA: '//betaapi.admiralcloud.com'
	      },
	      stats: {
	        LOCAL: '//localhost:3000',
	        DEV: '//statisticdev.admiralcloud.com',
	        STA: '//statisticdev.admiralcloud.com',
	        LIVE: '//statistic.admiralcloud.com',
	        BETA: '//statistic.admiralcloud.com'
	      }
	    };
	
	    var availableHosts = (0, _keys2.default)(hosts);
	    var chosenHost = availableHosts.indexOf(name) < 0 ? availableHosts[0] : name;
	
	    // We want to run on https
	    return 'https:' + hosts[chosenHost][env];
	  };
	
	  /**
	   * Wrapper for API requests
	   * @method    (String) - request method like get, post, etc...
	   * @resource  (String) - string indicating the resource
	   * @params    (Object) - object containng other params
	   */
	
	
	  API.prototype.apiRequest = function apiRequest(method, resource, params) {
	    var token = _lodash2.default.indexOf(['directLink'], resource) < 0 ? '?' + this.token : '&' + this.token;
	    var path = _config2.default.includeAuthToken ? this.apiPath(resource, params) + token : this.apiPath(resource, params);
	    var data = _lodash2.default.result(params, 'data');
	
	    var requestParams = {
	      method: method,
	      url: path,
	      type: 'json',
	      contentType: 'application/json',
	      crossOrigin: true
	    };
	
	    if (!!data) {
	      requestParams.data = (0, _stringify2.default)(data);
	    }
	
	    return (0, _reqwest2.default)(requestParams);
	  };
	
	  /**
	   * Method for GET api requests,
	   * only for convenience.
	   */
	
	
	  API.prototype.get = function get() {
	    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
	      params[_key] = arguments[_key];
	    }
	
	    return this.apiRequest.apply(this, ['get'].concat(params));
	  };
	
	  /**
	   * Method for POST api requests,
	   * only for convenience.
	   */
	
	
	  API.prototype.post = function post() {
	    for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      params[_key2] = arguments[_key2];
	    }
	
	    return this.apiRequest.apply(this, ['post'].concat(params));
	  };
	
	  return API;
	}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'token', [_mobx.observable], {
	  enumerable: true,
	  initializer: function initializer() {
	    return '';
	  }
	}), _applyDecoratedDescriptor(_class.prototype, 'setToken', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'setToken'), _class.prototype)), _class);
	
	
	var api = new API();
	exports.default = api;
	module.exports = exports['default'];

/***/ },

/***/ 1:
/***/ function(module, exports) {

	/* (ignored) */

/***/ },

/***/ "c/9r":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getMetaForMC = getMetaForMC;
	exports.getMetadata = getMetadata;
	exports.getDirectLink = getDirectLink;
	exports.getPreviewImage = getPreviewImage;
	exports.getLinkFromChannelTitle = getLinkFromChannelTitle;
	
	var _lodash = __webpack_require__("M4fF");
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * getMeta - helper function to get the proper metadata
	 *
	 * @param content (object) - the whole mediaContainer object
	 * @param field (string) - a field name such as 'container_name'
	 * @param language (string) - selected current language
	 *
	 * @return content (string)
	 */
	function getMetaForMC(content, field, language) {
	  return _lodash2.default.result(content, field + '_' + language) || _lodash2.default.result(content, '' + field);
	}
	
	/**
	 * getMeta - helper function to get the proper metadata
	 *
	 * @param metadata (array) - a metadata array with objects
	 * @param field (string) - a field name such as 'container_name'
	 * @param language (string) - selected current language
	 *
	 * @return content (string)
	 */
	function getMetadata(metadata, field, language) {
	  var meta = _lodash2.default.find(metadata, { title: field, language: language }) || _lodash2.default.find(metadata, { title: field, language: 'uni' }) || _lodash2.default.find(metadata, { title: field });
	  return _lodash2.default.result(meta, 'content', '');
	}
	
	/**
	 * getDirectLink - helper function to get the directLink
	 *
	 * @param directLinks (array) - a directLinks array with objects
	 * @param language (string) - selected current language
	 *
	 * @return url (string)
	 */
	function getDirectLink(directLinks, language) {
	  var link = _lodash2.default.find(directLinks, { language: language }) || _lodash2.default.find(directLinks, { language: 'uni' }) || _lodash2.default.head(directLinks);
	  return _lodash2.default.result(link, 'url', '');
	}
	
	/**
	 * getPreviewImage - helper function to get the proper preview image
	 *
	 * @param previewImages (array) - a previewImages array with objects
	 * @param width (number) - width of requested preview
	 *
	 * It looks for an image based on requested width/qualtiy or higher,
	 * than it looks for next best qualtiy image and than for the first
	 * from the previewImages array.
	 *
	 * @return signedUrl (string)
	 */
	function getPreviewImage(previewImages, width) {
	  var image = _lodash2.default.find(_lodash2.default.sortBy(previewImages, 'width'), function (image) {
	    return image.width >= width;
	  }) || _lodash2.default.find(_lodash2.default.reverse(_lodash2.default.sortBy(previewImages, 'width')), function (image) {
	    return image.width < width;
	  }) || _lodash2.default.head(_lodash2.default.sortBy(previewImages, 'width'));
	  return _lodash2.default.result(image, 'signedUrl', '');
	}
	
	/**
	 * getLinkFromChannelTitle - helper function to get a link to a channel
	 *
	 * @param title (string) - title of a channel
	 * @param language (string) - current UI language
	 *
	 * @return link (string)
	 */
	function getLinkFromChannelTitle(title) {
	  return _lodash2.default.kebabCase(_lodash2.default.deburr(_lodash2.default.toLower(title)));
	}

/***/ },

/***/ "9vrF":
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__("UvFP");
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _typeof2 = __webpack_require__("tyBi");
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*
	 Copyright (c) 2011-2012 Ternary Labs. All Rights Reserved.
	
	 Permission is hereby granted, free of charge, to any person obtaining a copy
	 of this software and associated documentation files (the "Software"), to deal
	 in the Software without restriction, including without limitation the rights
	 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 copies of the Software, and to permit persons to whom the Software is
	 furnished to do so, subject to the following conditions:
	
	 The above copyright notice and this permission notice shall be included in
	 all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 THE SOFTWARE.
	 */
	
	/*
	 # Websequencediagrams.com
	 participant abc.com
	 participant "iFrame proxy xyz.com"
	 participant "iFrame proxy abc.com"
	 participant "iFrame xyz.com"
	 abc.com->iFrame proxy xyz.com: postMessage(data, targetOrigin)
	 note left of "iFrame proxy xyz.com": Set url fragment and change size
	 iFrame proxy xyz.com->iFrame proxy xyz.com: onResize Event
	 note right of "iFrame proxy xyz.com": read url fragment
	 iFrame proxy xyz.com->iFrame xyz.com: forwardMessageEvent(event)
	 iFrame xyz.com->iFrame proxy abc.com: postMessage(data, targetOrigin)
	 note right of "iFrame proxy abc.com": Set url fragment and change size
	 iFrame proxy abc.com->iFrame proxy abc.com: onResize Event
	 note right of "iFrame proxy abc.com": read url fragment
	 iFrame proxy abc.com->abc.com: forwardMessageEvent(event)
	 */
	
	/* Simple JavaScript Inheritance
	 * By John Resig http://ejohn.org/
	 * MIT Licensed.
	 */
	// Inspired by base2 and Prototype
	(function (window) {
	  'use strict';
	
	  var initializing = false,
	      fnTest = /xyz/.test(function () {
	    xyz;
	  }) ? /\b_super\b/ : /.*/;
	
	  // The base Class implementation (does nothing)
	  var PortholeClass = function PortholeClass() {};
	
	  // Create a new Class that inherits from this class
	  PortholeClass.extend = function (prop) {
	    var _super = this.prototype;
	
	    // Instantiate a base class (but only create the instance,
	    // don't run the init constructor)
	    initializing = true;
	    var prototype = new this();
	    initializing = false;
	
	    // Copy the properties over onto the new prototype
	    for (var name in prop) {
	      // Check if we're overwriting an existing function
	      prototype[name] = typeof prop[name] == 'function' && typeof _super[name] == 'function' && fnTest.test(prop[name]) ? function (name, fn) {
	        return function () {
	          var tmp = this._super;
	
	          // Add a new ._super() method that is the same method
	          // but on the super-class
	          this._super = _super[name];
	
	          // The method only need to be bound temporarily, so we
	          // remove it when we're done executing
	          var ret = fn.apply(this, arguments);
	          this._super = tmp;
	
	          return ret;
	        };
	      }(name, prop[name]) : prop[name];
	    }
	
	    // The dummy class constructor
	    function Class() {
	      // All construction is actually done in the init method
	      if (!initializing && this.init) {
	        this.init.apply(this, arguments);
	      }
	    }
	
	    // Populate our constructed prototype object
	    Class.prototype = prototype;
	
	    // Enforce the constructor to be what we expect
	    Class.prototype.constructor = Class;
	
	    // And make this class extendable
	    Class.extend = PortholeClass.extend;
	
	    return Class;
	  };
	
	  /**
	   * @overview Porthole, JavaScript Library for Secure Cross Domain iFrame Communication.
	   * @author <a href="mailto:georges@ternarylabs.com">Georges Auberger</a>
	   * @copyright 2011-2012 Ternary Labs, All Rights Reserved.
	   *
	   * Namespace for Porthole
	   * @module Porthole
	   */
	  var Porthole = {
	    debug: false,
	
	    /**
	     * Utility function to trace to console
	     * @private
	     */
	    trace: function trace(s) {
	      if (this.debug && window.console !== undefined) {
	        window.console.log('Porthole: ' + s);
	      }
	    },
	
	    /**
	     * Utility function to send errors to console
	     * @private
	     */
	    error: function error(s) {
	      if ((0, _typeof3.default)(window.console) !== undefined && typeof window.console.error === 'function') {
	        window.console.error('Porthole: ' + s);
	      }
	    }
	  };
	
	  /**
	   * @class
	   * @classdesc Proxy window object to post message to target window
	   * @param {string} proxyIFrameUrl - Fully qualified url to proxy iframe, or null to create a receiver only window
	   * @param {string} targetWindowName - Name of the proxy iframe window
	   */
	  Porthole.WindowProxy = function () {};
	
	  Porthole.WindowProxy.prototype = {
	    /**
	     * Post a message to the target window only if the content comes from the target origin.
	     * <code>targetOrigin</code> can be a url or *
	     * @public
	     * @param {Object} data - Payload
	     * @param {String} targetOrigin
	     */
	    post: function post(data, targetOrigin) {},
	    /**
	     * Add an event listener to receive messages.
	     * @public
	     * @param {Function} eventListenerCallback
	     * @returns {Function} eventListenerCallback
	     */
	    addEventListener: function addEventListener(f) {},
	    /**
	     * Remove an event listener.
	     * @public
	     * @param {Function} eventListenerCallback
	     */
	    removeEventListener: function removeEventListener(f) {}
	  };
	
	  Porthole.WindowProxyBase = PortholeClass.extend({
	    init: function init(targetWindowName) {
	      if (targetWindowName === undefined) {
	        targetWindowName = '';
	      }
	      this.targetWindowName = targetWindowName;
	      this.origin = window.location.protocol + '//' + window.location.host;
	      this.eventListeners = [];
	    },
	
	    getTargetWindowName: function getTargetWindowName() {
	      return this.targetWindowName;
	    },
	
	    getOrigin: function getOrigin() {
	      return this.origin;
	    },
	
	    /**
	     * Lookup window object based on target window name
	     * @private
	     * @return {string} targetWindow
	     */
	    getTargetWindow: function getTargetWindow() {
	      return Porthole.WindowProxy.getTargetWindow(this.targetWindowName);
	    },
	
	    post: function post(data, targetOrigin) {
	      if (targetOrigin === undefined) {
	        targetOrigin = '*';
	      }
	      this.dispatchMessage({
	        'data': data,
	        'sourceOrigin': this.getOrigin(),
	        'targetOrigin': targetOrigin,
	        'sourceWindowName': window.name,
	        'targetWindowName': this.getTargetWindowName()
	      });
	    },
	
	    addEventListener: function addEventListener(f) {
	      this.eventListeners.push(f);
	      return f;
	    },
	
	    removeEventListener: function removeEventListener(f) {
	      var index;
	      try {
	        index = this.eventListeners.indexOf(f);
	        this.eventListeners.splice(index, 1);
	      } catch (e) {
	        this.eventListeners = [];
	      }
	    },
	
	    dispatchEvent: function dispatchEvent(event) {
	      var i;
	      for (i = 0; i < this.eventListeners.length; i++) {
	        try {
	          this.eventListeners[i](event);
	        } catch (e) {
	          Porthole.error(e);
	        }
	      }
	    }
	  });
	
	  /**
	   * Legacy browser implementation of proxy window object to post message to target window
	   *
	   * @private
	   * @constructor
	   * @param {string} proxyIFrameUrl - Fully qualified url to proxy iframe
	   * @param {string} targetWindowName - Name of the proxy iframe window
	   */
	  Porthole.WindowProxyLegacy = Porthole.WindowProxyBase.extend({
	    init: function init(proxyIFrameUrl, targetWindowName) {
	      this._super(targetWindowName);
	
	      if (proxyIFrameUrl !== null) {
	        this.proxyIFrameName = this.targetWindowName + 'ProxyIFrame';
	        this.proxyIFrameLocation = proxyIFrameUrl;
	
	        // Create the proxy iFrame and add to dom
	        this.proxyIFrameElement = this.createIFrameProxy();
	      } else {
	        // Won't be able to send messages
	        this.proxyIFrameElement = null;
	        Porthole.trace('proxyIFrameUrl is null, window will be a receiver only');
	        this.post = function () {
	          throw new Error('Receiver only window');
	        };
	      }
	    },
	
	    /**
	     * Create an iframe and load the proxy
	     *
	     * @private
	     * @returns iframe
	     */
	    createIFrameProxy: function createIFrameProxy() {
	      var iframe = document.createElement('iframe');
	
	      iframe.setAttribute('id', this.proxyIFrameName);
	      iframe.setAttribute('name', this.proxyIFrameName);
	      iframe.setAttribute('src', this.proxyIFrameLocation);
	      // IE needs this otherwise resize event is not fired
	      iframe.setAttribute('frameBorder', '1');
	      iframe.setAttribute('scrolling', 'auto');
	      // Need a certain size otherwise IE7 does not fire resize event
	      iframe.setAttribute('width', 30);
	      iframe.setAttribute('height', 30);
	      iframe.setAttribute('style', 'position: absolute; left: -100px; top:0px;');
	      // IE needs this because setting style attribute is broken. No really.
	      if (iframe.style.setAttribute) {
	        iframe.style.setAttribute('cssText', 'position: absolute; left: -100px; top:0px;');
	      }
	      document.body.appendChild(iframe);
	      return iframe;
	    },
	
	    dispatchMessage: function dispatchMessage(message) {
	      var encode = window.encodeURIComponent;
	
	      if (this.proxyIFrameElement) {
	        var src = this.proxyIFrameLocation + '#' + encode(Porthole.WindowProxy.serialize(message));
	        this.proxyIFrameElement.setAttribute('src', src);
	        this.proxyIFrameElement.height = this.proxyIFrameElement.height > 50 ? 50 : 100;
	      }
	    }
	  });
	
	  /**
	   * Implementation for modern browsers that supports it
	   */
	  Porthole.WindowProxyHTML5 = Porthole.WindowProxyBase.extend({
	    init: function init(proxyIFrameUrl, targetWindowName) {
	      this._super(targetWindowName);
	      this.eventListenerCallback = null;
	    },
	
	    dispatchMessage: function dispatchMessage(message) {
	      this.getTargetWindow().postMessage(Porthole.WindowProxy.serialize(message), message.targetOrigin);
	    },
	
	    addEventListener: function addEventListener(f) {
	      if (this.eventListeners.length === 0) {
	        var self = this;
	        if (window.addEventListener) {
	          this.eventListenerCallback = function (event) {
	            self.eventListener(self, event);
	          };
	          window.addEventListener('message', this.eventListenerCallback, false);
	        } else {
	          if (window.attachEvent) {
	            // Make IE8 happy, just not that 1. postMessage only works for IFRAMES/FRAMES http://blogs.msdn.com/b/ieinternals/archive/2009/09/16/bugs-in-ie8-support-for-html5-postmessage-sessionstorage-and-localstorage.aspx
	            this.eventListenerCallback = function (event) {
	              self.eventListener(self, window.event);
	            };
	            window.attachEvent('onmessage', this.eventListenerCallback);
	          }
	        }
	      }
	      return this._super(f);
	    },
	
	    removeEventListener: function removeEventListener(f) {
	      this._super(f);
	
	      if (this.eventListeners.length === 0) {
	        if (window.removeEventListener) {
	          window.removeEventListener('message', this.eventListenerCallback);
	        } else {
	          if (window.detachEvent) {
	            // Make IE8, happy, see above
	            // see jquery, detachEvent needed property on element, by name of that event, to properly expose it to GC
	            if (typeof window.onmessage === 'undefined') {
	              window.onmessage = null;
	            }
	            window.detachEvent('onmessage', this.eventListenerCallback);
	          }
	        }
	        this.eventListenerCallback = null;
	      }
	    },
	
	    eventListener: function eventListener(self, nativeEvent) {
	      var data = Porthole.WindowProxy.unserialize(nativeEvent.data);
	      if (data && (self.targetWindowName === '' || data.sourceWindowName == self.targetWindowName)) {
	        self.dispatchEvent(new Porthole.MessageEvent(data.data, nativeEvent.origin, self));
	      }
	    }
	  });
	
	  if (!window.postMessage) {
	    Porthole.trace('Using legacy browser support');
	    Porthole.WindowProxy = Porthole.WindowProxyLegacy.extend({});
	  } else {
	    Porthole.trace('Using built-in browser support');
	    Porthole.WindowProxy = Porthole.WindowProxyHTML5.extend({});
	  }
	
	  /**
	   * Serialize an object using JSON.stringify
	   *
	   * @param {Object} obj The object to be serialized
	   * @return {String}
	   */
	  Porthole.WindowProxy.serialize = function (obj) {
	    if (typeof JSON === 'undefined') {
	      throw new Error('Porthole serialization depends on JSON!');
	    }
	
	    return (0, _stringify2.default)(obj);
	  };
	
	  /**
	   * Unserialize using JSON.parse
	   *
	   * @param {String} text Serialization
	   * @return {Object}
	   */
	  Porthole.WindowProxy.unserialize = function (text) {
	    if (typeof JSON === 'undefined') {
	      throw new Error('Porthole unserialization dependens on JSON!');
	    }
	    try {
	      var json = JSON.parse(text);
	    } catch (e) {
	      return false;
	    }
	    return json;
	  };
	
	  Porthole.WindowProxy.getTargetWindow = function (targetWindowName) {
	    if (targetWindowName === '') {
	      return parent;
	    } else {
	      if (targetWindowName === 'top' || targetWindowName === 'parent') {
	        return window[targetWindowName];
	      }
	    }
	    return window.frames[targetWindowName];
	  };
	
	  /**
	   * @classdesc Event object to be passed to registered event handlers
	   * @class
	   * @param {String} data
	   * @param {String} origin - url of window sending the message
	   * @param {Object} source - window object sending the message
	   */
	  Porthole.MessageEvent = function MessageEvent(data, origin, source) {
	    this.data = data;
	    this.origin = origin;
	    this.source = source;
	  };
	
	  /**
	   * @classdesc Dispatcher object to relay messages.
	   * @public
	   * @constructor
	   */
	  Porthole.WindowProxyDispatcher = {
	    /**
	     * Forward a message event to the target window
	     * @private
	     */
	    forwardMessageEvent: function forwardMessageEvent(e) {
	      var message,
	          decode = window.decodeURIComponent,
	          targetWindow,
	          windowProxy;
	
	      if (document.location.hash.length > 0) {
	        // Eat the hash character
	        message = Porthole.WindowProxy.unserialize(decode(document.location.hash.substr(1)));
	
	        targetWindow = Porthole.WindowProxy.getTargetWindow(message.targetWindowName);
	
	        windowProxy = Porthole.WindowProxyDispatcher.findWindowProxyObjectInWindow(targetWindow, message.sourceWindowName);
	
	        if (windowProxy) {
	          if (windowProxy.origin === message.targetOrigin || message.targetOrigin === '*') {
	            windowProxy.dispatchEvent(new Porthole.MessageEvent(message.data, message.sourceOrigin, windowProxy));
	          } else {
	            Porthole.error('Target origin ' + windowProxy.origin + ' does not match desired target of ' + message.targetOrigin);
	          }
	        } else {
	          Porthole.error('Could not find window proxy object on the target window');
	        }
	      }
	    },
	
	    /**
	     * Look for a window proxy object in the target window
	     * @private
	     */
	    findWindowProxyObjectInWindow: function findWindowProxyObjectInWindow(w, sourceWindowName) {
	      var i;
	
	      if (w) {
	        for (i in w) {
	          if (Object.prototype.hasOwnProperty.call(w, i)) {
	            try {
	              // Ensure that we're finding the proxy object
	              // that is declared to be targetting the window that is calling us
	              if (w[i] !== null && (0, _typeof3.default)(w[i]) === 'object' && w[i] instanceof w.Porthole.WindowProxy && w[i].getTargetWindowName() === sourceWindowName) {
	                return w[i];
	              }
	            } catch (e) {
	              // Swallow exception in case we access an object we shouldn't
	            }
	          }
	        }
	      }
	      return null;
	    },
	
	    /**
	     * Start a proxy to relay messages.
	     * @public
	     */
	    start: function start() {
	      if (window.addEventListener) {
	        window.addEventListener('resize', Porthole.WindowProxyDispatcher.forwardMessageEvent, false);
	      } else {
	        if (window.attachEvent && window.postMessage !== 'undefined') {
	          window.attachEvent('onresize', Porthole.WindowProxyDispatcher.forwardMessageEvent);
	        } else {
	          if (document.body.attachEvent) {
	            window.attachEvent('onresize', Porthole.WindowProxyDispatcher.forwardMessageEvent);
	          } else {
	            // Should never happen
	            Porthole.error('Cannot attach resize event');
	          }
	        }
	      }
	    }
	  };
	
	  // Support testing in node.js:
	  if (true) {
	    module.exports = Porthole;
	  } else {
	    window.Porthole = Porthole;
	  }
	})(typeof window !== "undefined" ? window : undefined);

/***/ },

/***/ 2:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./de": "DOkx",
		"./fr": "tzHd",
		"./pl": "7LV+"
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2;


/***/ }

});


// WEBPACK FOOTER //
// app.8800a0d4.js